var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo267(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_267",
    "data-name": "Grupo 267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.178,
    height: 727.452,
    viewBox: "0 0 710.178 727.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_90",
    "data-name": "Ret\\xE2ngulo 90",
    width: 710.178,
    height: 727.452,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_33",
    "data-name": "Ret\\xE2ngulo 33",
    width: 191.529,
    height: 67.497,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_34",
    "data-name": "Ret\\xE2ngulo 34",
    width: 31.735,
    height: 37.61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_39",
    "data-name": "Ret\\xE2ngulo 39",
    width: 23.293,
    height: 22.708,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    width: 23.293,
    height: 13.743,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_36",
    "data-name": "Ret\\xE2ngulo 36",
    width: 23.293,
    height: 13.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_40",
    "data-name": "Ret\\xE2ngulo 40",
    width: 187.717,
    height: 108.327,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_41",
    "data-name": "Ret\\xE2ngulo 41",
    width: 191.528,
    height: 67.497,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_47",
    "data-name": "Ret\\xE2ngulo 47",
    width: 23.294,
    height: 22.708,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_43",
    "data-name": "Ret\\xE2ngulo 43",
    width: 23.294,
    height: 13.743,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_44",
    "data-name": "Ret\\xE2ngulo 44",
    width: 23.294,
    height: 13.742,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_48",
    "data-name": "Ret\\xE2ngulo 48",
    width: 171.341,
    height: 98.484,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_49",
    "data-name": "Ret\\xE2ngulo 49",
    width: 89.122,
    height: 53.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_50",
    "data-name": "Ret\\xE2ngulo 50",
    width: 157.647,
    height: 90.612,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_51",
    "data-name": "Ret\\xE2ngulo 51",
    width: 69.117,
    height: 40.844,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_52",
    "data-name": "Ret\\xE2ngulo 52",
    width: 90.2,
    height: 73.207,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_53",
    "data-name": "Ret\\xE2ngulo 53",
    width: 11.639,
    height: 19.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_55",
    "data-name": "Ret\\xE2ngulo 55",
    width: 68.717,
    height: 48.697,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_56",
    "data-name": "Ret\\xE2ngulo 56",
    width: 2.133,
    height: 22.34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_57",
    "data-name": "Ret\\xE2ngulo 57",
    width: 156.791,
    height: 95.587,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_58",
    "data-name": "Ret\\xE2ngulo 58",
    width: 156.791,
    height: 95.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_59",
    "data-name": "Ret\\xE2ngulo 59",
    width: 10.417,
    height: 14.427,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_60",
    "data-name": "Ret\\xE2ngulo 60",
    width: 67.119,
    height: 38.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_61",
    "data-name": "Ret\\xE2ngulo 61",
    width: 90.2,
    height: 73.205,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_62",
    "data-name": "Ret\\xE2ngulo 62",
    width: 2.147,
    height: 22.34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_63",
    "data-name": "Ret\\xE2ngulo 63",
    width: 16.515,
    height: 14.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_64",
    "data-name": "Ret\\xE2ngulo 64",
    width: 134.247,
    height: 98.711,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_65",
    "data-name": "Ret\\xE2ngulo 65",
    width: 261.379,
    height: 169.771,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_66",
    "data-name": "Ret\\xE2ngulo 66",
    width: 401.664,
    height: 250.611,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_67",
    "data-name": "Ret\\xE2ngulo 67",
    width: 249.397,
    height: 144.004,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_68",
    "data-name": "Ret\\xE2ngulo 68",
    width: 214.623,
    height: 123.951,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_69",
    "data-name": "Ret\\xE2ngulo 69",
    width: 73.547,
    height: 42.748,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_70",
    "data-name": "Ret\\xE2ngulo 70",
    width: 6.746,
    height: 5.852,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_71",
    "data-name": "Ret\\xE2ngulo 71",
    width: 1.716,
    height: 2.216,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_72",
    "data-name": "Ret\\xE2ngulo 72",
    width: 8.803,
    height: 8.507,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_73",
    "data-name": "Ret\\xE2ngulo 73",
    width: 4.802,
    height: 6.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_74",
    "data-name": "Ret\\xE2ngulo 74",
    width: 213.697,
    height: 123.379,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_75",
    "data-name": "Ret\\xE2ngulo 75",
    width: 6.588,
    height: 5.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_76",
    "data-name": "Ret\\xE2ngulo 76",
    width: 6.586,
    height: 5.387,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_81",
    "data-name": "Ret\\xE2ngulo 81",
    width: 6.586,
    height: 5.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_83",
    "data-name": "Ret\\xE2ngulo 83",
    width: 6.588,
    height: 5.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_85",
    "data-name": "Ret\\xE2ngulo 85",
    width: 59.781,
    height: 34.515,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_86",
    "data-name": "Ret\\xE2ngulo 86",
    width: 3.883,
    height: 18.884,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_87",
    "data-name": "Ret\\xE2ngulo 87",
    width: 8.559,
    height: 27.939,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_88",
    "data-name": "Ret\\xE2ngulo 88",
    width: 6.114,
    height: 25.334,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_266",
    "data-name": "Grupo 266",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_415",
    "data-name": "Caminho 415",
    d: "M22.924,452.147l271.75,156.9L697.817,376.493l-271.75-156.9Z",
    transform: "translate(12.36 118.403)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_416",
    "data-name": "Caminho 416",
    d: "M254.273,301.365V239.5l-80.361-46.4v61.863Z",
    transform: "translate(93.771 104.12)",
    fill: "#ceebf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_417",
    "data-name": "Caminho 417",
    d: "M226.121,245.7l111.166-64.1v61.863l-111.166,64.1Z",
    transform: "translate(121.923 97.92)",
    fill: "#c5e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_418",
    "data-name": "Caminho 418",
    d: "M255.107,262.93l-82.742-47.793,113.546-65.483,82.744,47.793Z",
    transform: "translate(92.937 80.691)",
    fill: "#d7f5fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_419",
    "data-name": "Caminho 419",
    d: "M255.107,239.991v15.466l-82.742-47.772V192.2Z",
    transform: "translate(92.937 103.631)",
    fill: "#ceebf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_420",
    "data-name": "Caminho 420",
    d: "M339.669,180.7,226.121,246.187v15.466l113.548-65.471Z",
    transform: "translate(121.922 97.434)",
    fill: "#c5e1e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_265",
    "data-name": "Grupo 265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    "data-name": "Grupo 264",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98",
    transform: "translate(267.682 294.992)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_97",
    "data-name": "Grupo 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_96",
    "data-name": "Grupo 96",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_421",
    "data-name": "Caminho 421",
    d: "M173.911,209.352l0,3.4,80.361,46.4v-3.4Zm191.529-17.7-111.166,64.1,0,3.4,111.163-64.1Z",
    transform: "translate(-173.911 -191.654)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_422",
    "data-name": "Caminho 422",
    d: "M219.3,235.01,191.85,219.161c-1.184-.68-2.143-.129-2.143,1.238v16.231a4.732,4.732,0,0,0,2.143,3.709L219.3,256.188c1.184.683,2.143.129,2.143-1.238V238.72a4.736,4.736,0,0,0-2.143-3.709",
    transform: "translate(102.288 118.012)",
    fill: "#c0dbe0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_101",
    "data-name": "Grupo 101",
    transform: "translate(291.995 336.883)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_99",
    "data-name": "Grupo 99",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_423",
    "data-name": "Caminho 423",
    d: "M219.3,235.01,191.85,219.161c-1.184-.68-2.143-.129-2.143,1.238v16.231a4.732,4.732,0,0,0,2.143,3.709L219.3,256.188c1.184.683,2.143.129,2.143-1.238V238.72a4.736,4.736,0,0,0-2.143-3.709",
    transform: "translate(-189.707 -218.87)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M216.675,235.462l-23.933-13.819c-.79-.454-1.428-.086-1.428.825v12.169a3.151,3.151,0,0,0,1.428,2.472l23.933,13.817c.788.456,1.428.086,1.428-.823l0-12.169a3.156,3.156,0,0,0-1.427-2.472",
    transform: "translate(103.155 119.403)",
    fill: "#d2f0f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_116",
    "data-name": "Grupo 116",
    transform: "translate(296.217 344.334)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_115",
    "data-name": "Grupo 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_114",
    "data-name": "Grupo 114",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_104",
    "data-name": "Grupo 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_103",
    "data-name": "Grupo 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_102",
    "data-name": "Grupo 102",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_425",
    "data-name": "Caminho 425",
    d: "M215.4,237.454a.348.348,0,0,0,.174-.65l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.048a.359.359,0,0,0,.174.046",
    transform: "translate(-192.45 -223.711)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_107",
    "data-name": "Grupo 107",
    transform: "translate(0 2.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_106",
    "data-name": "Grupo 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_105",
    "data-name": "Grupo 105",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_426",
    "data-name": "Caminho 426",
    d: "M215.4,239.4a.348.348,0,0,0,.174-.649l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.046a.344.344,0,0,0,.174.048",
    transform: "translate(-192.45 -225.653)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_110",
    "data-name": "Grupo 110",
    transform: "translate(0 5.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_109",
    "data-name": "Grupo 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_108",
    "data-name": "Grupo 108",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_427",
    "data-name": "Caminho 427",
    d: "M215.4,241.336a.348.348,0,0,0,.174-.65l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.046a.344.344,0,0,0,.174.048",
    transform: "translate(-192.45 -227.594)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_113",
    "data-name": "Grupo 113",
    transform: "translate(0 8.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_112",
    "data-name": "Grupo 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_111",
    "data-name": "Grupo 111",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_428",
    "data-name": "Caminho 428",
    d: "M215.4,243.278a.348.348,0,0,0,.174-.65l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.046a.345.345,0,0,0,.174.048",
    transform: "translate(-192.45 -229.535)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119",
    transform: "translate(267.276 230.344)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_429",
    "data-name": "Caminho 429",
    d: "M361.364,193.635,249.789,257.979,173.647,214l111.571-64.346Z",
    transform: "translate(-173.647 -149.653)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_430",
    "data-name": "Caminho 430",
    d: "M250.826,254.783V192.92l-80.363-46.4v61.863Z",
    transform: "translate(91.912 79.003)",
    fill: "#b6ccf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_431",
    "data-name": "Caminho 431",
    d: "M222.674,199.12l111.166-64.1v61.863l-111.166,64.1Z",
    transform: "translate(120.064 72.803)",
    fill: "#aec3e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_432",
    "data-name": "Caminho 432",
    d: "M251.659,216.348l-82.742-47.793,113.546-65.483,82.744,47.793Z",
    transform: "translate(91.078 55.575)",
    fill: "#bdd4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    "data-name": "Caminho 433",
    d: "M251.659,193.409v15.466L168.917,161.1V145.615Z",
    transform: "translate(91.078 78.514)",
    fill: "#b6ccf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M336.222,134.122,222.674,199.605v15.467L336.222,149.6Z",
    transform: "translate(120.064 72.317)",
    fill: "#aec3e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122",
    transform: "translate(262.376 223.293)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_435",
    "data-name": "Caminho 435",
    d: "M170.464,162.771v3.4l80.361,46.4v-3.4Zm191.528-17.7-111.166,64.1,0,3.4,111.163-64.1Z",
    transform: "translate(-170.464 -145.072)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    "data-name": "Caminho 436",
    d: "M215.852,188.43,188.4,172.581c-1.184-.683-2.141-.129-2.141,1.236v16.232a4.733,4.733,0,0,0,2.141,3.709l27.451,15.847c1.184.683,2.143.129,2.143-1.236V192.139a4.732,4.732,0,0,0-2.143-3.709",
    transform: "translate(100.43 92.896)",
    fill: "#a9bee0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125",
    transform: "translate(286.69 265.184)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    "data-name": "Caminho 437",
    d: "M215.852,188.43,188.4,172.581c-1.184-.683-2.141-.129-2.141,1.236v16.232a4.733,4.733,0,0,0,2.141,3.709l27.451,15.847c1.184.683,2.143.129,2.143-1.236V192.139a4.732,4.732,0,0,0-2.143-3.709",
    transform: "translate(-186.26 -172.288)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_438",
    "data-name": "Caminho 438",
    d: "M213.228,188.879,189.294,175.06c-.79-.454-1.427-.086-1.427.825v12.169a3.155,3.155,0,0,0,1.427,2.474l23.934,13.816c.788.456,1.427.088,1.427-.823V191.352a3.161,3.161,0,0,0-1.427-2.473",
    transform: "translate(101.296 94.286)",
    fill: "#b9d0f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_140",
    "data-name": "Grupo 140",
    transform: "translate(290.91 272.635)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_139",
    "data-name": "Grupo 139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_138",
    "data-name": "Grupo 138",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_439",
    "data-name": "Caminho 439",
    d: "M211.948,190.872a.348.348,0,0,0,.174-.65l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.048a.354.354,0,0,0,.174.046",
    transform: "translate(-189.002 -177.129)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_131",
    "data-name": "Grupo 131",
    transform: "translate(0 2.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_440",
    "data-name": "Caminho 440",
    d: "M211.948,192.813a.348.348,0,0,0,.174-.65l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.046a.34.34,0,0,0,.174.048",
    transform: "translate(-189.002 -179.071)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_134",
    "data-name": "Grupo 134",
    transform: "translate(0 5.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_133",
    "data-name": "Grupo 133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_132",
    "data-name": "Grupo 132",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_441",
    "data-name": "Caminho 441",
    d: "M211.948,194.754a.348.348,0,0,0,.174-.65l-22.6-13.046a.348.348,0,1,0-.348.6l22.6,13.046a.341.341,0,0,0,.174.048",
    transform: "translate(-189.002 -181.012)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_137",
    "data-name": "Grupo 137",
    transform: "translate(0 8.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_136",
    "data-name": "Grupo 136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_135",
    "data-name": "Grupo 135",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_442",
    "data-name": "Caminho 442",
    d: "M211.948,196.7a.348.348,0,0,0,.174-.65L189.524,183a.348.348,0,0,0-.348.6l22.6,13.046a.341.341,0,0,0,.174.048",
    transform: "translate(-189.002 -182.953)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143",
    transform: "translate(271.693 162.261)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_443",
    "data-name": "Caminho 443",
    d: "M176.517,160.541l75.513,43.134a1.606,1.606,0,0,0,.862.228,1.625,1.625,0,0,0,.882-.2l93.7-54.093a.573.573,0,0,0,.054-1.059l-75.56-43.134Z",
    transform: "translate(-176.517 -105.419)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_444",
    "data-name": "Caminho 444",
    d: "M339.362,147.476a1.8,1.8,0,0,1-.846,1.294l-87.481,50.475a1.633,1.633,0,0,1-1.559-.029L181.21,160.233l.085-1.656,89.059-51.42,68.294,39a1.669,1.669,0,0,1,.714,1.324",
    transform: "translate(97.707 57.778)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(347.951 203.926)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_445",
    "data-name": "Caminho 445",
    d: "M226.145,184.112l-.085,1.65a1.737,1.737,0,0,0,.8-.177l87.469-50.467a1.845,1.845,0,0,0,.854-1.3,1.7,1.7,0,0,0-.72-1.328.517.517,0,0,1-.049.956l-87.471,50.49a1.469,1.469,0,0,1-.8.177",
    transform: "translate(-226.061 -132.489)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149",
    transform: "translate(279.001 164.937)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_446",
    "data-name": "Caminho 446",
    d: "M181.265,158.576l68.255,38.988a1.439,1.439,0,0,0,.777.206,1.474,1.474,0,0,0,.8-.177l87.471-50.49a.518.518,0,0,0,.048-.956l-68.3-38.989Z",
    transform: "translate(-181.265 -107.158)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152",
    transform: "translate(278.917 216.355)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_447",
    "data-name": "Caminho 447",
    d: "M181.295,140.564l-.085,1.656L249.465,181.2a1.467,1.467,0,0,0,.779.2l.083-1.65a1.439,1.439,0,0,1-.777-.206Z",
    transform: "translate(-181.21 -140.564)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_448",
    "data-name": "Caminho 448",
    d: "M181.936,166.65l89.09-51.4,1.11-21.8-89.1,51.655Z",
    transform: "translate(98.098 50.385)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155",
    transform: "translate(280.034 143.828)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_449",
    "data-name": "Caminho 449",
    d: "M181.936,166.65l89.09-51.4,1.11-21.8-89.1,51.655Z",
    transform: "translate(-181.936 -93.444)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_450",
    "data-name": "Caminho 450",
    d: "M335.281,138.08a2.235,2.235,0,0,1,.883,1.81l-.225,4.413a2.413,2.413,0,0,1-1.067,1.775l-87.08,50.242a2.04,2.04,0,0,1-1.949-.035l-57.753-35.261.346-6.8L277.5,102.8Z",
    transform: "translate(101.417 55.43)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_451",
    "data-name": "Caminho 451",
    d: "M277.377,102.8l57.783,35.278a.645.645,0,0,1-.062,1.194L248.02,189.517a2.047,2.047,0,0,1-1.95-.035l-57.753-35.263Z",
    transform: "translate(101.538 55.43)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_452",
    "data-name": "Caminho 452",
    d: "M194.061,137.171a2.268,2.268,0,0,1-.674.231,1.9,1.9,0,0,1-1.054-.043.814.814,0,0,1-.325-.137c-.522-.317-.431-.888.209-1.25a2.286,2.286,0,0,1,.945-.269,1.812,1.812,0,0,1,1.107.219.187.187,0,0,1,.1.089c.4.337.291.82-.306,1.161",
    transform: "translate(103.346 73.165)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_453",
    "data-name": "Caminho 453",
    d: "M226.581,177.3l-.346,6.816a1.967,1.967,0,0,0,1-.222l87.075-50.235a2.424,2.424,0,0,0,1.057-1.776l.226-4.424a2.272,2.272,0,0,0-.662-1.615c.277.317.189.722-.276,1l-87.075,50.235a1.745,1.745,0,0,1-1,.22",
    transform: "translate(121.984 67.855)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_454",
    "data-name": "Caminho 454",
    d: "M187.66,130.562a3.679,3.679,0,0,1,4.019.323c2.36,1.538,4.285,5.013,5.07,8.766-.482.066-1.076.145-1.341.186-.736-3.331-2.429-6.429-4.453-7.748a3.26,3.26,0,0,0-1.648-.582,1.9,1.9,0,0,0-1.03.274c-1.1.656-1.787,2.452-1.841,4.8-.1,4.519,2.07,9.669,4.848,11.479a2.957,2.957,0,0,0,1.979.562l1.407.91c-.031.02-.06.038-.091.055a3.18,3.18,0,0,1-1.715.459,4.383,4.383,0,0,1-2.3-.78c-3.171-2.067-5.564-7.631-5.449-12.666.066-2.911,1-5.113,2.547-6.04",
    transform: "translate(99.809 70.151)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158",
    transform: "translate(284.918 200.256)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_455",
    "data-name": "Caminho 455",
    d: "M187.66,130.562a3.679,3.679,0,0,1,4.019.323c2.36,1.538,4.285,5.013,5.07,8.766-.482.066-1.076.145-1.341.186-.736-3.331-2.429-6.429-4.453-7.748a3.26,3.26,0,0,0-1.648-.582,1.9,1.9,0,0,0-1.03.274c-1.1.656-1.787,2.452-1.841,4.8-.1,4.519,2.07,9.669,4.848,11.479a2.957,2.957,0,0,0,1.979.562l1.407.91c-.031.02-.06.038-.091.055a3.18,3.18,0,0,1-1.715.459,4.383,4.383,0,0,1-2.3-.78c-3.171-2.067-5.564-7.631-5.449-12.666.066-2.911,1-5.113,2.547-6.04",
    transform: "translate(-185.109 -130.105)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_456",
    "data-name": "Caminho 456",
    d: "M339.68,141.233a1.811,1.811,0,0,1-.847,1.3L251.352,193a1.633,1.633,0,0,1-1.559-.029l-67.864-46.836.083-1.656L271.07,93.062l67.9,46.847a1.666,1.666,0,0,1,.714,1.324",
    transform: "translate(98.094 50.178)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161",
    "data-name": "Grupo 161",
    transform: "translate(348.656 190.082)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160",
    "data-name": "Grupo 160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_457",
    "data-name": "Caminho 457",
    d: "M226.6,175.118l-.085,1.65a1.709,1.709,0,0,0,.8-.177l87.469-50.465a1.844,1.844,0,0,0,.854-1.3,1.7,1.7,0,0,0-.72-1.33.517.517,0,0,1-.049.956L227.4,174.941a1.456,1.456,0,0,1-.8.177",
    transform: "translate(-226.519 -123.495)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_458",
    "data-name": "Caminho 458",
    d: "M181.982,144.48l67.857,46.841a1.444,1.444,0,0,0,.777.2,1.468,1.468,0,0,0,.8-.175l87.472-50.492a.518.518,0,0,0,.048-.956l-67.9-46.841Z",
    transform: "translate(98.123 50.178)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164",
    "data-name": "Grupo 164",
    transform: "translate(280.022 194.658)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163",
    "data-name": "Grupo 163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162",
    "data-name": "Grupo 162",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_459",
    "data-name": "Caminho 459",
    d: "M182.012,126.468l-.085,1.656,67.857,46.834a1.463,1.463,0,0,0,.777.206l.085-1.652a1.444,1.444,0,0,1-.777-.2Z",
    transform: "translate(-181.928 -126.468)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_460",
    "data-name": "Caminho 460",
    d: "M181.265,148.152l1.1-21.66,1.031.79-1.1,21.55Z",
    transform: "translate(97.736 68.203)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167",
    transform: "translate(279.001 194.695)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166",
    "data-name": "Grupo 166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165",
    "data-name": "Grupo 165",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_461",
    "data-name": "Caminho 461",
    d: "M181.265,148.152l1.1-21.66,1.031.79-1.1,21.55Z",
    transform: "translate(-181.265 -126.492)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_462",
    "data-name": "Caminho 462",
    d: "M183.88,144.467a1.288,1.288,0,0,1-.686-1.11c.019-.4.086-1.692.086-1.692l86.076-48.682a3.753,3.753,0,0,1,3.585.066l67.043,43.7-89.09,51.4Z",
    transform: "translate(98.775 49.908)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170",
    transform: "translate(281.967 142.469)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_463",
    "data-name": "Caminho 463",
    d: "M183.88,144.467a1.288,1.288,0,0,1-.686-1.11c.019-.4.086-1.692.086-1.692l86.076-48.682a3.753,3.753,0,0,1,3.585.066l67.043,43.7-89.09,51.4Z",
    transform: "translate(-183.192 -92.561)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_464",
    "data-name": "Caminho 464",
    d: "M183.935,143.4a1.187,1.187,0,0,1,.112-2.2l85.363-49.285a3.75,3.75,0,0,1,3.583.065l67.044,43.7-89.09,51.4Z",
    transform: "translate(98.805 49.33)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_173",
    "data-name": "Grupo 173",
    transform: "translate(282.052 140.819)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_172",
    "data-name": "Grupo 172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_171",
    "data-name": "Grupo 171",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_465",
    "data-name": "Caminho 465",
    d: "M183.935,143.4a1.187,1.187,0,0,1,.112-2.2l85.363-49.285a3.75,3.75,0,0,1,3.583.065l67.044,43.7-89.09,51.4Z",
    transform: "translate(-183.247 -91.489)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_466",
    "data-name": "Caminho 466",
    d: "M323.948,124.3,274.312,91.965a3.758,3.758,0,0,0-3.585-.063L191.47,137.66l-6.454-4.244-.426,8.384.12.082a1.136,1.136,0,0,0,.542,1.5L242.1,180.416l89.091-51.4.466-9.161Z",
    transform: "translate(99.529 49.324)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_467",
    "data-name": "Caminho 467",
    d: "M185.563,137.432a1.187,1.187,0,0,1,.112-2.2l85.363-49.283a3.753,3.753,0,0,1,3.585.063L331.5,123.065l-89.09,51.4Z",
    transform: "translate(99.683 46.115)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_468",
    "data-name": "Caminho 468",
    d: "M222.417,161.316l-.466,9.16,89.09-51.4.466-9.16Z",
    transform: "translate(119.674 59.265)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_469",
    "data-name": "Caminho 469",
    d: "M223.827,141.516a2.265,2.265,0,0,1-.674.229,1.9,1.9,0,0,1-1.054-.04.864.864,0,0,1-.325-.139c-.522-.317-.431-.888.209-1.25a2.256,2.256,0,0,1,.947-.269,1.8,1.8,0,0,1,1.105.219.2.2,0,0,1,.1.089c.4.337.289.819-.308,1.161",
    transform: "translate(119.396 75.507)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_470",
    "data-name": "Caminho 470",
    d: "M227.79,140.082a4.678,4.678,0,0,0-2.464-.836,3.246,3.246,0,0,0-2.629,1.228,4.184,4.184,0,0,0-.831,1.658,1.9,1.9,0,0,0,1.054.04,2.629,2.629,0,0,1,.982-1.39c.84-.645,2.039-.6,3.323.235a10.2,10.2,0,0,1,4.013,8.236c-.152,2.989-2.161,4.185-4.528,2.691l-1.045.6a4.984,4.984,0,0,0,.44.294,4.619,4.619,0,0,0,2.443.836h.022a3.24,3.24,0,0,0,2.63-1.25,5.294,5.294,0,0,0,1.073-3.149,11.176,11.176,0,0,0-4.482-9.191",
    transform: "translate(119.628 75.08)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_176",
    "data-name": "Grupo 176",
    transform: "translate(341.494 214.325)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_471",
    "data-name": "Caminho 471",
    d: "M227.79,140.082a4.678,4.678,0,0,0-2.464-.836,3.246,3.246,0,0,0-2.629,1.228,4.184,4.184,0,0,0-.831,1.658,1.9,1.9,0,0,0,1.054.04,2.629,2.629,0,0,1,.982-1.39c.84-.645,2.039-.6,3.323.235a10.2,10.2,0,0,1,4.013,8.236c-.152,2.989-2.161,4.185-4.528,2.691l-1.045.6a4.984,4.984,0,0,0,.44.294,4.619,4.619,0,0,0,2.443.836h.022a3.24,3.24,0,0,0,2.63-1.25,5.294,5.294,0,0,0,1.073-3.149,11.176,11.176,0,0,0-4.482-9.191",
    transform: "translate(-221.866 -139.245)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_472",
    "data-name": "Caminho 472",
    d: "M250.756,153.069,183.7,116.064l-.06,1.194a2.055,2.055,0,0,0,.811,1.665l66.222,35.8Z",
    transform: "translate(99.015 62.581)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_179",
    "data-name": "Grupo 179",
    transform: "translate(282.651 178.645)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_178",
    "data-name": "Grupo 178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_177",
    "data-name": "Grupo 177",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_473",
    "data-name": "Caminho 473",
    d: "M250.756,153.069,183.7,116.064l-.06,1.194a2.055,2.055,0,0,0,.811,1.665l66.222,35.8Z",
    transform: "translate(-183.636 -116.064)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_474",
    "data-name": "Caminho 474",
    d: "M184.363,134.964a1.187,1.187,0,0,1,.112-2.2l85.363-49.283a3.758,3.758,0,0,1,3.585.063l67.407,36.55-89.09,51.4Z",
    transform: "translate(99.036 44.784)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_475",
    "data-name": "Caminho 475",
    d: "M227.177,180.307l89.09-51.4,1.11-21.806-89.09,51.438Z",
    transform: "translate(122.492 57.748)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_182",
    "data-name": "Grupo 182",
    transform: "translate(349.669 164.85)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_181",
    "data-name": "Grupo 181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_180",
    "data-name": "Grupo 180",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_476",
    "data-name": "Caminho 476",
    d: "M227.177,180.307l89.09-51.4,1.11-21.806-89.09,51.438Z",
    transform: "translate(-227.177 -107.102)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_477",
    "data-name": "Caminho 477",
    d: "M239.023,150.77a3.043,3.043,0,0,1-2.514-1.342,5.126,5.126,0,0,1-.748-3.185,12.125,12.125,0,0,1,5.419-9.024,4.946,4.946,0,0,1,2.54-.747c2.087.038,3.4,1.856,3.262,4.528a12.1,12.1,0,0,1-5.419,9.024,4.942,4.942,0,0,1-2.538.745Z",
    transform: "translate(127.115 73.584)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_478",
    "data-name": "Caminho 478",
    d: "M236.433,145.878c-.154,3,1.77,4.259,4.3,2.8a10.99,10.99,0,0,0,4.853-8.082c.152-3.008-1.77-4.26-4.3-2.8a11,11,0,0,0-4.855,8.082",
    transform: "translate(127.478 73.969)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_479",
    "data-name": "Caminho 479",
    d: "M247.285,147.837l-.085,1.647c-.168,3.3,1.946,4.681,4.721,3.077l42.418-24.492a12.076,12.076,0,0,0,5.329-8.88l.085-1.648c.168-3.3-1.946-4.678-4.721-3.077l-42.418,24.493a12.076,12.076,0,0,0-5.329,8.88",
    transform: "translate(133.283 61.358)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_480",
    "data-name": "Caminho 480",
    d: "M226.5,161.825l1.1-21.676,1.042.573-1.11,21.767Z",
    transform: "translate(122.129 75.567)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_185",
    "data-name": "Grupo 185",
    transform: "translate(348.633 215.716)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_184",
    "data-name": "Grupo 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_183",
    "data-name": "Grupo 183",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_481",
    "data-name": "Caminho 481",
    d: "M226.5,161.825l1.1-21.676,1.042.573-1.11,21.767Z",
    transform: "translate(-226.504 -140.149)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_482",
    "data-name": "Caminho 482",
    d: "M273.89,13.553l10.557-6.1a1.748,1.748,0,0,1,1.819.166l4.139,2.39v12.2L275.7,13.719a1.723,1.723,0,0,0-1.807-.166",
    transform: "translate(147.679 3.918)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_483",
    "data-name": "Caminho 483",
    d: "M296.048,34.517l10.559,6.1V46.61a1.723,1.723,0,0,1-.762,1.641l.012.012-10.57,6.1a1.741,1.741,0,0,0,.76-1.653Z",
    transform: "translate(159.216 18.611)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_484",
    "data-name": "Caminho 484",
    d: "M329.438,42.951V54.092a1.74,1.74,0,0,1-.76,1.653v.012l-10.559,6.1v-.012a1.76,1.76,0,0,0,.76-1.665V49.051a5.037,5.037,0,0,0-.76-2.532.251.251,0,0,0-.035-.06,5,5,0,0,0-1.772-1.867l-14.8-8.549V17.852a5.037,5.037,0,0,0-.76-2.532c0-.012-.012-.012-.012-.025a5.142,5.142,0,0,0-1.807-1.915L286.907,6.437a1.8,1.8,0,0,0-1.747-.2L295.682.159l.012.012a1.724,1.724,0,0,1,1.772.179l12.021,6.943a4.948,4.948,0,0,1,1.807,1.915.012.012,0,0,1,.012.012,5.037,5.037,0,0,1,.76,2.532V29.944l14.8,8.549a4.627,4.627,0,0,1,.974.785,6.156,6.156,0,0,1,.833,1.142,5.037,5.037,0,0,1,.76,2.532",
    transform: "translate(153.755 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_188",
    "data-name": "Grupo 188",
    transform: "translate(421.569 11.185)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_187",
    "data-name": "Grupo 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_485",
    "data-name": "Caminho 485",
    d: "M273.89,13.553l10.557-6.1a1.748,1.748,0,0,1,1.819.166l4.139,2.39v12.2L275.7,13.719a1.723,1.723,0,0,0-1.807-.166",
    transform: "translate(-273.89 -7.267)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_486",
    "data-name": "Caminho 486",
    d: "M290.406,10.01v12.2L275.7,13.719a1.726,1.726,0,0,0-1.808-.166l10.559-6.1a1.748,1.748,0,0,1,1.819.166Z",
    transform: "translate(147.678 3.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_487",
    "data-name": "Caminho 487",
    d: "M290.67,23.99V5.8a1.744,1.744,0,0,1,.765-1.655,1.74,1.74,0,0,1,1.815.166l12.026,6.943a5.078,5.078,0,0,1,1.815,1.93,5.085,5.085,0,0,1,.765,2.537V33.912l14.8,8.544a5.749,5.749,0,0,1,2.574,4.461V58.051a1.575,1.575,0,0,1-2.572,1.488L307.855,51V69.185a1.579,1.579,0,0,1-2.58,1.485L293.25,63.727a5.778,5.778,0,0,1-2.58-4.464V41.073l-14.7-8.486a5.09,5.09,0,0,1-1.815-1.93,5.084,5.084,0,0,1-.765-2.534V16.99a1.58,1.58,0,0,1,2.58-1.487Z",
    transform: "translate(147.41 2.133)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_488",
    "data-name": "Caminho 488",
    d: "M292.13,5.218a1.089,1.089,0,0,1,.489.183l12.026,6.943A3.889,3.889,0,0,1,306,13.812a3.881,3.881,0,0,1,.6,1.907V34.641l.631.363,14.8,8.544a3.893,3.893,0,0,1,1.354,1.465,3.813,3.813,0,0,1,.588,1.9V58.05c0,.292-.051.519-.191.579a1.077,1.077,0,0,1-.489-.182l-14.8-8.544-1.892-1.093V69.185c0,.114-.009.489-.194.577a1.08,1.08,0,0,1-.493-.183L293.88,62.636a4.55,4.55,0,0,1-1.949-3.372V40.347l-.631-.365-14.7-8.487a4.56,4.56,0,0,1-1.949-3.371V16.989c0-.223.034-.5.194-.577a1.071,1.071,0,0,1,.493.185l14.7,8.486,1.892,1.093V5.8c0-.235.035-.5.134-.562a.106.106,0,0,1,.065-.018m0-1.261a1.366,1.366,0,0,0-.7.186,1.741,1.741,0,0,0-.764,1.655V23.99l-14.7-8.486a2.282,2.282,0,0,0-1.124-.354,1.36,1.36,0,0,0-.691.185,1.742,1.742,0,0,0-.765,1.655V28.124a5.08,5.08,0,0,0,.765,2.534,5.08,5.08,0,0,0,1.815,1.93l14.7,8.487V59.263a5.771,5.771,0,0,0,2.578,4.464l12.027,6.945a2.282,2.282,0,0,0,1.124.351,1.378,1.378,0,0,0,.691-.183,1.749,1.749,0,0,0,.765-1.655V51l14.8,8.544a2.285,2.285,0,0,0,1.121.349,1.367,1.367,0,0,0,.694-.185,1.742,1.742,0,0,0,.759-1.655V46.916a5.749,5.749,0,0,0-2.574-4.461l-14.8-8.542V15.719a5.076,5.076,0,0,0-.765-2.537,5.085,5.085,0,0,0-1.815-1.932L293.249,4.308a2.271,2.271,0,0,0-1.119-.351",
    transform: "translate(147.41 2.134)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_489",
    "data-name": "Caminho 489",
    d: "M311.294,9.208,300.737,15.3a5.157,5.157,0,0,0-1.809-1.915L286.907,6.437a1.8,1.8,0,0,0-1.747-.2L295.682.159l.012.012a1.72,1.72,0,0,1,1.772.179l12.021,6.943a4.948,4.948,0,0,1,1.807,1.915",
    transform: "translate(153.755 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_490",
    "data-name": "Caminho 490",
    d: "M322.9,29.882,312.356,35.97a4.989,4.989,0,0,0-1.772-1.867l-14.8-8.549,10.557-6.1,14.8,8.55a4.567,4.567,0,0,1,.974.783,7.387,7.387,0,0,1,.785,1.094",
    transform: "translate(159.483 10.489)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_491",
    "data-name": "Caminho 491",
    d: "M285.114,4.078h.035V4.066a.042.042,0,0,0-.035.012",
    transform: "translate(153.731 2.192)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_492",
    "data-name": "Caminho 492",
    d: "M333.677,89.357V100.5a1.738,1.738,0,0,1-.762,1.653v.012l-10.557,6.1v-.011a1.752,1.752,0,0,0,.76-1.653V95.457a5.047,5.047,0,0,0-.76-2.534,1.164,1.164,0,0,0-.108-.154,4.875,4.875,0,0,0-1.7-1.772l-14.8-8.549-17.18-9.917L273.86,64.043a1.726,1.726,0,0,0-1.809-.166l10.559-6.1a1.723,1.723,0,0,1,1.807.166l4.15,2.39,27.739,16.028,14.8,8.536a3.867,3.867,0,0,1,.69.523,5.405,5.405,0,0,1,1.117,1.4,5.025,5.025,0,0,1,.762,2.532",
    transform: "translate(146.687 31.052)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_493",
    "data-name": "Caminho 493",
    d: "M332.784,86.682,322.25,92.769a4.891,4.891,0,0,0-1.7-1.772l-14.8-8.549-17.182-9.917-14.707-8.489a1.723,1.723,0,0,0-1.807-.166l10.557-6.1a1.723,1.723,0,0,1,1.807.166l4.15,2.39L316.3,76.362l14.8,8.536a3.984,3.984,0,0,1,.69.523,6.8,6.8,0,0,1,.987,1.261",
    transform: "translate(146.687 31.052)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_494",
    "data-name": "Caminho 494",
    d: "M288.83,70.394l17.185,9.922,14.8,8.544a5.738,5.738,0,0,1,2.574,4.461v11.134a1.576,1.576,0,0,1-2.574,1.488l-14.8-8.542L288.83,87.477l-14.7-8.486a5.79,5.79,0,0,1-2.58-4.464V63.393a1.579,1.579,0,0,1,2.58-1.485Z",
    transform: "translate(146.418 33.189)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_495",
    "data-name": "Caminho 495",
    d: "M273.007,62.816A1.079,1.079,0,0,1,273.5,63l14.7,8.486,17.187,9.922,14.8,8.544a3.866,3.866,0,0,1,1.353,1.465,3.805,3.805,0,0,1,.589,1.9v11.134c0,.292-.051.517-.191.579a1.079,1.079,0,0,1-.491-.182l-14.8-8.544L289.46,86.386l-14.7-8.487a4.56,4.56,0,0,1-1.949-3.371V63.393c0-.234.035-.5.134-.562a.1.1,0,0,1,.06-.015m0-1.262a1.363,1.363,0,0,0-.691.185,1.741,1.741,0,0,0-.763,1.655V74.528a5.784,5.784,0,0,0,2.578,4.464l14.7,8.487L306.014,97.4l14.8,8.544a2.275,2.275,0,0,0,1.12.349,1.371,1.371,0,0,0,.694-.185,1.741,1.741,0,0,0,.757-1.655V93.32a5.742,5.742,0,0,0-2.572-4.461l-14.8-8.544-17.185-9.922-14.7-8.486a2.282,2.282,0,0,0-1.124-.354",
    transform: "translate(146.418 33.189)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_496",
    "data-name": "Caminho 496",
    d: "M500.887,389.148l0-276.135c0-5.624-3.948-12.463-8.82-15.275L339.22,9.444c-4.87-2.811-8.818-.531-8.818,5.092V290.672c0,5.623,3.948,12.463,8.82,15.273L492.067,394.24c4.871,2.812,8.82.533,8.82-5.092",
    transform: "translate(178.148 4.443)",
    fill: "#054c70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_497",
    "data-name": "Caminho 497",
    d: "M335.282,9.873a6.464,6.464,0,0,1,3.121.985L491.253,99.152c4.338,2.5,8,8.852,8,13.86V389.148c0,1.094-.234,4.662-3.246,4.662a6.468,6.468,0,0,1-3.123-.985L340.035,304.533c-4.337-2.506-8-8.852-8-13.86l0-276.137c0-1.093.236-4.662,3.248-4.662m0-1.633c-2.894,0-4.881,2.306-4.881,6.3V290.672c0,5.623,3.95,12.463,8.82,15.273L492.069,394.24a7.994,7.994,0,0,0,3.939,1.2c2.894,0,4.879-2.306,4.879-6.3l0-276.135c0-5.624-3.948-12.463-8.818-15.275L339.221,9.445a8,8,0,0,0-3.939-1.205",
    transform: "translate(178.148 4.443)",
    fill: "#054c70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_498",
    "data-name": "Caminho 498",
    d: "M332.1,12.2c-.031.02-.062.04-.092.062,1.6-1,3.85-.9,6.355.549L491.208,101.1a17.9,17.9,0,0,1,6.2,6.528l16.568-9.563a18.041,18.041,0,0,0-6.232-6.568L354.9,3.211c-2.4-1.395-4.584-1.538-6.171-.662C347.1,3.455,333.7,11.265,332.1,12.2",
    transform: "translate(179.014 1.079)",
    fill: "#213952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_499",
    "data-name": "Caminho 499",
    d: "M439.467,73.977a18.019,18.019,0,0,1,2.617,8.747l-.009,276.132c0,2.738-.937,4.684-2.455,5.641,1.813-1.09,14.847-8.626,16.426-9.531,1.588-.928,2.575-2.9,2.575-5.713V73.122a18.008,18.008,0,0,0-2.586-8.706Z",
    transform: "translate(236.956 34.732)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_500",
    "data-name": "Caminho 500",
    d: "M338.879,70.694V70.7a4.6,4.6,0,0,0,1.568,1.639L481.7,153.955c1.222.7,2.21.132,2.21-1.273V95.4a4.884,4.884,0,0,0-2.2-3.819L392.3,39.938Z",
    transform: "translate(182.72 21.534)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_501",
    "data-name": "Caminho 501",
    d: "M338.463,21.853V79.125a4.515,4.515,0,0,0,.642,2.17l53.422-30.756L342.6,21.69l-1.924-1.11c-1.222-.7-2.21-.132-2.21,1.273",
    transform: "translate(182.496 10.935)",
    fill: "#213952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_502",
    "data-name": "Caminho 502",
    d: "M341.149,21.2V76.248a4.869,4.869,0,0,0,2.209,3.819l139.326,80.481V105.505a4.883,4.883,0,0,0-2.2-3.819Z",
    transform: "translate(183.944 11.429)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_503",
    "data-name": "Caminho 503",
    d: "M341.149,21.2V76.248a4.869,4.869,0,0,0,2.209,3.819l139.326,80.481V105.505a4.883,4.883,0,0,0-2.2-3.819Z",
    transform: "translate(183.944 11.429)",
    fill: "#213952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_504",
    "data-name": "Caminho 504",
    d: "M383.354,73.419V74.7a4.091,4.091,0,0,1-.974,3.057,1.8,1.8,0,0,1-2.35.143l-3.325-1.921a6.21,6.21,0,0,1-2.352-2.857,9.7,9.7,0,0,1-.974-4.184,1.04,1.04,0,0,1,.24-.76.441.441,0,0,1,.585-.043,1.576,1.576,0,0,1,.591.722,2.441,2.441,0,0,1,.248,1.042,4.827,4.827,0,0,0,.486,2.092,3.087,3.087,0,0,0,1.176,1.428l3.325,1.921a.9.9,0,0,0,1.176-.072,2.049,2.049,0,0,0,.486-1.528V72.46a4.845,4.845,0,0,0-.486-2.092,3.106,3.106,0,0,0-1.176-1.428l-.831-.482a1.537,1.537,0,0,1-.591-.71,2.418,2.418,0,0,1-.24-1.039,1.057,1.057,0,0,1,.24-.771.443.443,0,0,1,.591-.04l.831.482a.9.9,0,0,0,1.176-.072,2.049,2.049,0,0,0,.486-1.528V63.5a4.856,4.856,0,0,0-.486-2.092,3.109,3.109,0,0,0-1.176-1.427l-3.325-1.921a.9.9,0,0,0-1.176.071,2.046,2.046,0,0,0-.486,1.53,1.011,1.011,0,0,1-.248.767.458.458,0,0,1-.591.029,1.534,1.534,0,0,1-.585-.708,2.429,2.429,0,0,1-.24-1.048,4.1,4.1,0,0,1,.974-3.058,1.8,1.8,0,0,1,2.352-.143l3.325,1.922a6.191,6.191,0,0,1,2.35,2.857,9.677,9.677,0,0,1,.974,4.182v1.279a5.607,5.607,0,0,1-.3,1.946,2.834,2.834,0,0,1-.825,1.242,10.993,10.993,0,0,1,.825,2.2,9.138,9.138,0,0,1,.3,2.3",
    transform: "translate(201.322 29.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_505",
    "data-name": "Caminho 505",
    d: "M381.078,75.065a32.407,32.407,0,0,0,.8-4.433l1.3.548a21.779,21.779,0,0,1-1.264,4.247Z",
    transform: "translate(205.474 38.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_506",
    "data-name": "Caminho 506",
    d: "M390.461,76.241l-3.326-1.919a.9.9,0,0,0-1.176.071,2.049,2.049,0,0,0-.486,1.528v1.921a1.2,1.2,0,0,0,.123.52.77.77,0,0,0,.292.359l7.08,4.088a1.582,1.582,0,0,1,.585.717,2.464,2.464,0,0,1,.245,1.053,1,1,0,0,1-.245.757.455.455,0,0,1-.585.034l-8.327-4.808a1.548,1.548,0,0,1-.585-.708,2.4,2.4,0,0,1-.246-1.053v-3.84a4.091,4.091,0,0,1,.974-3.055,1.792,1.792,0,0,1,2.35-.143l3.326,1.919a.91.91,0,0,0,1.182-.068,2.016,2.016,0,0,0,.494-1.525v-2.56a4.879,4.879,0,0,0-.488-2.092A3.112,3.112,0,0,0,390.461,66l-3.326-1.921a.9.9,0,0,0-1.176.071,2.053,2.053,0,0,0-.486,1.53,1.04,1.04,0,0,1-.24.771.45.45,0,0,1-.585.032,1.564,1.564,0,0,1-.591-.711,2.4,2.4,0,0,1-.246-1.053,4.1,4.1,0,0,1,.974-3.058,1.8,1.8,0,0,1,2.35-.143l3.326,1.922a6.213,6.213,0,0,1,2.364,2.864,9.7,9.7,0,0,1,.973,4.182v2.56a4.1,4.1,0,0,1-.973,3.058,1.808,1.808,0,0,1-2.364.134",
    transform: "translate(206.947 32.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_507",
    "data-name": "Caminho 507",
    d: "M394.115,73a1.2,1.2,0,0,0,.123.52.762.762,0,0,0,.294.359l4.571,2.641a6.22,6.22,0,0,1,2.352,2.857,9.72,9.72,0,0,1,.973,4.182v2.56a4.107,4.107,0,0,1-.973,3.058,1.8,1.8,0,0,1-2.352.143L395.778,87.4a6.217,6.217,0,0,1-2.35-2.857,9.712,9.712,0,0,1-.974-4.184,1,1,0,0,1,.246-.767.458.458,0,0,1,.591-.029,1.543,1.543,0,0,1,.585.708,2.427,2.427,0,0,1,.24,1.048,4.855,4.855,0,0,0,.486,2.092,3.113,3.113,0,0,0,1.176,1.428l3.326,1.921a.9.9,0,0,0,1.176-.071,2.055,2.055,0,0,0,.486-1.53V82.6a4.842,4.842,0,0,0-.486-2.09,3.115,3.115,0,0,0-1.176-1.428l-4.988-2.88a3.119,3.119,0,0,1-1.176-1.43,4.843,4.843,0,0,1-.486-2.09v-6.4a1.035,1.035,0,0,1,.24-.771.45.45,0,0,1,.591-.029l8.313,4.8a1.553,1.553,0,0,1,.585.706,2.376,2.376,0,0,1,.246,1.042.994.994,0,0,1-.246.759.456.456,0,0,1-.585.032l-7.065-4.08a.224.224,0,0,0-.294.022.533.533,0,0,0-.123.4Z",
    transform: "translate(211.607 35.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_508",
    "data-name": "Caminho 508",
    d: "M411.07,89.421V90.7a4.1,4.1,0,0,1-.974,3.057,1.794,1.794,0,0,1-2.352.143l-3.326-1.919a6.226,6.226,0,0,1-2.35-2.857,9.732,9.732,0,0,1-.973-4.184V83.66a5.714,5.714,0,0,1,.3-1.947,2.68,2.68,0,0,1,.83-1.241,10.328,10.328,0,0,1-.83-2.2,9.208,9.208,0,0,1-.3-2.292V74.7a4.1,4.1,0,0,1,.973-3.057,1.8,1.8,0,0,1,2.35-.143l3.326,1.919a6.206,6.206,0,0,1,2.352,2.858,9.7,9.7,0,0,1,.974,4.182v1.281a5.639,5.639,0,0,1-.3,1.944,2.842,2.842,0,0,1-.827,1.244,10.927,10.927,0,0,1,.827,2.2,9.213,9.213,0,0,1,.3,2.3m-1.662-9.92a4.857,4.857,0,0,0-.486-2.092,3.109,3.109,0,0,0-1.177-1.428l-3.326-1.919a.9.9,0,0,0-1.174.069,2.053,2.053,0,0,0-.488,1.53v1.281a4.851,4.851,0,0,0,.488,2.09,3.134,3.134,0,0,0,1.174,1.43l3.326,1.919a.9.9,0,0,0,1.177-.071,2.053,2.053,0,0,0,.486-1.53Zm0,8.96a4.845,4.845,0,0,0-.486-2.09,3.114,3.114,0,0,0-1.177-1.43l-3.326-1.919a.9.9,0,0,0-1.174.071,2.049,2.049,0,0,0-.488,1.528V85.9a4.846,4.846,0,0,0,.488,2.09,3.126,3.126,0,0,0,1.174,1.43l3.326,1.919a.9.9,0,0,0,1.177-.071,2.053,2.053,0,0,0,.486-1.53Z",
    transform: "translate(216.266 38.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_509",
    "data-name": "Caminho 509",
    d: "M409.1,87.686c0-.757.334-1.1.8-.83a2.05,2.05,0,0,1,.787,1.744c0,.737-.306,1.113-.8.83a2.076,2.076,0,0,1-.787-1.744",
    transform: "translate(220.585 46.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_510",
    "data-name": "Caminho 510",
    d: "M421.5,95.443v1.279a4.1,4.1,0,0,1-.973,3.057,1.793,1.793,0,0,1-2.35.143L414.851,98a6.218,6.218,0,0,1-2.352-2.857,9.734,9.734,0,0,1-.974-4.184V89.682a5.751,5.751,0,0,1,.3-1.947,2.659,2.659,0,0,1,.833-1.239,10.3,10.3,0,0,1-.833-2.2,9.279,9.279,0,0,1-.3-2.292V80.722a4.1,4.1,0,0,1,.974-3.057,1.8,1.8,0,0,1,2.352-.142l3.326,1.918a6.231,6.231,0,0,1,2.35,2.858,9.7,9.7,0,0,1,.973,4.182v1.281a5.6,5.6,0,0,1-.3,1.944,2.84,2.84,0,0,1-.825,1.244,10.928,10.928,0,0,1,.825,2.2,9.14,9.14,0,0,1,.3,2.3m-1.662-9.92a4.875,4.875,0,0,0-.485-2.092A3.124,3.124,0,0,0,418.177,82l-3.326-1.919a.9.9,0,0,0-1.176.069,2.048,2.048,0,0,0-.486,1.53v1.281a4.825,4.825,0,0,0,.486,2.09,3.107,3.107,0,0,0,1.176,1.43l3.326,1.919a.9.9,0,0,0,1.176-.071,2.059,2.059,0,0,0,.485-1.53Zm0,8.96a4.863,4.863,0,0,0-.485-2.09,3.121,3.121,0,0,0-1.176-1.43l-3.326-1.919a.9.9,0,0,0-1.176.071,2.042,2.042,0,0,0-.486,1.528v1.281a4.82,4.82,0,0,0,.486,2.09,3.1,3.1,0,0,0,1.176,1.43l3.326,1.919a.9.9,0,0,0,1.176-.071,2.055,2.055,0,0,0,.485-1.528Z",
    transform: "translate(221.89 41.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_511",
    "data-name": "Caminho 511",
    d: "M426.817,104.913l-3.325-1.921a6.212,6.212,0,0,1-2.349-2.858,9.674,9.674,0,0,1-.976-4.182,1,1,0,0,1,.246-.756.449.449,0,0,1,.591-.04,1.542,1.542,0,0,1,.585.717,2.484,2.484,0,0,1,.242,1.039A4.826,4.826,0,0,0,422.318,99a3.11,3.11,0,0,0,1.174,1.428l3.325,1.919a.916.916,0,0,0,1.185-.066,2.026,2.026,0,0,0,.493-1.525V97.5a2.039,2.039,0,0,1-1.678-.268l-3.325-1.919a6.22,6.22,0,0,1-2.349-2.858,9.681,9.681,0,0,1-.976-4.184v-2.56a4.091,4.091,0,0,1,.976-3.057,1.8,1.8,0,0,1,2.349-.143l3.325,1.921a6.228,6.228,0,0,1,2.366,2.866,9.7,9.7,0,0,1,.974,4.182v10.239a4.1,4.1,0,0,1-.974,3.058,1.81,1.81,0,0,1-2.366.135M428.5,90.52a4.854,4.854,0,0,0-.486-2.092,3.119,3.119,0,0,0-1.191-1.436l-3.325-1.921a.9.9,0,0,0-1.174.072,2.044,2.044,0,0,0-.486,1.528v2.56a4.821,4.821,0,0,0,.486,2.092,3.107,3.107,0,0,0,1.174,1.43l3.325,1.919A.916.916,0,0,0,428,94.6a2.024,2.024,0,0,0,.493-1.525Z",
    transform: "translate(226.55 44.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_512",
    "data-name": "Caminho 512",
    d: "M422.409,118.517l17.062,9.851a7.487,7.487,0,0,1,3.389,5.869v10.527a2.256,2.256,0,0,1-.971,2.09c-.165.1-4.085,2.361-4.254,2.457a2.263,2.263,0,0,1-2.287-.209l-17.064-9.851a7.488,7.488,0,0,1-3.388-5.869V122.854a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(223.708 63.671)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_513",
    "data-name": "Caminho 513",
    d: "M418.284,138.426l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956V135.794a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956v10.527a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(223.707 64.493)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_514",
    "data-name": "Caminho 514",
    d: "M418.284,138.426l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956V135.794a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956v10.527a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(223.707 64.493)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_515",
    "data-name": "Caminho 515",
    d: "M415.859,120.469l3.723-2.15a2.274,2.274,0,0,1,2.313.2l17.065,9.857a6.726,6.726,0,0,1,2.394,2.53l-4.131,2.384a6.779,6.779,0,0,0-2.393-2.53L417.764,120.9a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(224.227 63.672)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_516",
    "data-name": "Caminho 516",
    d: "M415.859,120.469l3.723-2.15a2.274,2.274,0,0,1,2.313.2l17.065,9.857a6.726,6.726,0,0,1,2.394,2.53l-4.131,2.384a6.779,6.779,0,0,0-2.393-2.53L417.764,120.9a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(224.227 63.672)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_517",
    "data-name": "Caminho 517",
    d: "M396.592,103.607l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v10.527a2.254,2.254,0,0,1-.971,2.09c-.165.1-4.085,2.361-4.254,2.457a2.263,2.263,0,0,1-2.287-.209l-17.063-9.851a7.488,7.488,0,0,1-3.388-5.869V107.944a2.262,2.262,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(209.788 55.631)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_518",
    "data-name": "Caminho 518",
    d: "M392.467,123.517l17.063,9.851c1.87,1.08,3.388.2,3.388-1.956V120.885a7.492,7.492,0,0,0-3.388-5.869l-17.063-9.851c-1.872-1.08-3.388-.2-3.388,1.956v10.527a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(209.788 56.454)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_519",
    "data-name": "Caminho 519",
    d: "M392.467,123.517l17.063,9.851c1.87,1.08,3.388.2,3.388-1.956V120.885a7.492,7.492,0,0,0-3.388-5.869l-17.063-9.851c-1.872-1.08-3.388-.2-3.388,1.956v10.527a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(209.788 56.454)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_520",
    "data-name": "Caminho 520",
    d: "M390.042,105.559l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.777,6.777,0,0,0-2.393-2.53l-17.065-9.857a2.864,2.864,0,0,0-1.905-.434",
    transform: "translate(210.307 55.633)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_521",
    "data-name": "Caminho 521",
    d: "M390.042,105.559l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.777,6.777,0,0,0-2.393-2.53l-17.065-9.857a2.864,2.864,0,0,0-1.905-.434",
    transform: "translate(210.307 55.633)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_522",
    "data-name": "Caminho 522",
    d: "M370.774,88.7l17.063,9.851a7.491,7.491,0,0,1,3.388,5.867v10.528a2.254,2.254,0,0,1-.971,2.09c-.165.1-4.085,2.361-4.254,2.457a2.263,2.263,0,0,1-2.287-.209l-17.064-9.851a7.492,7.492,0,0,1-3.388-5.869V93.034a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(195.867 47.592)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_523",
    "data-name": "Caminho 523",
    d: "M366.65,108.607l17.064,9.851c1.87,1.08,3.388.2,3.388-1.956V105.975a7.49,7.49,0,0,0-3.389-5.869L366.65,90.255c-1.872-1.081-3.388-.2-3.389,1.956l0,10.527a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(195.867 48.415)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_524",
    "data-name": "Caminho 524",
    d: "M366.65,108.607l17.064,9.851c1.87,1.08,3.388.2,3.388-1.956V105.975a7.49,7.49,0,0,0-3.389-5.869L366.65,90.255c-1.872-1.081-3.388-.2-3.389,1.956l0,10.527a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(195.867 48.415)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_525",
    "data-name": "Caminho 525",
    d: "M364.225,90.649l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.779,6.779,0,0,0-2.393-2.53L366.13,91.083a2.867,2.867,0,0,0-1.906-.434",
    transform: "translate(196.387 47.593)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_526",
    "data-name": "Caminho 526",
    d: "M364.225,90.649l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.779,6.779,0,0,0-2.393-2.53L366.13,91.083a2.867,2.867,0,0,0-1.906-.434",
    transform: "translate(196.387 47.593)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_527",
    "data-name": "Caminho 527",
    d: "M344.958,73.787l17.06,9.851a7.489,7.489,0,0,1,3.389,5.869v10.527a2.256,2.256,0,0,1-.971,2.09c-.165.1-4.085,2.361-4.254,2.457a2.263,2.263,0,0,1-2.287-.209L340.832,94.52a7.492,7.492,0,0,1-3.388-5.869V78.124a2.266,2.266,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.259,2.259,0,0,1,2.3.2",
    transform: "translate(181.946 39.553)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_528",
    "data-name": "Caminho 528",
    d: "M340.833,93.7l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956V91.065A7.49,7.49,0,0,0,357.9,85.2l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956V87.828a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(181.946 40.376)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_529",
    "data-name": "Caminho 529",
    d: "M340.833,93.7l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956V91.065A7.49,7.49,0,0,0,357.9,85.2l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956V87.828a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(181.946 40.376)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_530",
    "data-name": "Caminho 530",
    d: "M338.408,75.739l3.723-2.15a2.27,2.27,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(182.466 39.554)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_531",
    "data-name": "Caminho 531",
    d: "M338.408,75.739l3.723-2.15a2.27,2.27,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(182.466 39.554)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_532",
    "data-name": "Caminho 532",
    d: "M422.412,221.436l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.479,7.479,0,0,1-3.388-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(223.709 119.164)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_533",
    "data-name": "Caminho 533",
    d: "M422.412,221.436l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.479,7.479,0,0,1-3.388-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(223.709 119.164)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_534",
    "data-name": "Caminho 534",
    d: "M418.287,250.618l17.063,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(223.709 119.987)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_535",
    "data-name": "Caminho 535",
    d: "M415.863,223.388l3.723-2.149a2.27,2.27,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.855a2.867,2.867,0,0,0-1.906-.436",
    transform: "translate(224.229 119.165)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_536",
    "data-name": "Caminho 536",
    d: "M422.41,194.67l17.062,9.851a7.487,7.487,0,0,1,3.389,5.867v19.8a2.258,2.258,0,0,1-.97,2.092c-.166.1-4.085,2.361-4.256,2.457a2.26,2.26,0,0,1-2.287-.211l-17.062-9.851a7.484,7.484,0,0,1-3.389-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.257,2.257,0,0,1,2.3.2",
    transform: "translate(223.708 104.732)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_537",
    "data-name": "Caminho 537",
    d: "M422.41,194.67l17.062,9.851a7.487,7.487,0,0,1,3.389,5.867v19.8a2.258,2.258,0,0,1-.97,2.092c-.166.1-4.085,2.361-4.256,2.457a2.26,2.26,0,0,1-2.287-.211l-17.062-9.851a7.484,7.484,0,0,1-3.389-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.257,2.257,0,0,1,2.3.2",
    transform: "translate(223.708 104.732)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_538",
    "data-name": "Caminho 538",
    d: "M418.287,223.852l17.062,9.851c1.872,1.081,3.388.2,3.388-1.956v-19.8a7.488,7.488,0,0,0-3.388-5.869l-17.062-9.851c-1.872-1.079-3.391-.2-3.391,1.956l0,19.8a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(223.708 105.555)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_539",
    "data-name": "Caminho 539",
    d: "M415.861,196.622l3.722-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.7,6.7,0,0,1,2.393,2.53l-4.13,2.384a6.767,6.767,0,0,0-2.393-2.53l-17.065-9.857a2.87,2.87,0,0,0-1.9-.434",
    transform: "translate(224.228 104.733)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_540",
    "data-name": "Caminho 540",
    d: "M422.408,167.9l17.062,9.851a7.489,7.489,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.485,7.485,0,0,1-3.389-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(223.707 90.3)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_541",
    "data-name": "Caminho 541",
    d: "M422.408,167.9l17.062,9.851a7.489,7.489,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.485,7.485,0,0,1-3.389-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(223.707 90.3)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_542",
    "data-name": "Caminho 542",
    d: "M418.283,197.085l17.064,9.851c1.87,1.08,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.079-3.389-.2-3.389,1.956v19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(223.707 91.123)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_543",
    "data-name": "Caminho 543",
    d: "M415.858,169.856l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.7,6.7,0,0,1,2.393,2.53l-4.13,2.384a6.779,6.779,0,0,0-2.393-2.531l-17.065-9.857a2.856,2.856,0,0,0-1.906-.434",
    transform: "translate(224.227 90.301)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_544",
    "data-name": "Caminho 544",
    d: "M422.4,141.137l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.087,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.063-9.851a7.492,7.492,0,0,1-3.388-5.869v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(223.706 75.867)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_545",
    "data-name": "Caminho 545",
    d: "M422.4,141.137l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.087,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.063-9.851a7.492,7.492,0,0,1-3.388-5.869v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(223.706 75.867)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_546",
    "data-name": "Caminho 546",
    d: "M418.281,170.319l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869L418.281,142.7c-1.872-1.081-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(223.706 76.69)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_547",
    "data-name": "Caminho 547",
    d: "M415.856,143.089l3.723-2.15a2.271,2.271,0,0,1,2.312.2L438.956,151a6.714,6.714,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.874,2.874,0,0,0-1.906-.434",
    transform: "translate(224.225 75.869)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_548",
    "data-name": "Caminho 548",
    d: "M370.7,191.774l17.062,9.851a7.487,7.487,0,0,1,3.389,5.869v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.456a2.263,2.263,0,0,1-2.287-.209l-17.063-9.851a7.492,7.492,0,0,1-3.388-5.869v-19.8a2.262,2.262,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(195.826 103.17)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_549",
    "data-name": "Caminho 549",
    d: "M366.574,220.956l17.063,9.851c1.87,1.08,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.079-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(195.826 103.994)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_550",
    "data-name": "Caminho 550",
    d: "M365.06,194.5a1.463,1.463,0,0,1,.7.245l17.062,9.849a5.874,5.874,0,0,1,2.572,4.454v19.8c0,.536-.14.753-.242.787a1.482,1.482,0,0,1-.7-.245l-17.062-9.849a5.874,5.874,0,0,1-2.572-4.454v-19.8a1.2,1.2,0,0,1,.174-.779.21.21,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.492,7.492,0,0,0,3.388,5.867l17.063,9.851a3.071,3.071,0,0,0,1.513.463c1.111,0,1.875-.887,1.875-2.42v-19.8a7.487,7.487,0,0,0-3.388-5.867l-17.063-9.851a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(195.826 103.994)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_551",
    "data-name": "Caminho 551",
    d: "M364.149,193.726l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.394-2.53l-17.065-9.857a2.875,2.875,0,0,0-1.906-.434",
    transform: "translate(196.346 103.172)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_552",
    "data-name": "Caminho 552",
    d: "M364.642,192.892l-.5.286a1.994,1.994,0,0,0-.911,1.339,1.853,1.853,0,0,1,1.408-1.625",
    transform: "translate(195.852 104.005)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_553",
    "data-name": "Caminho 553",
    d: "M396.559,179.849l17.062,9.851a7.487,7.487,0,0,1,3.389,5.869v19.8a2.258,2.258,0,0,1-.97,2.09c-.166.1-4.087,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.063-9.851a7.492,7.492,0,0,1-3.388-5.869v-19.8a2.262,2.262,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(209.77 96.74)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    "data-name": "Caminho 554",
    d: "M392.435,209.031l17.064,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.08-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(209.77 97.563)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_555",
    "data-name": "Caminho 555",
    d: "M390.921,182.577a1.483,1.483,0,0,1,.7.245l17.062,9.851a5.871,5.871,0,0,1,2.572,4.453l0,19.8c0,.537-.142.753-.243.788a1.507,1.507,0,0,1-.7-.245l-17.062-9.851a5.874,5.874,0,0,1-2.572-4.454v-19.8a1.209,1.209,0,0,1,.174-.78.213.213,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.888-1.875,2.421v19.8a7.484,7.484,0,0,0,3.389,5.867L409.5,218.88a3.058,3.058,0,0,0,1.513.465c1.113,0,1.875-.888,1.875-2.421v-19.8a7.487,7.487,0,0,0-3.388-5.867l-17.063-9.849a3.074,3.074,0,0,0-1.513-.465",
    transform: "translate(209.77 97.563)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_556",
    "data-name": "Caminho 556",
    d: "M390.01,181.8l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.873,2.873,0,0,0-1.905-.434",
    transform: "translate(210.289 96.742)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_557",
    "data-name": "Caminho 557",
    d: "M390.5,180.967l-.5.286a2,2,0,0,0-.911,1.339,1.853,1.853,0,0,1,1.408-1.625",
    transform: "translate(209.796 97.576)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_558",
    "data-name": "Caminho 558",
    d: "M370.7,165.008l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.479,7.479,0,0,1-3.388-5.867v-19.8a2.266,2.266,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(195.825 88.738)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_559",
    "data-name": "Caminho 559",
    d: "M366.571,194.19l17.063,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.079-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(195.824 89.562)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_560",
    "data-name": "Caminho 560",
    d: "M365.058,167.736a1.488,1.488,0,0,1,.7.245l17.062,9.851a5.871,5.871,0,0,1,2.572,4.453v19.8c0,.537-.14.754-.242.788a1.5,1.5,0,0,1-.7-.245l-17.062-9.852a5.869,5.869,0,0,1-2.572-4.453v-19.8a1.208,1.208,0,0,1,.174-.78.21.21,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.888-1.875,2.421v19.8a7.492,7.492,0,0,0,3.388,5.867l17.063,9.851a3.075,3.075,0,0,0,1.513.465c1.111,0,1.875-.888,1.875-2.421v-19.8a7.492,7.492,0,0,0-3.388-5.869l-17.063-9.848a3.076,3.076,0,0,0-1.513-.465",
    transform: "translate(195.825 89.561)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_561",
    "data-name": "Caminho 561",
    d: "M364.147,166.96l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.7,6.7,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(196.344 88.74)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_562",
    "data-name": "Caminho 562",
    d: "M364.64,166.126l-.5.286a1.991,1.991,0,0,0-.913,1.339,1.853,1.853,0,0,1,1.408-1.625",
    transform: "translate(195.851 89.573)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_563",
    "data-name": "Caminho 563",
    d: "M344.835,150.167l17.062,9.851a7.49,7.49,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.851a7.49,7.49,0,0,1-3.389-5.869V154.5a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.256,2.256,0,0,1,2.295.2",
    transform: "translate(181.881 80.736)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_564",
    "data-name": "Caminho 564",
    d: "M340.711,179.349l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956v-19.8a7.494,7.494,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(181.881 81.559)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_565",
    "data-name": "Caminho 565",
    d: "M339.2,152.9a1.472,1.472,0,0,1,.7.243l17.062,9.851a5.874,5.874,0,0,1,2.572,4.454v19.8c0,.536-.14.753-.243.787a1.494,1.494,0,0,1-.7-.245l-17.062-9.849a5.874,5.874,0,0,1-2.572-4.454v-19.8a1.2,1.2,0,0,1,.174-.779.211.211,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.485,7.485,0,0,0,3.389,5.867l17.062,9.851a3.075,3.075,0,0,0,1.513.463c1.113,0,1.876-.887,1.876-2.42v-19.8a7.483,7.483,0,0,0-3.388-5.867l-17.063-9.851a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(181.881 81.559)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_566",
    "data-name": "Caminho 566",
    d: "M338.286,152.119l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.715,6.715,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.875,2.875,0,0,0-1.905-.434",
    transform: "translate(182.4 80.737)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_567",
    "data-name": "Caminho 567",
    d: "M338.779,151.285l-.5.286a2,2,0,0,0-.911,1.339,1.851,1.851,0,0,1,1.408-1.625",
    transform: "translate(181.907 81.571)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_568",
    "data-name": "Caminho 568",
    d: "M396.555,153.083l17.062,9.851a7.487,7.487,0,0,1,3.389,5.867v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.479,7.479,0,0,1-3.388-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(209.768 82.308)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_569",
    "data-name": "Caminho 569",
    d: "M392.43,182.264l17.063,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869L392.43,154.64c-1.872-1.079-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(209.767 83.131)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_570",
    "data-name": "Caminho 570",
    d: "M390.917,155.811a1.464,1.464,0,0,1,.7.245l17.062,9.849a5.874,5.874,0,0,1,2.572,4.454l0,19.8c0,.536-.142.753-.243.787a1.468,1.468,0,0,1-.7-.243l-17.064-9.851a5.874,5.874,0,0,1-2.572-4.454V156.6a1.2,1.2,0,0,1,.174-.779.211.211,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.492,7.492,0,0,0,3.388,5.867l17.063,9.851a3.071,3.071,0,0,0,1.513.463c1.113,0,1.876-.887,1.875-2.42v-19.8a7.487,7.487,0,0,0-3.388-5.867l-17.063-9.851a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(209.768 83.131)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_571",
    "data-name": "Caminho 571",
    d: "M390.005,155.035l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.714,6.714,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53l-17.065-9.857a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(210.287 82.31)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_572",
    "data-name": "Caminho 572",
    d: "M390.5,154.2l-.5.286a2,2,0,0,0-.911,1.339A1.853,1.853,0,0,1,390.5,154.2",
    transform: "translate(209.794 83.144)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_573",
    "data-name": "Caminho 573",
    d: "M370.694,138.241l17.062,9.852a7.489,7.489,0,0,1,3.389,5.867v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.264,2.264,0,0,1-2.287-.211l-17.063-9.852a7.482,7.482,0,0,1-3.388-5.867v-19.8a2.267,2.267,0,0,1,.953-2.081c.169-.1,4.1-2.366,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(195.824 74.306)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_574",
    "data-name": "Caminho 574",
    d: "M366.571,167.423l17.063,9.851c1.87,1.081,3.386.2,3.386-1.956v-19.8a7.486,7.486,0,0,0-3.389-5.869l-17.06-9.851c-1.872-1.081-3.391-.2-3.391,1.956l0,19.8a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(195.823 75.129)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_575",
    "data-name": "Caminho 575",
    d: "M365.056,140.97a1.463,1.463,0,0,1,.7.245l17.062,9.849a5.874,5.874,0,0,1,2.572,4.454l0,19.8c0,.536-.142.753-.243.787a1.488,1.488,0,0,1-.7-.245l-17.062-9.849a5.874,5.874,0,0,1-2.572-4.454v-19.8a1.2,1.2,0,0,1,.174-.779.211.211,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.487,7.487,0,0,0,3.388,5.867l17.063,9.851a3.072,3.072,0,0,0,1.513.463c1.113,0,1.875-.887,1.875-2.42v-19.8a7.485,7.485,0,0,0-3.388-5.867L366.569,139.8a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(195.824 75.129)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_576",
    "data-name": "Caminho 576",
    d: "M364.145,140.194l3.722-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.7,6.7,0,0,1,2.393,2.53l-4.13,2.384a6.777,6.777,0,0,0-2.393-2.53l-17.065-9.857a2.872,2.872,0,0,0-1.9-.434",
    transform: "translate(196.343 74.308)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_577",
    "data-name": "Caminho 577",
    d: "M364.639,139.36l-.5.286a2,2,0,0,0-.911,1.339,1.856,1.856,0,0,1,1.41-1.625",
    transform: "translate(195.849 75.142)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_578",
    "data-name": "Caminho 578",
    d: "M344.833,123.4l17.063,9.851a7.489,7.489,0,0,1,3.388,5.867l0,19.8a2.261,2.261,0,0,1-.971,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209L340.709,153.4a7.483,7.483,0,0,1-3.388-5.867l0-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(181.88 66.304)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_579",
    "data-name": "Caminho 579",
    d: "M340.71,152.582l17.063,9.851c1.87,1.08,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.081-3.391-.2-3.391,1.956l0,19.8a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(181.879 67.127)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_580",
    "data-name": "Caminho 580",
    d: "M339.195,126.129a1.463,1.463,0,0,1,.7.245l17.062,9.849a5.874,5.874,0,0,1,2.572,4.454v19.8c0,.536-.141.751-.243.787a1.488,1.488,0,0,1-.7-.245l-17.062-9.851a5.869,5.869,0,0,1-2.572-4.454v-19.8a1.2,1.2,0,0,1,.174-.779.212.212,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.492,7.492,0,0,0,3.388,5.869l17.063,9.851a3.071,3.071,0,0,0,1.513.463c1.113,0,1.876-.887,1.876-2.42v-19.8a7.492,7.492,0,0,0-3.388-5.869l-17.063-9.849a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(181.88 67.127)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_581",
    "data-name": "Caminho 581",
    d: "M338.284,125.351l3.723-2.149a2.274,2.274,0,0,1,2.312.2l17.065,9.858a6.72,6.72,0,0,1,2.394,2.529l-4.13,2.386a6.8,6.8,0,0,0-2.393-2.532l-17.065-9.855a2.876,2.876,0,0,0-1.905-.436",
    transform: "translate(182.399 66.305)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_582",
    "data-name": "Caminho 582",
    d: "M338.777,124.518l-.5.286a2.006,2.006,0,0,0-.911,1.341,1.855,1.855,0,0,1,1.408-1.627",
    transform: "translate(181.906 67.139)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_583",
    "data-name": "Caminho 583",
    d: "M396.553,126.316l17.06,9.851A7.49,7.49,0,0,1,417,142.036v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.087,2.361-4.254,2.457a2.265,2.265,0,0,1-2.289-.209l-17.063-9.851a7.492,7.492,0,0,1-3.388-5.869v-19.8a2.262,2.262,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.259,2.259,0,0,1,2.3.2",
    transform: "translate(209.766 67.876)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_584",
    "data-name": "Caminho 584",
    d: "M392.428,155.5l17.062,9.851c1.872,1.081,3.389.2,3.389-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.08-3.389-.2-3.389,1.956v19.8a7.49,7.49,0,0,0,3.389,5.869",
    transform: "translate(209.766 68.699)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_585",
    "data-name": "Caminho 585",
    d: "M390.915,129.046a1.471,1.471,0,0,1,.7.243l17.062,9.851a5.874,5.874,0,0,1,2.572,4.453v19.8c0,.536-.14.753-.242.787a1.488,1.488,0,0,1-.7-.245l-17.062-9.849a5.874,5.874,0,0,1-2.572-4.454v-19.8a1.2,1.2,0,0,1,.174-.779.21.21,0,0,1,.068-.008m0-1.635c-1.111,0-1.875.888-1.875,2.421v19.8a7.487,7.487,0,0,0,3.388,5.867l17.063,9.851a3.071,3.071,0,0,0,1.513.463c1.111,0,1.875-.887,1.875-2.42v-19.8a7.487,7.487,0,0,0-3.388-5.866l-17.063-9.851a3.075,3.075,0,0,0-1.513-.465",
    transform: "translate(209.767 68.699)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_586",
    "data-name": "Caminho 586",
    d: "M390,128.268l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.713,6.713,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53L391.908,128.7a2.876,2.876,0,0,0-1.906-.434",
    transform: "translate(210.286 67.877)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_587",
    "data-name": "Caminho 587",
    d: "M390.5,127.434l-.5.286a2,2,0,0,0-.911,1.339,1.851,1.851,0,0,1,1.408-1.625",
    transform: "translate(209.792 68.711)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_588",
    "data-name": "Caminho 588",
    d: "M370.692,111.475l17.062,9.851a7.487,7.487,0,0,1,3.389,5.869v19.8a2.255,2.255,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.485,7.485,0,0,1-3.389-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(195.823 59.874)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_589",
    "data-name": "Caminho 589",
    d: "M366.567,140.657l17.063,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.489,7.489,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.079-3.389-.2-3.389,1.956v19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(195.822 60.697)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_590",
    "data-name": "Caminho 590",
    d: "M365.054,114.2a1.464,1.464,0,0,1,.7.245l17.062,9.849a5.874,5.874,0,0,1,2.572,4.454l0,19.8c0,.536-.142.753-.243.786a1.488,1.488,0,0,1-.7-.245l-17.062-9.849a5.874,5.874,0,0,1-2.572-4.456v-19.8a1.2,1.2,0,0,1,.174-.779.211.211,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.492,7.492,0,0,0,3.388,5.867l17.063,9.851a3.071,3.071,0,0,0,1.513.463c1.111,0,1.875-.887,1.875-2.42v-19.8a7.483,7.483,0,0,0-3.388-5.867l-17.063-9.851a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(195.823 60.697)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_591",
    "data-name": "Caminho 591",
    d: "M364.142,113.427l3.723-2.15a2.274,2.274,0,0,1,2.313.2l17.065,9.857a6.726,6.726,0,0,1,2.394,2.53l-4.131,2.384a6.78,6.78,0,0,0-2.393-2.53l-17.065-9.857a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(196.342 59.875)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_592",
    "data-name": "Caminho 592",
    d: "M364.635,112.593l-.5.286a1.992,1.992,0,0,0-.913,1.339,1.853,1.853,0,0,1,1.408-1.625",
    transform: "translate(195.848 60.709)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_593",
    "data-name": "Caminho 593",
    d: "M344.837,176.933l17.062,9.851a7.487,7.487,0,0,1,3.389,5.869v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.478,7.478,0,0,1-3.388-5.867l0-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.367,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(181.882 95.168)",
    fill: "#658d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_594",
    "data-name": "Caminho 594",
    d: "M340.713,206.115l17.063,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.079-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(181.882 95.991)",
    fill: "#7daf80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_595",
    "data-name": "Caminho 595",
    d: "M338.288,178.885l3.723-2.149a2.27,2.27,0,0,1,2.312.2l17.065,9.858a6.708,6.708,0,0,1,2.394,2.529l-4.13,2.386a6.772,6.772,0,0,0-2.393-2.532l-17.065-9.857a2.867,2.867,0,0,0-1.906-.434",
    transform: "translate(182.402 95.17)",
    fill: "#93cd96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_596",
    "data-name": "Caminho 596",
    d: "M344.831,96.634l17.062,9.851a7.487,7.487,0,0,1,3.389,5.867v19.8a2.257,2.257,0,0,1-.97,2.09c-.166.1-4.085,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.062-9.852a7.484,7.484,0,0,1-3.389-5.867v-19.8a2.265,2.265,0,0,1,.953-2.079c.169-.1,4.1-2.369,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(181.878 51.872)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_597",
    "data-name": "Caminho 597",
    d: "M340.706,125.816l17.063,9.851c1.87,1.081,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.079-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(181.878 52.695)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_598",
    "data-name": "Caminho 598",
    d: "M339.193,99.363a1.464,1.464,0,0,1,.7.245l17.062,9.849a5.874,5.874,0,0,1,2.572,4.454v19.8c0,.536-.14.753-.242.787a1.487,1.487,0,0,1-.7-.245L341.523,124.4a5.869,5.869,0,0,1-2.572-4.453v-19.8a1.2,1.2,0,0,1,.174-.779.212.212,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.492,7.492,0,0,0,3.388,5.867l17.064,9.851a3.071,3.071,0,0,0,1.513.463c1.113,0,1.875-.887,1.875-2.42v-19.8a7.487,7.487,0,0,0-3.388-5.867l-17.064-9.851a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(181.878 52.695)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_599",
    "data-name": "Caminho 599",
    d: "M338.281,98.586,342,96.436a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.7,6.7,0,0,1,2.393,2.53l-4.13,2.384a6.778,6.778,0,0,0-2.393-2.53L340.187,99.02a2.865,2.865,0,0,0-1.906-.434",
    transform: "translate(182.398 51.873)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_600",
    "data-name": "Caminho 600",
    d: "M338.774,97.752l-.5.286a2,2,0,0,0-.911,1.339,1.853,1.853,0,0,1,1.408-1.625",
    transform: "translate(181.904 52.707)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_601",
    "data-name": "Caminho 601",
    d: "M396.559,205.012l17.062,9.851a7.487,7.487,0,0,1,3.389,5.869v19.8a2.258,2.258,0,0,1-.97,2.09c-.166.1-4.087,2.361-4.256,2.457a2.263,2.263,0,0,1-2.287-.209l-17.063-9.851a7.492,7.492,0,0,1-3.388-5.869v-19.8A2.262,2.262,0,0,1,390,207.27c.169-.1,4.1-2.367,4.265-2.463a2.257,2.257,0,0,1,2.295.2",
    transform: "translate(209.77 110.308)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_602",
    "data-name": "Caminho 602",
    d: "M392.435,234.193l17.064,9.851c1.87,1.08,3.388.2,3.388-1.956v-19.8a7.49,7.49,0,0,0-3.389-5.869l-17.062-9.851c-1.872-1.081-3.389-.2-3.389,1.956l0,19.8a7.488,7.488,0,0,0,3.388,5.869",
    transform: "translate(209.77 111.131)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_603",
    "data-name": "Caminho 603",
    d: "M390.921,207.74a1.472,1.472,0,0,1,.7.243l17.062,9.851a5.872,5.872,0,0,1,2.572,4.454l0,19.8c0,.536-.142.753-.243.787a1.488,1.488,0,0,1-.7-.245l-17.062-9.849a5.874,5.874,0,0,1-2.572-4.454v-19.8a1.223,1.223,0,0,1,.174-.779.211.211,0,0,1,.068-.008m0-1.633c-1.111,0-1.875.887-1.875,2.42v19.8a7.489,7.489,0,0,0,3.389,5.867l17.062,9.851a3.07,3.07,0,0,0,1.513.463c1.113,0,1.875-.887,1.875-2.42v-19.8a7.492,7.492,0,0,0-3.388-5.869l-17.063-9.849a3.071,3.071,0,0,0-1.513-.463",
    transform: "translate(209.77 111.131)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_604",
    "data-name": "Caminho 604",
    d: "M390.01,206.964l3.723-2.15a2.271,2.271,0,0,1,2.312.2l17.065,9.857a6.714,6.714,0,0,1,2.393,2.53l-4.13,2.384a6.777,6.777,0,0,0-2.393-2.53L391.915,207.4a2.873,2.873,0,0,0-1.905-.434",
    transform: "translate(210.289 110.309)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_605",
    "data-name": "Caminho 605",
    d: "M390.5,206.13l-.5.286a2,2,0,0,0-.911,1.339,1.853,1.853,0,0,1,1.408-1.625",
    transform: "translate(209.796 111.143)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_606",
    "data-name": "Caminho 606",
    d: "M280.113,400.7c.391-5.147-3.685-11.022-12.758-17.987-16.743-12.865-77.594-55.177-101.229-70.846a.247.247,0,0,0-.186-.22c-18.107-13.066-22.169-102.564-32.015-145.39a79.739,79.739,0,0,0-2.146-7.905c-.063-.2-.132-.38-.2-.574-.194-.576-.4-1.161-.617-1.761-.1-.288-.2-.6-.308-.88l-.018,0c-1.773-4.667-4.314-9.822-7.781-13.4a19.265,19.265,0,0,0-4.068-3.375c-2.044-1.379-7.029-3.87-8.1-4.616C98.381,124.976,67.149,147.215,45.1,157.1c-13.713,6.157-25.606,13.823-33.7,29.235h0c-3.885,7.383-6.889,16.568-8.824,28.2-3.626,21.876-2.9,95.288-.965,127.536l-.017-.02c2.227,53.8,10.16,54.53,21,64.372,18.637,16.928,73.355,51.561,91.623,60.489,33.113,16.181,62.717-2.336,84.378-10.965,21.643-8.612,62.665-28.724,71.946-34.392,5.5-3.38,8.512-7,8.776-11.036.109-1.593.67-8.142.8-9.826",
    transform: "translate(0 71.032)",
    fill: "#017098"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_607",
    "data-name": "Caminho 607",
    d: "M193.172,385.954c21.649-8.626,62.676-28.737,71.949-34.4,12.538-7.661,12.149-16.552-3.956-28.926-22.375-17.19-114.208-79.442-114.208-79.442S40.2,294.626,14.9,317.1c-3.825,3.4-3.982,10.588-2.646,12.258,13.862,17.325,75.6,57.325,96.544,67.557,33.126,16.181,62.727-2.332,84.375-10.957",
    transform: "translate(6.196 131.121)",
    fill: "#2a9dc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_608",
    "data-name": "Caminho 608",
    d: "M114.8,139.039c-.111-.063-.222-.142-.348-.206a18.849,18.849,0,0,0-9.149-2.86c-11.188-.9-28.857,6.922-55.311,24.021-7.537,4.867-15.8,10.588-22.677,17.32-.142.126-.283.268-.411.394a53.591,53.591,0,0,0-5.8,6.5c-.3.379-.585.759-.87,1.153-.159.222-.332.443-.474.663-.363.522-.726,1.044-1.074,1.581-.7,1.074-1.376,2.2-2.039,3.351-.078.126-.142.237-.2.363q-.381.711-.759,1.422l-.063-.031-8.218-5.69c8.092-15.407,20.528-23.34,33.328-31.195,22.061-13.526,46.634-31.1,62.279-23.514,1.185.57,9.734,5.358,11.789,6.732",
    transform: "translate(3.993 70.351)",
    fill: "#2a9dc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_609",
    "data-name": "Caminho 609",
    d: "M130.79,165.033c-1.425-5.641-6.374-29.993-24.632-30.965C94.98,133.175,77.3,141,50.857,158.087c-12.314,7.956-26.513,18.15-33.551,31.327C6.93,205.79,5.314,251.208,5.922,294.895s3.442,85.64,9.349,93.364c10.39-29.135,133.158-86.5,147.534-77.835C144.7,297.358,140.637,207.86,130.79,165.033",
    transform: "translate(3.133 72.251)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_610",
    "data-name": "Caminho 610",
    d: "M36.574,242.635c-1.653,24.724-2.1,56.795.822,68.742,3.571,14.618,12.447,32.519,40.334,48.929,39.657,23.337,67.236,38.818,67.236,38.818L285,307.861l-95.45-55.585Z",
    transform: "translate(19.016 130.826)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_611",
    "data-name": "Caminho 611",
    d: "M36.574,242.635c-1.653,24.724-2.1,56.795.822,68.742,3.571,14.618,12.447,32.519,40.334,48.929,39.657,23.337,67.236,38.818,67.236,38.818L285,307.861l-95.45-55.585Z",
    transform: "translate(19.016 130.826)",
    fill: "#545869"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191",
    transform: "translate(189.876 383.103)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_190",
    "data-name": "Grupo 190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_189",
    "data-name": "Grupo 189",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_612",
    "data-name": "Caminho 612",
    d: "M142.053,248.9c-5.287,17.019-18.693,59.594-18.693,59.594,20.582,14.99,37.453,28.9,49.234,39.117l85.013-32.091",
    transform: "translate(-123.362 -248.899)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_613",
    "data-name": "Caminho 613",
    d: "M290.976,587.585,29.6,436.677,431.261,204.93,692.64,355.839Z",
    transform: "translate(15.959 110.496)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_614",
    "data-name": "Caminho 614",
    d: "M29.6,355.495v18.863L290.976,525.266V506.4Z",
    transform: "translate(15.958 191.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_615",
    "data-name": "Caminho 615",
    d: "M29.6,355.495v18.863L290.976,525.266V506.4Z",
    transform: "translate(15.958 191.679)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_616",
    "data-name": "Caminho 616",
    d: "M199.413,553.585,601.077,321.838V302.974L199.413,534.721Z",
    transform: "translate(107.522 163.361)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_617",
    "data-name": "Caminho 617",
    d: "M199.413,534.721,601.077,302.974v18.863L199.413,553.585Z",
    transform: "translate(107.522 163.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    transform: "translate(45.555 547.174)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_618",
    "data-name": "Caminho 618",
    d: "M29.6,355.495v18.863L290.976,525.266V506.4Z",
    transform: "translate(-29.597 -355.495)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    transform: "translate(306.935 466.335)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_619",
    "data-name": "Caminho 619",
    d: "M199.413,534.721,601.077,302.974v18.863L199.413,553.585Z",
    transform: "translate(-199.413 -302.974)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_200",
    "data-name": "Grupo 200",
    transform: "translate(248.899 362.882)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_620",
    "data-name": "Caminho 620",
    d: "M163.1,343.024l61.974,35.931a7.452,7.452,0,0,0,6.748.006L409.705,276.4c1.865-1.074,1.867-2.82,0-3.9l-61.974-35.932a7.457,7.457,0,0,0-6.748-.006L163.107,339.125c-1.864,1.074-1.865,2.82,0,3.9",
    transform: "translate(-161.708 -235.762)",
    fill: "#ba68c8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_621",
    "data-name": "Caminho 621",
    d: "M400.088,268.35a2.324,2.324,0,0,0-1.37-1.91l-55.445-32.006a7.305,7.305,0,0,0-6.614,0l-169.18,97.837a2.323,2.323,0,0,0-1.368,1.909V340a2.318,2.318,0,0,0,1.373,1.91l55.415,32a7.33,7.33,0,0,0,6.619-.006l169.2-97.682a2.327,2.327,0,0,0,1.37-1.9c0-.693,0-5.278,0-5.969",
    transform: "translate(89.565 125.978)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_622",
    "data-name": "Caminho 622",
    d: "M222.9,367.946l-55.419-31.858c-1.829-1.051-1.83-2.758,0-3.814L336.66,234.437a7.3,7.3,0,0,1,6.612,0l55.446,32.006c1.827,1.054,1.827,2.764,0,3.819l-169.2,97.682a7.323,7.323,0,0,1-6.615.006",
    transform: "translate(89.565 125.978)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_623",
    "data-name": "Caminho 623",
    d: "M225.994,333.516v5.944a6.846,6.846,0,0,1-3.106-.763l-55.4-32a2.339,2.339,0,0,1-1.374-1.91v-5.829a2.339,2.339,0,0,0,1.374,1.909l55.4,31.874a6.816,6.816,0,0,0,3.106.777",
    transform: "translate(89.568 161.195)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_624",
    "data-name": "Caminho 624",
    d: "M336.085,237.438a.286.286,0,0,1,.118.022l5.487,3.168-7.444,4.3-5.67-3.188,7.436-4.293Zm8.587,4.959a.284.284,0,0,1,.122.023l5.487,3.168-5.846,3.375-5.673-3.189,5.84-3.372Zm-18.991,1.045a.277.277,0,0,1,.12.022l5.489,3.171-5.844,3.372-5.673-3.189,5.838-3.368Zm27.581,3.916a.329.329,0,0,1,.126.021l5.484,3.168L349.428,256l-5.677-3.186,9.44-5.45Zm-17.393.122a.323.323,0,0,1,.123.022l5.489,3.168-4.644,2.683-5.677-3.189,4.639-2.678Zm-18.989,1.044a.277.277,0,0,1,.122.023l5.487,3.168-5.844,3.375-5.672-3.189,5.838-3.369Zm11.387,3.342a.316.316,0,0,1,.129.025l5.484,3.168-4.647,2.68-5.67-3.186,4.636-2.678Zm33.584.453a.322.322,0,0,1,.128.023l5.484,3.168-7.445,4.3-5.675-3.189,7.439-4.294Zm-53.77,1.288a.268.268,0,0,1,.122.023l5.486,3.166-42.245,24.393L265.77,278l42.24-24.385Zm32.78.913a.328.328,0,0,1,.126.022l5.484,3.168-4.644,2.68-5.673-3.186,4.636-2.678Zm-20.191,1.738a.354.354,0,0,1,.126.022l5.486,3.168-4.647,2.68-5.672-3.188,4.638-2.677Zm49.771,1.022a.313.313,0,0,1,.126.022l5.487,3.168-4.647,2.68-5.677-3.188,4.641-2.677Zm-18.991,1.044a.292.292,0,0,1,.123.023l5.489,3.166-4.647,2.683L346.742,261l4.639-2.678Zm-18.19.585a.323.323,0,0,1,.126.022l5.486,3.168-4.645,2.68-5.677-3.189,4.641-2.675Zm-20.191,1.738a.366.366,0,0,1,.128.022l5.484,3.168-4.647,2.68-5.673-3.189L313,260.649Zm49.771,1.022a.323.323,0,0,1,.126.021l5.484,3.168-4.644,2.68-5.673-3.188,4.638-2.677ZM343.85,262.71a.264.264,0,0,1,.123.023l5.487,3.166-4.644,2.683-5.675-3.189,4.641-2.678Zm-18.193.582a.307.307,0,0,1,.125.025l5.489,3.168-4.644,2.68-5.677-3.189,4.639-2.675Zm55.208,0a.3.3,0,0,1,.126.023l5.489,3.168-5.849,3.374-5.672-3.191,5.84-3.369Zm-75.4,1.736a.314.314,0,0,1,.126.022l5.486,3.168-4.647,2.68-5.672-3.188,4.638-2.677Zm49.771,1.02a.321.321,0,0,1,.128.023l5.484,3.168-4.645,2.68-5.674-3.188,4.638-2.677ZM336.248,267.1a.329.329,0,0,1,.125.021l5.49,3.168-4.648,2.683-5.672-3.189,4.639-2.678Zm-18.189.583a.284.284,0,0,1,.122.023l5.49,3.168-4.647,2.68-5.673-3.191,4.639-2.674Zm-20.191,1.739a.331.331,0,0,1,.128.022l5.484,3.168-4.647,2.68-5.67-3.188,4.636-2.677Zm70.892.865a.292.292,0,0,1,.122.022l5.49,3.171-4.647,2.68-5.675-3.189,4.641-2.678Zm-21.122.154a.323.323,0,0,1,.129.025l5.484,3.168-4.645,2.68-5.675-3.189,4.641-2.675Zm-18.989,1.047a.316.316,0,0,1,.123.022l5.489,3.168-4.645,2.683-5.673-3.189,4.639-2.678Zm-18.193.582a.308.308,0,0,1,.129.025l5.486,3.168-4.647,2.68-5.673-3.189,4.639-2.675Zm-20.19,1.738a.308.308,0,0,1,.125.025L295.88,277l-4.647,2.68-5.673-3.189,4.641-2.675Zm70.89.868a.337.337,0,0,1,.131.022l5.481,3.168-4.644,2.683-5.673-3.191,4.639-2.677Zm-21.115.154a.31.31,0,0,1,.12.022l5.489,3.171L341,280.7l-5.673-3.191,4.639-2.674Zm-19,1.047a.314.314,0,0,1,.126.022l5.486,3.168-4.644,2.683-5.673-3.189,4.636-2.678Zm-18.189.58a.293.293,0,0,1,.123.023l5.487,3.171-4.645,2.68-5.673-3.189,4.639-2.677Zm-20.19,1.741a.283.283,0,0,1,.122.023l5.489,3.168-4.647,2.68-5.67-3.188L282.6,278.2Zm70.89.867a.331.331,0,0,1,.128.022l5.481,3.168-4.644,2.683-5.673-3.189,4.639-2.678Zm-21.121.155a.317.317,0,0,1,.128.023l5.484,3.168-4.647,2.68L327.73,281.9l4.639-2.675Zm-69.564.485a.291.291,0,0,1,.125.023l5.49,3.168-5.846,3.374-5.675-3.191,5.838-3.368Zm50.573.56a.294.294,0,0,1,.123.022l5.49,3.168-4.647,2.683-5.673-3.189,4.639-2.678Zm-18.187.582a.269.269,0,0,1,.119.022l5.49,3.171-4.647,2.68-5.674-3.189,4.641-2.675Zm-20.193,1.739a.313.313,0,0,1,.126.023l5.484,3.168-4.645,2.68-5.673-3.189L275,282.589Zm70.891.865a.273.273,0,0,1,.122.023l5.487,3.168-4.644,2.683-5.673-3.191,4.639-2.678Zm-21.122.156a.324.324,0,0,1,.129.025l5.484,3.168-4.647,2.678-5.673-3.189,4.641-2.675Zm-18.989,1.047a.336.336,0,0,1,.125.022l5.489,3.168-4.647,2.683-5.673-3.189,4.639-2.678Zm-51.772.131a.278.278,0,0,1,.128.026l5.486,3.166-5.846,3.375-5.675-3.188,5.84-3.372Zm33.58.449a.315.315,0,0,1,.129.026l5.484,3.168-4.647,2.68-5.673-3.189,4.639-2.677Zm-20.191,1.739a.333.333,0,0,1,.131.025l5.483,3.168-4.645,2.68-5.672-3.188,4.638-2.677Zm49.774,1.022a.293.293,0,0,1,.122.021l5.489,3.171-4.644,2.68-5.677-3.191L317.17,288Zm-18.989,1.047a.291.291,0,0,1,.122.022l5.489,3.168-4.647,2.68-5.67-3.188,4.636-2.677Zm-18.193.582a.294.294,0,0,1,.123.022l5.489,3.169-4.647,2.681-5.673-3.189,4.639-2.677Zm55,.126a.3.3,0,0,1,.123.023l5.489,3.166-4.647,2.683-5.673-3.189,4.639-2.678Zm-89.776.117a.329.329,0,0,1,.128.022l5.484,3.168-5.846,3.377-5.673-3.191,5.838-3.371Zm14.595,1.495a.273.273,0,0,1,.119.022l5.49,3.171-4.647,2.68-5.675-3.191,4.641-2.673Zm49.768,1.022a.33.33,0,0,1,.129.025l5.48,3.165-4.641,2.683-5.678-3.191,4.641-2.675Zm-18.991,1.047a.3.3,0,0,1,.123.022l5.489,3.168-4.647,2.683-5.673-3.191,4.641-2.677Zm-18.19.58a.283.283,0,0,1,.122.023l5.489,3.169-4.647,2.681-5.673-3.189,4.641-2.677Zm55,.128a.312.312,0,0,1,.12.022l5.489,3.168-4.645,2.683-5.673-3.189,4.639-2.678Zm-90.978.81a.289.289,0,0,1,.125.023l5.49,3.168-7.448,4.3-5.672-3.191,7.436-4.293Zm15.791.8a.309.309,0,0,1,.125.025l5.489,3.168-14.645,8.455-5.675-3.189,14.639-8.45Zm49.774,1.022a.311.311,0,0,1,.125.022l5.486,3.171L303,302.641l-5.673-3.191,4.639-2.675Zm-18.994,1.045a.291.291,0,0,1,.125.023l5.487,3.168-4.644,2.683-5.675-3.191,4.639-2.677Zm-18.187.582a.28.28,0,0,1,.12.023l5.489,3.169-4.645,2.681-5.673-3.191,4.639-2.674Zm54.991.128a.325.325,0,0,1,.125.022l5.489,3.168-4.645,2.683-5.673-3.189,4.638-2.678Zm-25.409,2.632a.309.309,0,0,1,.125.023l5.484,3.169-4.647,2.68-5.673-3.189,4.639-2.675Zm-69.964.716a.27.27,0,0,1,.117.023l5.495,3.171-4.648,2.68-5.672-3.191,4.639-2.675Zm50.969.331a.29.29,0,0,1,.125.023l5.489,3.168-4.645,2.68-5.672-3.188,4.638-2.677Zm-18.189.583a.271.271,0,0,1,.117.022l5.492,3.171-4.244,2.449a.9.9,0,0,0-.476.773.933.933,0,0,0,.5.81l7.208,4.16-5.447,3.143-14.267-8.145,11.042-6.375Zm55,.126a.293.293,0,0,1,.122.022l5.489,3.168-4.647,2.683-5.673-3.189,4.641-2.678Zm-25.413,2.632a.27.27,0,0,1,.12.023l5.487,3.168-4.644,2.683-5.672-3.191,4.638-2.675Zm-69.964.719a.28.28,0,0,1,.123.023l5.49,3.168-4.648,2.68-5.672-3.191,4.639-2.675Zm50.97.328a.291.291,0,0,1,.125.023l5.49,3.168-4.647,2.68-5.675-3.189,4.638-2.677Zm33.5,2.618a.288.288,0,0,1,.125.023l5.487,3.168-4.645,2.681-5.673-3.189,4.639-2.677Zm-22.1.723a.316.316,0,0,1,.125.023l5.483,3.168L280.2,315.8l-5.673-3.189,4.639-2.675Zm-69.965.717a.31.31,0,0,1,.129.023l5.483,3.168-4.645,2.681-5.673-3.189,4.639-2.677Zm16.192.571a.363.363,0,0,1,.126.022l5.484,3.171-4.645,2.68-5.675-3.189,4.641-2.678Zm68.275,2.377a.289.289,0,0,1,.125.023l5.489,3.166-4.647,2.681-5.673-3.188,4.638-2.677Zm-22.1.723a.3.3,0,0,1,.125.023l5.483,3.168L269,322.272l-5.673-3.191,8.239-4.753Zm-71.565,1.642a.284.284,0,0,1,.122.022l5.49,3.168-12.247,7.069-5.673-3.189,12.24-7.065Zm50.171.79a.346.346,0,0,1,.126.022l5.486,3.168-4.647,2.683-5.674-3.188,4.639-2.68Zm35.9,1.233a.289.289,0,0,1,.125.023l5.489,3.166-4.647,2.68-5.672-3.186,4.636-2.678Zm-77.477,2.937a.353.353,0,0,1,.126.022l5.484,3.168-4.647,2.683-5.673-3.188,4.639-2.68Zm33.981.219a.316.316,0,0,1,.126.022l5.483,3.168-4.641,2.683-5.677-3.191,4.639-2.677Zm16.191.571a.294.294,0,0,1,.123.023l5.49,3.168-4.647,2.683-5.673-3.191,4.636-2.678Zm19.7.662a.29.29,0,0,1,.125.023l5.489,3.166-4.647,2.681-5.672-3.188,4.636-2.678Zm-93.667,2.364a.317.317,0,0,1,.128.023l5.481,3.166-4.644,2.684-5.673-3.191,4.639-2.678Zm16.191.573a.315.315,0,0,1,.126.021l5.486,3.168-4.645,2.683-5.673-3.189,4.638-2.678Zm33.981.219a.325.325,0,0,1,.128.022l5.484,3.168L236.01,331.4l-5.673-3.189,4.639-2.678Zm-17.792.353a.284.284,0,0,1,.125.023l5.489,3.168-4.645,2.68-5.674-3.188,4.638-2.678Zm33.982.218a.305.305,0,0,1,.126.023l5.486,3.168-4.645,2.681-5.673-3.189,4.638-2.677Zm18.024,1.632a.321.321,0,0,1,.125.021l5.49,3.168-4.647,2.683-5.673-3.189,4.636-2.678Zm-91.987,1.394a.323.323,0,0,1,.128.023l14.074,8.127-4.645,2.683-14.267-8.147,4.641-2.681Zm16.191.571a.323.323,0,0,1,.128.023l5.484,3.168-4.645,2.683-5.675-3.189,4.639-2.678Zm16.189.573a.29.29,0,0,1,.125.023l5.49,3.166-4.647,2.681-5.673-3.188,4.636-2.678Zm33.982.219a.305.305,0,0,1,.126.023l5.484,3.166L244.6,336.36l-5.673-3.189,4.638-2.677Zm-17.792.351a.258.258,0,0,1,.118.023l5.495,3.169-4.645,2.68-5.675-3.189,4.638-2.675Zm35.817,1.279a.325.325,0,0,1,.125.023l5.489,3.168-4.647,2.683-5.673-3.189,4.636-2.678Zm-59.607,2.54a.328.328,0,0,1,.125.022l5.489,3.168-4.647,2.681-5.675-3.188,4.638-2.678Zm16.189.569a.3.3,0,0,1,.12.021l5.495,3.171-4.647,2.68-5.675-3.189,4.638-2.675Zm16.192.573a.3.3,0,0,1,.123.022l5.487,3.168-4.645,2.683-5.673-3.191,4.639-2.675Zm19.625.708a.284.284,0,0,1,.123.022l5.49,3.168-4.647,2.683-5.673-3.189,4.639-2.678Zm-59.607,2.538a.347.347,0,0,1,.126.022l14.077,8.129-4.647,2.68-14.268-8.145,4.642-2.68Zm16.192.57a.3.3,0,0,1,.117.022l5.495,3.171-4.647,2.68-5.673-3.189,4.639-2.675Zm16.191.571a.27.27,0,0,1,.117.023l5.492,3.168-4.645,2.681-5.672-3.189,4.638-2.675Zm20.23,2.908a.3.3,0,0,1,.125.022l2.381,1.345-4.644,2.683-2.549-1.378L247,343.1Zm-27.83,1.481a.283.283,0,0,1,.122.023l5.487,3.168-4.645,2.683-5.673-3.191,4.641-2.675Zm20.23,2.906a.321.321,0,0,1,.128.023l2.38,1.345-4.645,2.683-2.549-1.378,4.618-2.667Zm-27.83,1.482a.277.277,0,0,1,.122.023l5.487,3.168-4.644,2.683-5.673-3.191,4.636-2.675Zm20.23,2.906a.321.321,0,0,1,.128.023l2.38,1.345-4.645,2.683-2.549-1.378,4.618-2.667Zm-7.6,4.387a.323.323,0,0,1,.129.025l2.381,1.345-4.645,2.683-2.552-1.378,4.619-2.667Z",
    transform: "translate(93.044 128.024)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_625",
    "data-name": "Caminho 625",
    d: "M250.5,263.133a97.109,97.109,0,0,0-16.773-18.355c-7.544-5.983-10.628-7.8-24.159-14.017L190.037,257.9l6.024,1.709c2.529.85,3.893,1.077,4.895,3.4.554,1.284.716,4.762,1.241,7.993a62.684,62.684,0,0,0,3.106,13.1c2.209,6.291,3.555,5.837,7.434,10.814,3.586,4.605,5.062,7.678,7.014,7.405s4.327-4.144,3.26-8.422-4.75-10.41-5.284-12.186c-.459-1.524-1.262-4.4,3.392-3.018,4.879,1.447,13.426,11.866,17.7,16.145s6.96,10.876,10.927,13.736,9.862,2.626,8.112-3.7c.579-3.685,2.737-10.059,3.2-15.944s-6.111-19.557-10.548-25.791",
    transform: "translate(102.466 124.424)",
    fill: "#fac7af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203",
    transform: "translate(424.039 470.369)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_202",
    "data-name": "Grupo 202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_626",
    "data-name": "Caminho 626",
    d: "M487.854,312.525l-9.828-5.489a11.945,11.945,0,0,0-11.131-.129l-48.911,28.227-6.428-3.759a10.894,10.894,0,0,0-9.914-.026l-59.4,34.527c-2.741,1.584-2.741,4.15,0,5.733l6.268,3.617-70.7,40.8c-3.1,1.8-3.091,4.708.011,6.5l9.837,5.68a12.407,12.407,0,0,0,11.227,0l70.69-40.813a10.98,10.98,0,0,0,9.923,0L438.668,353c2.666-1.539,2.724-4.014.214-5.618l48.886-28.226c3.1-1.789,3.138-4.758.086-6.628",
    transform: "translate(-275.495 -305.595)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_627",
    "data-name": "Caminho 627",
    d: "M473.184,333.783,485.7,185.051c.346-4.185-2.139-9.174-5.552-11.144s-9.123-1.864-12.76.236L280.472,282.06a16.259,16.259,0,0,0-7.21,11.379l-12.52,148.732c-.345,4.185,2.141,9.174,5.552,11.142s9.124,1.866,12.76-.234L465.974,345.162a16.254,16.254,0,0,0,7.21-11.379",
    transform: "translate(140.573 93.008)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_628",
    "data-name": "Caminho 628",
    d: "M467.939,333.783l12.518-148.732c.346-4.185-2.139-9.174-5.552-11.144s-9.123-1.864-12.76.236L275.228,282.06a14.88,14.88,0,0,0-4.79,4.838l22.912,13.228-1.416,142.491,168.8-97.454a16.254,16.254,0,0,0,7.21-11.379",
    transform: "translate(145.817 93.008)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_629",
    "data-name": "Caminho 629",
    d: "M268.768,446.122l12.52-148.732a16.253,16.253,0,0,1,7.21-11.378l184.626-106.7c3.637-2.1,5.156-.5,4.811,3.68L468.855,330.6a16.251,16.251,0,0,1-7.21,11.378L274.727,449.9c-3.636,2.1-6.3.409-5.958-3.776",
    transform: "translate(144.901 96.188)",
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_630",
    "data-name": "Caminho 630",
    d: "M334.818,274.036c.568-6.893,5.4-15.012,10.788-18.135s9.3-.065,8.73,6.826-5.4,15.012-10.79,18.133-9.3.066-8.729-6.825",
    transform: "translate(180.501 137.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_631",
    "data-name": "Caminho 631",
    d: "M336.352,314.05,376.3,290.841,369.5,286.91,329.57,310.131Z",
    transform: "translate(177.701 154.699)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_632",
    "data-name": "Caminho 632",
    d: "M399.564,357.57l-48.637,28.089a6.015,6.015,0,0,1-3.117.7,6.178,6.178,0,0,1-2.649-.67c-.034,0-.034-.034-.066-.034l-21.419-12.367c-.034-.035-.068-.035-.1-.069a6.272,6.272,0,0,1-2.783-4.961v-1.139c0-1.844,1.274-2.615,2.883-1.676l12.938,7.442,2.883,1.676-.637-3.286L334.3,308.75l6.786,3.93,39.957-23.208,20.8,63.138a5.036,5.036,0,0,1-2.28,4.961",
    transform: "translate(172.968 156.08)",
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_633",
    "data-name": "Caminho 633",
    d: "M321.375,342.035l16.591-9.578,3.369,22.324Z",
    transform: "translate(173.282 179.257)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_634",
    "data-name": "Caminho 634",
    d: "M341.087,305.926,334.3,302l4.558,62.53c.369,1.81-.669,2.547-2.244,1.61l-12.938-7.442c-1.61-.939-2.884-.168-2.884,1.676v1.139a6.275,6.275,0,0,0,2.783,4.961c.034.034.068.034.1.068L345.1,378.907c.034,0,.034.032.068.032a6.17,6.17,0,0,0,2.647.671Z",
    transform: "translate(172.968 162.834)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_635",
    "data-name": "Caminho 635",
    d: "M122.237,139.661c26.4,2.327,30.624,14.162,37.7,35.251,8.452,25.195,22.612,74.411,22.612,74.411l64.521,30.559-19.537,27.136s-43.21-8.533-63.422-15.609c-15.891-5.563-16.739-10.759-29.842-47.082-9.22-25.555-13.774-41.543-13.774-41.543,2.015-19.966,1.742-63.122,1.742-63.122",
    transform: "translate(64.97 75.304)",
    fill: "#fac7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_636",
    "data-name": "Caminho 636",
    d: "M122.522,138.824c13.751,1.288,23.653,1.975,32.729,19.579s28.821,91,28.821,91l8.586,5.018s-8.389-3.726-19.529,4.1S156.9,280.8,160.477,291.387a32.139,32.139,0,0,1-14.767-11.054c-11.726-17.119-25.755-76-25.755-76Z",
    transform: "translate(64.679 74.853)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_637",
    "data-name": "Caminho 637",
    d: "M175.067,208.546c3.114-.08,3.782,2.48,5.673,4.039s2.561.491,4.676,1.972,3.269,2.84,2.8,4.108l-2.607-1.236s-14.259-2.626-23.35,8.225-5.952,28.715-5.952,28.715l5.858,1.906a7.527,7.527,0,0,1-6.381.948c-3.654-1.113-3.7-1.67-7.571-2.338a9.443,9.443,0,0,1-7.661-6.078c-1.447-3.383-3.785-3.383-5.453-7.391s11.248-35.8,39.965-32.869",
    transform: "translate(72.769 112.343)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_638",
    "data-name": "Caminho 638",
    d: "M195.042,201.856c2.013-41.76-9.626-57.863-24.7-61.974a141.229,141.229,0,0,0-46.587-1.889c-23.128,5.423-50.07,17.219-65.931,24.048,0,0-3.873,7.059-8.13,36.246-3.025,20.737-6.528,45.614-10.984,85-2.726,24.082-14.516,53.162-1.244,59.827,33.116,17.37,131.63,3.489,154.242-33.81,5.058-12.828-5.569-18.036-5.558-35.468,1.162-30.456,8.262-58.859,8.9-71.983",
    transform: "translate(16.863 73.794)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_639",
    "data-name": "Caminho 639",
    d: "M169.938,108.468a21.353,21.353,0,0,0,2.654-3.863c1.085-1.966,2.894-6.426.907-8.275,3.057-1.562,6.188-4.336,6.266-8.036.074-3.514-2.718-3.643-5.523-3.871,6.534-2.646,9.932-9.114,10.76-11.267s.848-4.194.212-4.972c-.908-1.108-1.907.152-7.727.422a32.656,32.656,0,0,1-17.808-4.747c-4.942-2.992-6.789-3.933-14.073-6.663a79.5,79.5,0,0,0-15.432-3.68C119.1,52.068,88.1,54.73,83.888,75.568c-14.975,1.9-17.788,25.863-13.905,36.156C77.135,130.68,84.169,143.3,87.63,156.9c.791-.517,51.775-27.535,63.516-35.223l13.2-8.643a25.9,25.9,0,0,0,5.593-4.562",
    transform: "translate(36.885 28.678)",
    fill: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_640",
    "data-name": "Caminho 640",
    d: "M74.187,132.892c8.61,6.973,14.625.843,14.625.843L86.8,179.006c10.884,15.39,37.818,22.157,46.36,29.2,2.323-4.668,4.853-18.076-.037-28.692l.891-10.822a57.621,57.621,0,0,0,12.058-.1,30.5,30.5,0,0,0,10.531-3.323c5.212-2.9,8.079-6.334,10.876-13.242,4.25-10.493,5.187-34.068,4.04-41.832,1.676-14.859,1.1-23.406-2.877-32.408-7.581-7.267-29.071-8.669-49.009-3.845-.56,4.91-2.146,8.983-6.3,14.221a20.8,20.8,0,0,1-7.778,5.607c-.922,9.541-1.416,12.1-3.363,16.249-1.085,2.389-3.189,5.949-7.976,3.983-2.26-.928-3.749-6.077-5.981-9.552-3-4.673-12.94-7.22-18.21,2.41-5.324,9.812-1.71,21.232,4.164,26.039",
    transform: "translate(36.358 38.342)",
    fill: "#fac7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_641",
    "data-name": "Caminho 641",
    d: "M173.987,92.073c-.625-.1-1.279-.2-1.955-.285-6.317-.84-14.621-1.318-19.739-.142-6.415,1.482-8.78,3.309-12.26,3.2-3.72-.148-5.926-2.144-12.5-4.094-5.244-1.545-14.151-1.69-21.007-1.321-.736.04-1.448.086-2.132.137l-22.82,6.748c.679,1.334,1.515,3.055,2.016,4.067l19.181-5.175c.294.429.593.814.788,1.1a4.091,4.091,0,0,1,.579,1.487c.526,2.543.61,7.382,1.8,10.112a11.956,11.956,0,0,0,2.42,3.7,10.253,10.253,0,0,0,1.294,1.113c.246.175.493.34.757.506a12.615,12.615,0,0,0,2.286,1.087c.129.048.259.094.388.131.2.063.406.131.617.189s.423.112.645.168a17.264,17.264,0,0,0,2.066.366c.285.043.583.072.888.1.356.028.731.052,1.116.068,8.643.345,12.535-3.2,14.97-6.925s2.3-9.106,6.281-8.949c.134.008.259.015.379.034a2.587,2.587,0,0,1,.348.065c2.9.722,2.163,5.626,3.746,9.238a13.8,13.8,0,0,0,2.53,3.974c.2.217.4.422.626.622.111.1.222.2.339.3s.234.192.356.285.215.163.328.242c.189.132.272.189.354.242s.186.122.283.179c.062.042.129.082.2.122a13.1,13.1,0,0,0,3.349,1.359c.1.025.206.052.312.077a20.287,20.287,0,0,0,4.184.529c8.095.26,11.208-3.879,12.738-6.512s2.392-7.428,3.235-9.934a3.112,3.112,0,0,1,.837-1.29,6.889,6.889,0,0,0,2.107-3.629,2.931,2.931,0,0,0-1.929-3.278M131.421,104.75a11.406,11.406,0,0,1-3.4,5.181l-.006,0c-1.99,1.667-5.021,2.912-9.652,2.678-4.685-.232-7.285-2.079-8.766-4.187-.094-.131-.182-.262-.259-.388s-.165-.259-.236-.386-.137-.24-.2-.363c-.055-.106-.111-.215-.16-.325a2.394,2.394,0,0,1-.118-.257c-.04-.082-.074-.159-.1-.232-.054-.129-.106-.262-.154-.388v0a11.5,11.5,0,0,1-.366-1.127c-.006-.008,0-.015-.011-.028-.063-.231-.12-.457-.172-.674-.089-.391-.159-.759-.214-1.082-.012-.071-.023-.142-.035-.208s-.025-.132-.035-.2c-.465-2.678-.857-7.921.717-9.043,1.521-1.079,5.6-2.2,11.992-1.407.219.018.448.049.682.085.979.14,1.953.325,2.906.559.38.089.754.189,1.122.291a27.522,27.522,0,0,1,2.8.936c.3.115.582.237.85.357.325.14.631.289.919.44.062.029.123.06.183.1a3.475,3.475,0,0,1,.334.186,5.548,5.548,0,0,1,1.821,1.459c1.162,1.675.514,5.1-.442,8.028m37.627.229c-.656,2.053-2.069,6.485-6.728,8.276a12.57,12.57,0,0,1-4.859.762c-5.1-.1-7.845-2.1-9.318-4.322a.3.3,0,0,1-.023-.042c-.058-.086-.111-.169-.159-.249-.063-.1-.12-.2-.174-.289-.028-.048-.055-.1-.085-.152-.075-.142-.149-.288-.214-.428-.08-.166-.152-.331-.22-.5-.037-.08-.069-.162-.1-.242-.02-.048-.032-.091-.051-.137-.026-.071-.048-.137-.069-.2s-.04-.109-.052-.157a12.059,12.059,0,0,1-.468-2c-.436-2.975-.523-6.426.814-8.011s6.221-3.2,10.831-3.543c1.062-.078,2.053-.106,2.972-.089.118,0,.235,0,.349.009.129,0,.254.008.379.014.349.014.694.038,1.022.062.125.011.248.02.372.034.165.018.326.034.48.055.274.029.542.069.8.111.525.082,1.014.179,1.465.291.117.029.234.059.345.089a.506.506,0,0,1,.091.025c.074.02.152.04.232.066.115.029.235.071.348.106.143.043.285.094.417.14.248.089.473.18.68.277a.927.927,0,0,1,.12.054,5.614,5.614,0,0,1,1.521.954c1.293,1.219.112,6.412-.719,9.043",
    transform: "translate(43.982 48.129)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_642",
    "data-name": "Caminho 642",
    d: "M86.136,130.475l-.276,6.2c-.025,3.56,3.317,10.579,18.69,21.684,7.034,5.082,15.561,7.371,19.914,10.363a23.377,23.377,0,0,1,7.3,7.467s-4.895-3.677-13.948,1.214c-7.359,3.977-16.549,10.2-20.19,9.351-3.543-.827-11.47-6.612-18.991-18.666-6.318-10.128-8.609-16.249-8.609-16.249s3.9-5.022,7.422-10.079c4.424-6.361,5.15-11.29,8.689-11.29",
    transform: "translate(37.757 70.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_643",
    "data-name": "Caminho 643",
    d: "M110.148,174.019c8.7-8.749,12.8,4.045,14.769,2.1,1.473-1.455-1.488-29.217-13.913-41.618l-.893,10.822Z",
    transform: "translate(59.371 72.524)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_644",
    "data-name": "Caminho 644",
    d: "M109.516,174.6c.323,12.674-.825,42.572-6.224,84.272-1.324,10.225,10.908,32.9,14.476,32.917s12.529-18.667,14.907-29.87c2.133-27.595-8.932-72.277-14.291-87.74Z",
    transform: "translate(55.64 93.916)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_645",
    "data-name": "Caminho 645",
    d: "M109.182,161.5a37.6,37.6,0,0,1,8.353.068,19.862,19.862,0,0,1,4.482,7.043s-.537,7.762-3.774,12.523c0,0-3.548,2.283-8.867.42,0,0-4.779-3.8-5.926-8.8-.022-4.251,3.7-10.136,5.732-11.25",
    transform: "translate(55.779 86.963)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_646",
    "data-name": "Caminho 646",
    d: "M19.17,275.919c4.836-35.218,8.242-46.9,13.725-71.478,7.873-35.3,11.361-39.611,33.271-50.541,15.209,8.926,23.873,36.827,13.625,75.6L67.235,284.243S79.832,301.6,93.5,316.7c11.55,12.758,16.06,21.641,31.729,26.83s22.24,7.627,29.868,12.982c4.057,2.849,13.3,9.426,16.412,11.89s8.038,10.011,12.923,15.413c4.531,5.419-2.72,6.428-6.668,4.339-5.149-2.72-8.045-5.82-11.365-8.7-3.138-2.721-6.557-4.205-9.98-6.354a65.574,65.574,0,0,1-.286,13.1c-.46,2.312-.528,5.215-2.883,6.5-1.327.72-3.8.8-5.238,1.005a3.559,3.559,0,0,1-1.415,2.033c-1.159.757-3.061.548-4.324.219a18.4,18.4,0,0,1-2.269-.834,4.344,4.344,0,0,1-3.283,2.8c-3.913.723-9.172-1.182-9.915-1.675-.442-.292-3.7-3.017-4.661-3.8-1.388-1.131-2.683-1.872-3.155-3.023-.559-1.362,2.26-3.676,4.213-3.591,2.112-.008,4.948,1.224,6.186,1.688a22.056,22.056,0,0,1-.734-5.772c-1.147-3.088-15.383-1.619-25.94-5.755-7.973-3.125-12.571-11.909-15.712-14.633C67.589,344.51,50.8,334.144,29.185,315.349c-17.7-15.392-12.38-22.212-10.016-39.429",
    transform: "translate(8.921 82.981)",
    fill: "#fac7af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_647",
    "data-name": "Caminho 647",
    d: "M66.394,153.222c-17.317,6.709-25.249,11.242-32.532,38.434s-11.33,54.058-14.89,74.614-7.365,30.227,4,42.628c7.648-21.426,42-26.1,48.047-20.043l-2.041-5.229s13.111-53.935,15.7-66.4,5.9-53.739-18.289-64.006",
    transform: "translate(8.289 82.616)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_648",
    "data-name": "Caminho 648",
    d: "M71.775,236.05c2.835,2.509-.194,4.234.907,6.426s1.681,2.49,3.017,4.7a3.508,3.508,0,0,1-.633,4.7l-1.825-2.287s-12.575-4.391-25.406,1.587c-20.328,9.472-19.36,21.332-19.36,21.332l4.6,4.033s-4.581,1.571-7.473-.924-1.608-3.654-4.884-5.834a9.441,9.441,0,0,1-4.547-8.656c.045-3.68-1.869-4.627-2-8.966-.272-9.1,34.262-33.3,57.6-16.114",
    transform: "translate(7.641 124.034)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_206",
    "data-name": "Grupo 206",
    transform: "translate(253.235 495.273)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_205",
    "data-name": "Grupo 205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_649",
    "data-name": "Caminho 649",
    d: "M164.752,326.1l63,36.393,9.951,2.024a.306.306,0,0,0,.329-.446l-3.117-5.714-63.013-36.4c-1.961-1.133-8.69,3.252-7.151,4.14",
    transform: "translate(-164.525 -321.775)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_650",
    "data-name": "Caminho 650",
    d: "M170.534,318.385a1.122,1.122,0,0,1,.288.1l-.559-.319c-.032-.018-.068-.035-.1-.052l-.023-.009a.734.734,0,0,0-.108-.046l-.055-.017c-.029-.009-.058-.018-.092-.026l-.154-.026a1.415,1.415,0,0,0-.165-.009h-.009a2.425,2.425,0,0,0-1.2.363,5.905,5.905,0,0,0-2.666,4.621,2.77,2.77,0,0,0,.072.663.831.831,0,0,0,.029.118.216.216,0,0,0,.02.066c.012.042.029.085.046.128a1.582,1.582,0,0,0,.219.4c.021.029.043.055.063.08l.012.012c.025.026.048.049.071.072a.922.922,0,0,0,.117.1c.034.023.063.046.1.066a.24.24,0,0,1,.037.022l.64.365a1.135,1.135,0,0,1-.289-.226,2.127,2.127,0,0,0,1.533-.325,5.9,5.9,0,0,0,2.669-4.621,2.122,2.122,0,0,0-.494-1.5m-3.946,6.363c.015.006.031.015.046.022-.015-.006-.031-.015-.046-.022",
    transform: "translate(89.34 171.453)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_651",
    "data-name": "Caminho 651",
    d: "M230.992,353.214l-3.763,6.542-.637-.368-59.7-34.458a1.134,1.134,0,0,1-.289-.226,2.129,2.129,0,0,1-.493-1.5,5.891,5.891,0,0,1,2.669-4.619,2.4,2.4,0,0,1,1.193-.365,1.448,1.448,0,0,1,.339.038,1.069,1.069,0,0,1,.288.1.322.322,0,0,1,.046.023l.017.009.006,0Z",
    transform: "translate(89.564 171.581)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_652",
    "data-name": "Caminho 652",
    d: "M207.971,341.2c1.473-.851,2.667-.162,2.667,1.541a5.9,5.9,0,0,1-2.667,4.621c-1.473.85-2.667.16-2.667-1.541a5.9,5.9,0,0,1,2.667-4.621",
    transform: "translate(110.698 183.777)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_653",
    "data-name": "Caminho 653",
    d: "M213.707,345.168a.761.761,0,0,0-.066-.075l-3.4-3.743-.006-.011-.026-.028c-.02-.023-.042-.046-.063-.068l-.035-.039,0,0a1.716,1.716,0,0,0-2.13,0,5.9,5.9,0,0,0-2.669,4.622,1.735,1.735,0,0,0,1.03,1.832l0,0,.042.009a1.262,1.262,0,0,0,.194.042l.04.009.014,0,4.936,1.076a1.194,1.194,0,0,0,.859-.186,3.366,3.366,0,0,0,1.528-2.64,1.257,1.257,0,0,0-.237-.8",
    transform: "translate(110.697 183.778)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_654",
    "data-name": "Caminho 654",
    d: "M179.916,326.121a.019.019,0,0,0-.017-.011l-.088-.051a.7.7,0,0,0-.622.088,2.105,2.105,0,0,0-.948,1.645.7.7,0,0,0,.22.573l0,0,.115.065L223.9,354.585l2.667-1.539Z",
    transform: "translate(96.106 175.786)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_655",
    "data-name": "Caminho 655",
    d: "M205.458,343.975l3.765,2.173,2.666-1.541-5.1-2.943a6.416,6.416,0,0,0-1.334,2.31",
    transform: "translate(110.781 184.222)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_656",
    "data-name": "Caminho 656",
    d: "M213.938,346.125h0l0,0-3.089-3.4a.671.671,0,0,0-.083-.091,1.211,1.211,0,0,0-1.522-.012,4.165,4.165,0,0,0-1.884,3.266,1.239,1.239,0,0,0,.717,1.3l.029.009.126.026,4.525.987,0,0a.685.685,0,0,0,.486-.1,1.9,1.9,0,0,0,.86-1.487.669.669,0,0,0-.172-.489",
    transform: "translate(111.808 184.6)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_209",
    "data-name": "Grupo 209",
    transform: "translate(319.171 526.965)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_208",
    "data-name": "Grupo 208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_657",
    "data-name": "Caminho 657",
    d: "M213.938,346.125h0l0,0-3.089-3.4a.671.671,0,0,0-.083-.091,1.211,1.211,0,0,0-1.522-.012,4.165,4.165,0,0,0-1.884,3.266,1.239,1.239,0,0,0,.717,1.3l.029.009.126.026,4.525.987,0,0a.685.685,0,0,0,.486-.1,1.9,1.9,0,0,0,.86-1.487.669.669,0,0,0-.172-.489",
    transform: "translate(-207.363 -342.365)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_658",
    "data-name": "Caminho 658",
    d: "M213.23,345.978a1.9,1.9,0,0,1-.86,1.487.688.688,0,0,1-.486.1l0,0-2.287-.5c-.36-.077-.6-.417-.6-.959a3.045,3.045,0,0,1,1.37-2.381.889.889,0,0,1,1.1,0l.063.069,1.53,1.679,0,0a.662.662,0,0,1,.172.489",
    transform: "translate(112.689 185.237)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(324.201 530.602)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_211",
    "data-name": "Grupo 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_210",
    "data-name": "Grupo 210",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_659",
    "data-name": "Caminho 659",
    d: "M211.488,344.845c.474-.274.859-.051.859.5a1.9,1.9,0,0,1-.859,1.487c-.474.272-.857.052-.857-.5a1.9,1.9,0,0,1,.857-1.487",
    transform: "translate(-210.631 -344.728)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_660",
    "data-name": "Caminho 660",
    d: "M173.334,322.318a.662.662,0,0,0-.67.065,2.081,2.081,0,0,0-.944,1.636.655.655,0,0,0,.28.614l9.976,5.76a.7.7,0,0,1-.22-.571,2.105,2.105,0,0,1,.948-1.645.7.7,0,0,1,.622-.089Z",
    transform: "translate(92.59 173.756)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_661",
    "data-name": "Caminho 661",
    d: "M173.611,322.93a2.089,2.089,0,0,1-.947,1.635.66.66,0,0,1-.662.066.653.653,0,0,1-.282-.611,2.075,2.075,0,0,1,.944-1.635.576.576,0,0,1,.947.545",
    transform: "translate(92.59 173.756)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_662",
    "data-name": "Caminho 662",
    d: "M174.431,320.944v0l-.031-.019-.04-.023-3.937-2.27a.886.886,0,0,0-.089-.052l-.023-.014h0a1.737,1.737,0,0,0-1.628.2,5.3,5.3,0,0,0-2.4,4.157,1.683,1.683,0,0,0,.711,1.559l3.983,2.3.02.012.023.014,0,0a1.709,1.709,0,0,0,1.662-.185,5.313,5.313,0,0,0,2.4-4.159,1.722,1.722,0,0,0-.656-1.521",
    transform: "translate(89.658 171.701)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215",
    transform: "translate(255.941 490.144)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_213",
    "data-name": "Grupo 213",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_663",
    "data-name": "Caminho 663",
    d: "M174.431,320.944v0l-.031-.019-.04-.023-3.937-2.27a.886.886,0,0,0-.089-.052l-.023-.014h0a1.737,1.737,0,0,0-1.628.2,5.3,5.3,0,0,0-2.4,4.157,1.683,1.683,0,0,0,.711,1.559l3.983,2.3.02.012.023.014,0,0a1.709,1.709,0,0,0,1.662-.185,5.313,5.313,0,0,0,2.4-4.159,1.722,1.722,0,0,0-.656-1.521",
    transform: "translate(-166.283 -318.443)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218",
    transform: "translate(259.941 492.453)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_664",
    "data-name": "Caminho 664",
    d: "M171.283,320.271c1.325-.766,2.4-.145,2.4,1.385a5.308,5.308,0,0,1-2.4,4.159c-1.327.767-2.4.146-2.4-1.385a5.3,5.3,0,0,1,2.4-4.159",
    transform: "translate(-168.882 -319.943)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_665",
    "data-name": "Caminho 665",
    d: "M213.291,346.09h0l-1.628-.977h0a.3.3,0,0,0-.319.025.972.972,0,0,0-.44.762.309.309,0,0,0,.129.285l1.622.981a.609.609,0,0,0,.3.078.626.626,0,0,0,.336-1.154",
    transform: "translate(113.716 186.063)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    "data-name": "Caminho 666",
    d: "M212.8,345.816l0,0a1.007,1.007,0,0,0-.086-.069l-.006,0a.336.336,0,0,0-.282.049.97.97,0,0,0-.442.762.3.3,0,0,0,.125.28.158.158,0,0,0,.032.015l.032.015a.515.515,0,0,0,.2.034.626.626,0,0,0,.625-.626.617.617,0,0,0-.2-.454",
    transform: "translate(114.299 186.413)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    transform: "translate(124.017 525.573)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_667",
    "data-name": "Caminho 667",
    d: "M81.946,396.091l117.7,67.957a7.329,7.329,0,0,0,6.628,0L292.9,414.036c1.83-1.056,1.83-2.769,0-3.826l-117.7-67.955a7.314,7.314,0,0,0-6.625,0l-86.621,50.01c-1.832,1.056-1.832,2.771,0,3.826",
    transform: "translate(-80.573 -341.461)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_668",
    "data-name": "Caminho 668",
    d: "M81.945,392.107l117.7,67.957a7.326,7.326,0,0,0,6.626,0L292.9,410.052c1.83-1.056,1.83-2.769,0-3.825L175.192,338.271a7.317,7.317,0,0,0-6.626,0l-86.621,50.01c-1.83,1.057-1.83,2.771,0,3.826",
    transform: "translate(43.444 181.965)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_669",
    "data-name": "Caminho 669",
    d: "M166.555,338.269,84.3,385.759l113.337,65.436a7.327,7.327,0,0,0,6.626,0l82.254-47.49L173.183,338.269a7.339,7.339,0,0,0-6.628,0",
    transform: "translate(45.455 181.965)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_670",
    "data-name": "Caminho 670",
    d: "M81.946,384.333l117.7,67.955a7.32,7.32,0,0,0,6.628,0l86.618-50.01c1.83-1.056,1.83-2.769,0-3.827L175.192,330.5a7.314,7.314,0,0,0-6.625,0l-86.621,50.01c-1.832,1.056-1.832,2.771,0,3.826",
    transform: "translate(43.444 177.773)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_671",
    "data-name": "Caminho 671",
    d: "M193.8,406.259l-19.466,11.23L162.5,410.66l59.248-34.205,11.852,6.84Z",
    transform: "translate(87.619 202.98)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_672",
    "data-name": "Caminho 672",
    d: "M208.5,373.062l-19.158,11.061a1.688,1.688,0,0,1-1.53.028c-.408-.236-.386-.631.049-.884l19.158-11.06a1.7,1.7,0,0,1,1.53-.028c.408.236.386.631-.049.884",
    transform: "translate(101.11 200.584)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_673",
    "data-name": "Caminho 673",
    d: "M206.578,371.95,187.419,383.01a1.688,1.688,0,0,1-1.53.028c-.408-.236-.386-.631.049-.883L205.1,371.094a1.7,1.7,0,0,1,1.53-.028c.408.236.386.631-.049.883",
    transform: "translate(100.072 199.984)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_674",
    "data-name": "Caminho 674",
    d: "M204.653,370.839,185.494,381.9a1.688,1.688,0,0,1-1.53.028c-.408-.236-.386-.631.049-.883l19.158-11.061a1.7,1.7,0,0,1,1.53-.028c.409.236.386.631-.049.884",
    transform: "translate(99.034 199.385)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_675",
    "data-name": "Caminho 675",
    d: "M202.728,369.728l-19.158,11.061a1.687,1.687,0,0,1-1.53.028c-.408-.235-.386-.631.049-.883l19.158-11.061a1.7,1.7,0,0,1,1.53-.028c.408.235.386.633-.049.883",
    transform: "translate(97.996 198.786)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_676",
    "data-name": "Caminho 676",
    d: "M164.5,386.242,145.343,397.3a1.693,1.693,0,0,1-1.53.029c-.408-.237-.386-.633.049-.884l19.158-11.062a1.7,1.7,0,0,1,1.53-.028c.409.237.386.633-.049.883",
    transform: "translate(77.385 207.69)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_677",
    "data-name": "Caminho 677",
    d: "M162.578,385.131l-19.158,11.061a1.687,1.687,0,0,1-1.53.028c-.408-.235-.386-.631.049-.883L161.1,384.275a1.7,1.7,0,0,1,1.53-.028c.409.236.386.631-.049.884",
    transform: "translate(76.348 207.091)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_678",
    "data-name": "Caminho 678",
    d: "M160.653,384.02,141.494,395.08a1.688,1.688,0,0,1-1.53.028c-.408-.235-.386-.631.049-.884l19.158-11.061a1.7,1.7,0,0,1,1.53-.028c.409.236.386.631-.049.884",
    transform: "translate(75.31 206.492)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_679",
    "data-name": "Caminho 679",
    d: "M158.728,382.908l-19.158,11.061a1.688,1.688,0,0,1-1.53.028c-.408-.236-.386-.631.049-.884l19.158-11.061a1.7,1.7,0,0,1,1.53-.028c.409.236.386.631-.049.884",
    transform: "translate(74.272 205.893)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_680",
    "data-name": "Caminho 680",
    d: "M167.517,338.615,95.035,380.462a1.694,1.694,0,0,1-1.528.028c-.409-.237-.388-.631.048-.884l72.482-41.848a1.7,1.7,0,0,1,1.53-.028c.408.236.386.633-.049.884",
    transform: "translate(50.26 182.01)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_681",
    "data-name": "Caminho 681",
    d: "M165.592,337.5,93.112,379.35a1.7,1.7,0,0,1-1.53.028c-.409-.235-.388-.631.049-.884l72.48-41.848a1.7,1.7,0,0,1,1.53-.028c.409.236.386.633-.049.884",
    transform: "translate(49.222 181.411)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_682",
    "data-name": "Caminho 682",
    d: "M179.811,390.545l-23.7,13.682a1.693,1.693,0,0,1-1.53.029c-.409-.237-.386-.633.049-.883l23.7-13.683a1.7,1.7,0,0,1,1.53-.028c.408.236.386.631-.049.883",
    transform: "translate(83.192 210.01)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_683",
    "data-name": "Caminho 683",
    d: "M177.888,389.433l-23.7,13.683a1.7,1.7,0,0,1-1.53.028c-.408-.237-.386-.633.049-.883l23.7-13.683a1.7,1.7,0,0,1,1.532-.028c.406.237.385.631-.049.884",
    transform: "translate(82.154 209.411)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_684",
    "data-name": "Caminho 684",
    d: "M175.962,388.322,152.263,402a1.7,1.7,0,0,1-1.53.028c-.408-.237-.386-.632.049-.883l23.7-13.683a1.7,1.7,0,0,1,1.53-.028c.409.236.386.633-.049.883",
    transform: "translate(81.116 208.812)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_685",
    "data-name": "Caminho 685",
    d: "M174.037,387.211l-23.7,13.682a1.693,1.693,0,0,1-1.53.029c-.409-.237-.386-.633.049-.884l23.7-13.683a1.7,1.7,0,0,1,1.53-.028c.408.235.386.631-.049.884",
    transform: "translate(80.078 208.213)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_686",
    "data-name": "Caminho 686",
    d: "M184.2,362.8a.528.528,0,0,1,.311-.051.815.815,0,0,1,.349.106l9.046,5.222a.346.346,0,0,1,.182.2.15.15,0,0,1-.086.179l-1.376.8a.536.536,0,0,1-.312.049.808.808,0,0,1-.349-.1l-9.046-5.223a.339.339,0,0,1-.182-.2.152.152,0,0,1,.088-.18Z",
    transform: "translate(98.525 195.587)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_687",
    "data-name": "Caminho 687",
    d: "M178.959,366.672a.752.752,0,0,1,.416-.094,2.327,2.327,0,0,1,.337.031l7.194,1.378-4.733-2.734a.339.339,0,0,1-.182-.2.151.151,0,0,1,.086-.18l1.376-.794a.531.531,0,0,1,.312-.051.816.816,0,0,1,.349.106l9.046,5.222a.345.345,0,0,1,.182.2.153.153,0,0,1-.088.18l-1.093.63a.747.747,0,0,1-.414.094,2.077,2.077,0,0,1-.337-.031l-7.194-1.376,4.733,2.732a.345.345,0,0,1,.182.2.153.153,0,0,1-.088.18l-1.374.794a.536.536,0,0,1-.312.051.844.844,0,0,1-.351-.1l-9.044-5.222a.344.344,0,0,1-.182-.2.15.15,0,0,1,.088-.18Z",
    transform: "translate(95.854 196.278)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_688",
    "data-name": "Caminho 688",
    d: "M175.806,367.687a1.354,1.354,0,0,1,1.116,0l10.894,3.816.152.058a.371.371,0,0,1,.06.029.279.279,0,0,1,.149.165.123.123,0,0,1-.071.146l-1.324.763a.711.711,0,0,1-.419.1,1.212,1.212,0,0,1-.34-.071l-7.621-2.714,4.7,4.4a.381.381,0,0,1,.122.2c.019.08-.042.16-.182.242l-1.324.763a.433.433,0,0,1-.252.042.671.671,0,0,1-.286-.086.405.405,0,0,1-.051-.035c-.015-.012-.048-.042-.1-.088l-6.608-6.289c-.276-.272-.276-.488,0-.645Z",
    transform: "translate(93.936 198.19)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_689",
    "data-name": "Caminho 689",
    d: "M180.059,372.55a5.438,5.438,0,0,1,1.221,1,2.225,2.225,0,0,1,.563,1.065,1.534,1.534,0,0,1-.2,1.051,2.787,2.787,0,0,1-1.07.965,5.265,5.265,0,0,1-1.667.614,7.307,7.307,0,0,1-1.824.117,8.359,8.359,0,0,1-1.845-.326,9.041,9.041,0,0,1-1.733-.7q-.623-.335-1.282-.714t-1.211-.723a5.468,5.468,0,0,1-1.219-1,2.287,2.287,0,0,1-.571-1.068,1.467,1.467,0,0,1,.2-1.054,2.87,2.87,0,0,1,1.073-.959,5.323,5.323,0,0,1,1.664-.62,7.086,7.086,0,0,1,1.819-.114,8.449,8.449,0,0,1,1.852.329,9.088,9.088,0,0,1,1.735.7q.6.319,1.254.7t1.238.74m-7.031,1.262c.16.1.34.212.539.337s.4.245.619.369.426.242.634.352.394.212.56.3a4.575,4.575,0,0,0,.754.309,3.642,3.642,0,0,0,.763.149,2.813,2.813,0,0,0,.747-.035,2.165,2.165,0,0,0,.694-.254,1.134,1.134,0,0,0,.44-.4.59.59,0,0,0,.062-.432,1.043,1.043,0,0,0-.259-.44,2.831,2.831,0,0,0-.536-.436c-.143-.1-.314-.208-.513-.326s-.4-.239-.617-.362-.426-.245-.636-.362-.4-.219-.586-.308a4.275,4.275,0,0,0-1.524-.462,2.305,2.305,0,0,0-1.433.294q-.651.376-.5.823a1.861,1.861,0,0,0,.8.884",
    transform: "translate(91.23 199.533)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_690",
    "data-name": "Caminho 690",
    d: "M167.536,372.416a.528.528,0,0,1,.311-.051.815.815,0,0,1,.349.106l9.046,5.221a.352.352,0,0,1,.182.2.149.149,0,0,1-.086.178l-1.376.8a.548.548,0,0,1-.312.049.823.823,0,0,1-.351-.1l-9.044-5.222a.34.34,0,0,1-.182-.2.153.153,0,0,1,.088-.18Z",
    transform: "translate(89.541 200.774)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_691",
    "data-name": "Caminho 691",
    d: "M170.938,377.73c-.114-.074-.277-.174-.488-.3s-.431-.255-.659-.386-.456-.262-.677-.386-.4-.22-.528-.285a5.629,5.629,0,0,0-.71-.3,3.352,3.352,0,0,0-.75-.166,2.9,2.9,0,0,0-.757.025,2.151,2.151,0,0,0-.731.269,1.274,1.274,0,0,0-.476.4.647.647,0,0,0-.106.376.671.671,0,0,0,.131.336,2.363,2.363,0,0,0,.246.28.729.729,0,0,1,.2.249c.018.059-.032.123-.151.191l-1.376.794a.426.426,0,0,1-.254.042.669.669,0,0,1-.285-.086,3.641,3.641,0,0,1-1.082-.927,1.857,1.857,0,0,1-.4-1.031,1.749,1.749,0,0,1,.3-1.022,2.912,2.912,0,0,1,1.013-.9,5.222,5.222,0,0,1,1.652-.6,7.47,7.47,0,0,1,1.832-.112,8.365,8.365,0,0,1,1.858.326,9.105,9.105,0,0,1,1.721.7q.593.319,1.253.7t1.239.74a5.1,5.1,0,0,1,1.211.99,2.313,2.313,0,0,1,.565,1.073,1.5,1.5,0,0,1-.194,1.057,2.755,2.755,0,0,1-1.054.956,5.307,5.307,0,0,1-1.559.585,7.962,7.962,0,0,1-1.769.172,7.853,7.853,0,0,1-1.785-.229,6.453,6.453,0,0,1-1.607-.625.293.293,0,0,1-.151-.165.126.126,0,0,1,.074-.146l1.376-.794a.547.547,0,0,1,.332-.088,2.057,2.057,0,0,1,.431.115c.14.048.3.1.483.14a2.831,2.831,0,0,0,.582.077,2.955,2.955,0,0,0,.653-.062,2.332,2.332,0,0,0,.7-.274,1.132,1.132,0,0,0,.465-.423.57.57,0,0,0,.043-.436,1.023,1.023,0,0,0-.288-.434,3.832,3.832,0,0,0-.522-.409",
    transform: "translate(87.395 201.75)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_692",
    "data-name": "Caminho 692",
    d: "M159.053,380.627a.526.526,0,0,1-.311.052.859.859,0,0,1-.351-.1l-1.484-.857a.342.342,0,0,1-.182-.2.15.15,0,0,1,.088-.179l4.978-2.875a.53.53,0,0,1,.311-.049.812.812,0,0,1,.349.1l9.046,5.221a.348.348,0,0,1,.182.2.15.15,0,0,1-.086.179l-4.893,2.826a.566.566,0,0,1-.314.051.814.814,0,0,1-.349-.1l-1.484-.857a.333.333,0,0,1-.182-.2.152.152,0,0,1,.088-.179l3.234-1.867-1.513-.873-3,1.735a.542.542,0,0,1-.311.049.8.8,0,0,1-.351-.106l-1.484-.856a.348.348,0,0,1-.182-.2.156.156,0,0,1,.086-.182l3-1.733-1.568-.905Z",
    transform: "translate(84.502 202.955)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_693",
    "data-name": "Caminho 693",
    d: "M207.919,361.029l-74.06,42.759-1.481-.856,74.06-42.759Z",
    transform: "translate(71.377 194.202)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_694",
    "data-name": "Caminho 694",
    d: "M207.919,361.029l-74.06,42.759-1.481-.856,74.06-42.759Z",
    transform: "translate(71.377 194.202)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_695",
    "data-name": "Caminho 695",
    d: "M182.9,346.583l-74.06,42.759-1.481-.856,74.06-42.757Z",
    transform: "translate(57.886 186.413)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_696",
    "data-name": "Caminho 696",
    d: "M182.9,346.583l-74.06,42.759-1.481-.856,74.06-42.757Z",
    transform: "translate(57.886 186.413)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_697",
    "data-name": "Caminho 697",
    d: "M188.947,359.661l-26.662,15.393-2.961-1.71,26.66-15.393Z",
    transform: "translate(85.906 193.004)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_698",
    "data-name": "Caminho 698",
    d: "M162.587,371.884l-11.85,6.842-2.961-1.71,11.849-6.842Z",
    transform: "translate(79.679 199.594)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_699",
    "data-name": "Caminho 699",
    d: "M152.964,377.44l-11.849,6.842-2.963-1.71L150,375.73Z",
    transform: "translate(74.49 202.59)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_700",
    "data-name": "Caminho 700",
    d: "M143.34,383l-11.849,6.842-2.963-1.71,11.849-6.842Z",
    transform: "translate(69.301 205.586)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_701",
    "data-name": "Caminho 701",
    d: "M200.814,356.927l-74.06,42.759-5.924-3.422,74.06-42.757Z",
    transform: "translate(65.151 190.607)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_702",
    "data-name": "Caminho 702",
    d: "M193.116,352.482l-74.06,42.759-5.924-3.422,74.06-42.757Z",
    transform: "translate(61 188.211)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_703",
    "data-name": "Caminho 703",
    d: "M179.916,357.788a2.653,2.653,0,0,1,.948,0c.453.088.608.28.346.431l-20.736,11.972a2.222,2.222,0,0,1-1.293.116c-.454-.086-.61-.28-.348-.431L179.569,357.9a1.157,1.157,0,0,1,.346-.115",
    transform: "translate(85.573 192.893)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_704",
    "data-name": "Caminho 704",
    d: "M155.366,370.483a1.815,1.815,0,0,1,.631,0c.3.059.406.186.232.288l-8.889,5.13a1.481,1.481,0,0,1-.862.077c-.3-.057-.406-.186-.232-.286l8.889-5.132a.764.764,0,0,1,.231-.077",
    transform: "translate(78.809 199.746)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_705",
    "data-name": "Caminho 705",
    d: "M153.99,369.689a1.809,1.809,0,0,1,.631,0c.3.058.406.186.232.288l-8.889,5.13a1.478,1.478,0,0,1-.862.077c-.3-.057-.406-.186-.231-.286l8.887-5.132a.765.765,0,0,1,.231-.077",
    transform: "translate(78.067 199.318)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_706",
    "data-name": "Caminho 706",
    d: "M145.02,375.622a1.773,1.773,0,0,1,.631,0c.3.058.406.186.232.288L137,381.04a1.479,1.479,0,0,1-.862.077c-.3-.057-.406-.186-.232-.288l8.887-5.13a.763.763,0,0,1,.231-.077",
    transform: "translate(73.231 202.516)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_707",
    "data-name": "Caminho 707",
    d: "M135.4,381.178a1.812,1.812,0,0,1,.631,0c.3.059.406.186.232.288l-8.889,5.132a1.491,1.491,0,0,1-.862.077c-.3-.059-.406-.188-.231-.288l8.887-5.132a.771.771,0,0,1,.231-.077",
    transform: "translate(68.042 205.512)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_708",
    "data-name": "Caminho 708",
    d: "M173.991,355.566a2.652,2.652,0,0,1,.948,0c.453.088.608.28.346.431l-14.81,8.552a2.227,2.227,0,0,1-1.294.115c-.453-.086-.608-.28-.346-.431l14.81-8.552a1.156,1.156,0,0,1,.346-.115",
    transform: "translate(85.573 191.695)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_709",
    "data-name": "Caminho 709",
    d: "M151.517,368.26a1.809,1.809,0,0,1,.631,0c.3.058.406.186.232.288l-8.889,5.13a1.492,1.492,0,0,1-.862.077c-.3-.057-.406-.186-.232-.286l8.889-5.132a.764.764,0,0,1,.231-.077",
    transform: "translate(76.734 198.547)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_710",
    "data-name": "Caminho 710",
    d: "M150.141,367.466a1.774,1.774,0,0,1,.631,0c.3.058.406.186.232.288l-8.887,5.132a1.5,1.5,0,0,1-.863.077c-.3-.058-.4-.188-.231-.288l8.887-5.132a.761.761,0,0,1,.231-.077",
    transform: "translate(75.992 198.119)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_711",
    "data-name": "Caminho 711",
    d: "M141.171,373.4a1.737,1.737,0,0,1,.631,0c.3.058.406.186.232.288l-8.887,5.13a1.48,1.48,0,0,1-.862.077c-.3-.057-.406-.186-.232-.288l8.887-5.13a.763.763,0,0,1,.231-.077",
    transform: "translate(71.156 201.317)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_712",
    "data-name": "Caminho 712",
    d: "M131.548,378.955a1.807,1.807,0,0,1,.631,0c.3.059.406.186.232.288l-8.889,5.132a1.477,1.477,0,0,1-.862.075c-.3-.057-.406-.186-.231-.286l8.887-5.132a.763.763,0,0,1,.231-.077",
    transform: "translate(65.967 204.314)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_713",
    "data-name": "Caminho 713",
    d: "M173.255,353.344a2.65,2.65,0,0,1,.948,0c.453.086.608.28.348.431l-23.7,13.683a2.255,2.255,0,0,1-1.294.115c-.453-.088-.608-.28-.348-.431l23.7-13.683a1.158,1.158,0,0,1,.346-.115",
    transform: "translate(80.385 190.497)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_714",
    "data-name": "Caminho 714",
    d: "M147.667,366.038a1.809,1.809,0,0,1,.631,0c.3.059.406.186.232.288l-8.889,5.13a1.467,1.467,0,0,1-.862.077c-.3-.057-.406-.186-.231-.286l8.887-5.132a.806.806,0,0,1,.231-.077",
    transform: "translate(74.658 197.349)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_715",
    "data-name": "Caminho 715",
    d: "M146.292,365.244a1.81,1.81,0,0,1,.631,0c.3.058.406.186.231.288l-8.887,5.13a1.49,1.49,0,0,1-.862.078c-.3-.058-.406-.188-.231-.288l8.887-5.132a.763.763,0,0,1,.231-.077",
    transform: "translate(73.917 196.921)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_716",
    "data-name": "Caminho 716",
    d: "M137.321,371.177a1.811,1.811,0,0,1,.631,0c.3.058.406.186.232.288l-8.887,5.13a1.467,1.467,0,0,1-.862.077c-.3-.057-.406-.186-.232-.288l8.887-5.13a.8.8,0,0,1,.231-.077",
    transform: "translate(69.08 200.12)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_717",
    "data-name": "Caminho 717",
    d: "M127.7,376.733a1.8,1.8,0,0,1,.63,0c.3.058.406.186.232.288l-8.889,5.13a1.461,1.461,0,0,1-.86.077c-.3-.057-.406-.186-.232-.286l8.889-5.132a.78.78,0,0,1,.231-.077",
    transform: "translate(63.891 203.116)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_718",
    "data-name": "Caminho 718",
    d: "M165.256,351.121a2.686,2.686,0,0,1,.948,0c.453.088.608.28.346.431L154.7,358.393a2.228,2.228,0,0,1-1.294.115c-.453-.088-.608-.28-.346-.431l11.849-6.842a1.156,1.156,0,0,1,.346-.115",
    transform: "translate(82.46 189.298)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_719",
    "data-name": "Caminho 719",
    d: "M143.818,363.816a1.808,1.808,0,0,1,.631,0c.3.058.406.186.231.288l-8.887,5.13a1.478,1.478,0,0,1-.862.077c-.3-.057-.406-.186-.231-.286l8.887-5.132a.808.808,0,0,1,.231-.077",
    transform: "translate(72.583 196.151)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_720",
    "data-name": "Caminho 720",
    d: "M142.442,363.021a1.774,1.774,0,0,1,.631,0c.3.059.406.186.231.288l-8.887,5.13a1.476,1.476,0,0,1-.862.079c-.3-.059-.406-.188-.231-.288l8.887-5.132a.767.767,0,0,1,.231-.077",
    transform: "translate(71.841 195.722)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_721",
    "data-name": "Caminho 721",
    d: "M133.472,368.954a1.807,1.807,0,0,1,.631,0c.3.059.406.186.231.288l-8.886,5.13a1.48,1.48,0,0,1-.862.077c-.3-.057-.406-.186-.232-.286l8.887-5.132a.763.763,0,0,1,.231-.077",
    transform: "translate(67.005 198.921)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M123.849,374.51a1.807,1.807,0,0,1,.631,0c.3.058.406.186.232.288l-8.889,5.13a1.464,1.464,0,0,1-.862.077c-.3-.057-.406-.186-.231-.286l8.887-5.132a.767.767,0,0,1,.231-.077",
    transform: "translate(61.816 201.917)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    "data-name": "Caminho 723",
    d: "M164.518,348.9a2.65,2.65,0,0,1,.948,0c.453.086.608.28.346.431L145.078,361.3a2.239,2.239,0,0,1-1.294.117c-.453-.088-.608-.282-.346-.433l20.734-11.972a1.154,1.154,0,0,1,.346-.115",
    transform: "translate(77.272 188.1)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_724",
    "data-name": "Caminho 724",
    d: "M139.969,361.593a1.813,1.813,0,0,1,.631,0c.3.059.406.186.231.288l-8.887,5.13a1.478,1.478,0,0,1-.862.077c-.3-.057-.406-.186-.231-.286l8.887-5.132a.809.809,0,0,1,.231-.077",
    transform: "translate(70.507 194.952)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M138.593,360.8a1.809,1.809,0,0,1,.631,0c.3.058.406.186.231.288l-8.887,5.132a1.491,1.491,0,0,1-.862.077c-.3-.058-.406-.188-.231-.288l8.887-5.132a.809.809,0,0,1,.231-.077",
    transform: "translate(69.766 194.524)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M129.623,366.732a1.809,1.809,0,0,1,.631,0c.3.058.406.186.231.288l-8.886,5.13a1.489,1.489,0,0,1-.862.078c-.3-.058-.406-.188-.231-.288l8.886-5.132a.813.813,0,0,1,.231-.077",
    transform: "translate(64.929 197.723)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_727",
    "data-name": "Caminho 727",
    d: "M120,372.288a1.808,1.808,0,0,1,.631,0c.3.058.406.186.231.288l-8.887,5.132a1.49,1.49,0,0,1-.862.077c-.3-.059-.406-.188-.231-.288l8.887-5.132a.81.81,0,0,1,.231-.077",
    transform: "translate(59.74 200.719)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_728",
    "data-name": "Caminho 728",
    d: "M123.849,363.4a1.811,1.811,0,0,1,.631,0c.3.059.406.186.231.288l-8.887,5.13a1.476,1.476,0,0,1-.862.078c-.3-.058-.406-.188-.231-.288l8.887-5.132a.764.764,0,0,1,.231-.077",
    transform: "translate(61.816 195.926)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_729",
    "data-name": "Caminho 729",
    d: "M114.225,368.955a1.813,1.813,0,0,1,.631,0c.3.058.406.186.231.288l-8.886,5.13a1.483,1.483,0,0,1-.863.077c-.3-.057-.4-.186-.231-.288l8.887-5.13a.753.753,0,0,1,.231-.077",
    transform: "translate(56.627 198.922)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_730",
    "data-name": "Caminho 730",
    d: "M121.924,362.287a1.81,1.81,0,0,1,.631,0c.3.059.406.186.231.288L113.9,367.7a1.477,1.477,0,0,1-.862.079c-.3-.058-.406-.188-.231-.288l8.887-5.132a.814.814,0,0,1,.231-.077",
    transform: "translate(60.778 195.326)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_731",
    "data-name": "Caminho 731",
    d: "M112.3,367.843a1.813,1.813,0,0,1,.631,0c.3.059.406.186.231.288l-8.886,5.13a1.48,1.48,0,0,1-.862.077c-.3-.057-.406-.186-.232-.288l8.887-5.13a.765.765,0,0,1,.231-.077",
    transform: "translate(55.589 198.322)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_732",
    "data-name": "Caminho 732",
    d: "M104.7,381.558l47.4-27.365-8.887-5.132-47.4,27.365Z",
    transform: "translate(51.659 188.21)",
    fill: "#7daf80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_733",
    "data-name": "Caminho 733",
    d: "M126.557,356.248a.263.263,0,0,1-.151.025.429.429,0,0,1-.169-.051l-.716-.414a.164.164,0,0,1-.088-.1.075.075,0,0,1,.043-.086l.891-.516-3.465-2a.172.172,0,0,1-.088-.1.074.074,0,0,1,.042-.088l.665-.383a.245.245,0,0,1,.149-.023.408.408,0,0,1,.169.049l3.465,2,.891-.516a.26.26,0,0,1,.149-.023.4.4,0,0,1,.169.049l.716.414a.173.173,0,0,1,.088.1.074.074,0,0,1-.042.088Z",
    transform: "translate(66.219 190.073)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_734",
    "data-name": "Caminho 734",
    d: "M125.665,354.855a2.656,2.656,0,0,1,.589.483,1.081,1.081,0,0,1,.271.514.739.739,0,0,1-.094.506,1.327,1.327,0,0,1-.517.465,2.536,2.536,0,0,1-.8.3,3.526,3.526,0,0,1-.882.055,3.9,3.9,0,0,1-.89-.157,4.447,4.447,0,0,1-.836-.339q-.3-.162-.617-.346c-.212-.122-.406-.239-.585-.348a2.615,2.615,0,0,1-.588-.483,1.1,1.1,0,0,1-.276-.516.708.708,0,0,1,.1-.508,1.387,1.387,0,0,1,.519-.462,2.549,2.549,0,0,1,.8-.3,3.48,3.48,0,0,1,.879-.055,4.111,4.111,0,0,1,.893.16,4.4,4.4,0,0,1,.837.339c.189.1.393.216.6.337s.411.242.6.357m-3.391.61c.077.048.163.1.26.162s.194.118.3.178.2.117.3.171.191.1.271.143a2.229,2.229,0,0,0,.363.149,1.749,1.749,0,0,0,.368.072,1.4,1.4,0,0,0,.36-.017,1.028,1.028,0,0,0,.334-.123.533.533,0,0,0,.214-.192.281.281,0,0,0,.029-.209.533.533,0,0,0-.125-.212,1.345,1.345,0,0,0-.259-.209c-.068-.048-.151-.1-.246-.157l-.3-.175c-.1-.06-.206-.119-.3-.174s-.2-.106-.283-.149a2.091,2.091,0,0,0-.736-.222,1.109,1.109,0,0,0-.693.142c-.209.12-.289.252-.243.4a.9.9,0,0,0,.385.426",
    transform: "translate(64.933 190.688)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_735",
    "data-name": "Caminho 735",
    d: "M122.2,358.765a.262.262,0,0,1-.151.025.4.4,0,0,1-.168-.051l-.717-.414a.156.156,0,0,1-.086-.1.073.073,0,0,1,.042-.086l.893-.516-3.465-2a.173.173,0,0,1-.088-.1.074.074,0,0,1,.042-.088l.663-.383a.262.262,0,0,1,.151-.025.411.411,0,0,1,.169.051l3.465,2,.891-.514a.257.257,0,0,1,.149-.026.42.42,0,0,1,.169.051l.716.414a.164.164,0,0,1,.088.1.074.074,0,0,1-.042.088Z",
    transform: "translate(63.868 191.43)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_736",
    "data-name": "Caminho 736",
    d: "M121.615,359.631a.376.376,0,0,1-.228.046,1.024,1.024,0,0,1-.222-.043l-5.361-1.819a.7.7,0,0,1-.12-.046.138.138,0,0,1-.071-.08.059.059,0,0,1,.034-.071l.639-.368a.349.349,0,0,1,.2-.051.625.625,0,0,1,.165.034l.7.242,1.347-.777-.419-.406a.188.188,0,0,1-.058-.094c-.009-.04.02-.079.088-.117l.637-.369a.225.225,0,0,1,.122-.02.324.324,0,0,1,.139.042.382.382,0,0,1,.082.071l3.149,3.094a.286.286,0,0,1,.075.128c.014.049-.012.094-.079.132Zm-2.13-2.178-.82.474,2.032.7Z",
    transform: "translate(62.337 191.784)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_737",
    "data-name": "Caminho 737",
    d: "M114.779,359.176a.26.26,0,0,1-.151.025.434.434,0,0,1-.168-.051l-.716-.414a.168.168,0,0,1-.088-.1.072.072,0,0,1,.042-.086l2.346-1.355a.263.263,0,0,1,.151-.025.421.421,0,0,1,.168.051l4.364,2.52a.156.156,0,0,1,.086.1.07.07,0,0,1-.042.086l-.662.383a.265.265,0,0,1-.151.025.4.4,0,0,1-.169-.051l-3.465-2Z",
    transform: "translate(61.281 192.584)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_738",
    "data-name": "Caminho 738",
    d: "M111.778,365.08a2.8,2.8,0,0,1-.63.142,3.586,3.586,0,0,1-.614.008,3.064,3.064,0,0,1-.546-.094,2.346,2.346,0,0,1-.423-.157c-.058-.029-.089-.062-.094-.1a.08.08,0,0,1,.049-.086l.352-.2a.355.355,0,0,1,.174-.049.979.979,0,0,1,.2.023,1.933,1.933,0,0,0,.523.037,1.369,1.369,0,0,0,.583-.192.839.839,0,0,0,.214-.168.385.385,0,0,0,.1-.182.26.26,0,0,0-.034-.18.47.47,0,0,0-.18-.162.9.9,0,0,0-.306-.114,1.121,1.121,0,0,0-.349.006,3.815,3.815,0,0,0-.451.108c-.171.052-.377.117-.616.192a5.248,5.248,0,0,1-.72.179,2.836,2.836,0,0,1-.628.034,2.3,2.3,0,0,1-.574-.108,3.06,3.06,0,0,1-.549-.253,1.637,1.637,0,0,1-.419-.328.8.8,0,0,1-.192-.365.616.616,0,0,1,.049-.379,1.071,1.071,0,0,1,.3-.371l-.459-.265a.162.162,0,0,1-.089-.1.072.072,0,0,1,.042-.086l.411-.237a.261.261,0,0,1,.151-.025.382.382,0,0,1,.168.051l.459.265a3.079,3.079,0,0,1,.588-.155,3.239,3.239,0,0,1,.622-.043,3.09,3.09,0,0,1,.617.077,2.286,2.286,0,0,1,.57.212c.057.029.088.062.092.1a.079.079,0,0,1-.048.086l-.354.2a.371.371,0,0,1-.171.052.727.727,0,0,1-.2-.026c-.083-.02-.171-.037-.263-.052a1.4,1.4,0,0,0-.292-.011,1.689,1.689,0,0,0-.326.06,1.672,1.672,0,0,0-.365.16,1.561,1.561,0,0,0-.263.188.488.488,0,0,0-.148.2.276.276,0,0,0,0,.2.421.421,0,0,0,.194.188.749.749,0,0,0,.314.1,1.273,1.273,0,0,0,.377-.031,4.7,4.7,0,0,0,.485-.131c.185-.058.4-.125.648-.2a4.517,4.517,0,0,1,.636-.143,2.612,2.612,0,0,1,.586-.025,2.412,2.412,0,0,1,.568.114,3.125,3.125,0,0,1,.583.268,1.532,1.532,0,0,1,.411.325.867.867,0,0,1,.191.352.569.569,0,0,1-.025.357.9.9,0,0,1-.239.337l.46.265a.173.173,0,0,1,.088.1.074.074,0,0,1-.043.088l-.409.237a.252.252,0,0,1-.151.023.382.382,0,0,1-.168-.051Z",
    transform: "translate(57.395 194.976)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_739",
    "data-name": "Caminho 739",
    d: "M109.491,366.4a2.727,2.727,0,0,1-.628.14,3.309,3.309,0,0,1-.616.008,2.784,2.784,0,0,1-.546-.092,2.449,2.449,0,0,1-.425-.157c-.055-.031-.088-.062-.092-.1a.081.081,0,0,1,.049-.086l.354-.2a.319.319,0,0,1,.172-.051,1.073,1.073,0,0,1,.2.023,1.892,1.892,0,0,0,.525.037,1.347,1.347,0,0,0,.583-.194.84.84,0,0,0,.214-.166.387.387,0,0,0,.1-.18.27.27,0,0,0-.032-.182.479.479,0,0,0-.18-.16.848.848,0,0,0-.309-.115,1.126,1.126,0,0,0-.349.008,3.556,3.556,0,0,0-.449.108c-.169.051-.376.114-.616.192a4.955,4.955,0,0,1-.72.176,2.843,2.843,0,0,1-.628.037,2.3,2.3,0,0,1-.574-.109,3.121,3.121,0,0,1-.551-.252,1.656,1.656,0,0,1-.417-.328.791.791,0,0,1-.191-.365.6.6,0,0,1,.048-.377,1.045,1.045,0,0,1,.3-.372l-.459-.265a.162.162,0,0,1-.089-.1.074.074,0,0,1,.042-.086l.409-.237a.254.254,0,0,1,.151-.025.371.371,0,0,1,.171.052l.459.263a3.04,3.04,0,0,1,.586-.154,3.271,3.271,0,0,1,.623-.045,2.951,2.951,0,0,1,.614.077,2.371,2.371,0,0,1,.571.212c.058.031.089.062.094.1a.082.082,0,0,1-.049.086l-.354.2a.367.367,0,0,1-.171.052.8.8,0,0,1-.2-.025c-.083-.02-.169-.038-.263-.054a1.3,1.3,0,0,0-.291-.009,1.564,1.564,0,0,0-.328.058,1.744,1.744,0,0,0-.366.16,1.635,1.635,0,0,0-.262.189.488.488,0,0,0-.148.2.289.289,0,0,0,0,.2.42.42,0,0,0,.194.186.74.74,0,0,0,.314.1,1.338,1.338,0,0,0,.379-.029c.142-.031.3-.074.485-.132s.4-.123.646-.194a4.169,4.169,0,0,1,.636-.143,2.452,2.452,0,0,1,.588-.025,2.352,2.352,0,0,1,.566.112,3.388,3.388,0,0,1,.583.266,1.57,1.57,0,0,1,.411.325.9.9,0,0,1,.192.354.6.6,0,0,1-.025.359.962.962,0,0,1-.239.336l.459.265a.168.168,0,0,1,.088.1.071.071,0,0,1-.043.086l-.409.24a.291.291,0,0,1-.151.023.378.378,0,0,1-.168-.052Z",
    transform: "translate(56.162 195.687)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_740",
    "data-name": "Caminho 740",
    d: "M107.2,367.721a2.636,2.636,0,0,1-.63.14,3.289,3.289,0,0,1-.613.008,2.9,2.9,0,0,1-.548-.092,2.239,2.239,0,0,1-.423-.157c-.057-.029-.089-.062-.094-.1a.081.081,0,0,1,.048-.086l.354-.2a.34.34,0,0,1,.174-.049,1.112,1.112,0,0,1,.2.023,1.935,1.935,0,0,0,.523.037,1.349,1.349,0,0,0,.583-.192.871.871,0,0,0,.214-.168.384.384,0,0,0,.1-.182.269.269,0,0,0-.032-.18.5.5,0,0,0-.18-.162.907.907,0,0,0-.308-.114,1.121,1.121,0,0,0-.349.006,3.568,3.568,0,0,0-.451.109c-.171.051-.376.115-.616.191a5.062,5.062,0,0,1-.719.178,2.947,2.947,0,0,1-.63.036,2.235,2.235,0,0,1-.574-.111,2.911,2.911,0,0,1-.551-.251,1.62,1.62,0,0,1-.417-.328.777.777,0,0,1-.191-.365.594.594,0,0,1,.048-.379,1.039,1.039,0,0,1,.3-.369l-.459-.265a.163.163,0,0,1-.089-.1.073.073,0,0,1,.042-.086l.411-.237a.26.26,0,0,1,.149-.025.4.4,0,0,1,.169.051l.459.265a2.94,2.94,0,0,1,.588-.154,3.264,3.264,0,0,1,.623-.045,3.069,3.069,0,0,1,.614.077,2.306,2.306,0,0,1,.571.212c.057.029.089.061.094.1a.081.081,0,0,1-.048.086l-.356.2a.351.351,0,0,1-.172.052.69.69,0,0,1-.2-.026c-.082-.02-.169-.037-.262-.052a1.306,1.306,0,0,0-.292-.009,1.576,1.576,0,0,0-.326.059,1.612,1.612,0,0,0-.365.162,1.479,1.479,0,0,0-.263.186.487.487,0,0,0-.148.2.276.276,0,0,0,0,.2.422.422,0,0,0,.194.188.751.751,0,0,0,.314.1,1.39,1.39,0,0,0,.377-.031c.142-.031.3-.074.486-.132s.4-.123.648-.194a4.475,4.475,0,0,1,.634-.145,2.522,2.522,0,0,1,.588-.023,2.429,2.429,0,0,1,.566.112,3.217,3.217,0,0,1,.583.266,1.548,1.548,0,0,1,.411.326.859.859,0,0,1,.191.353.574.574,0,0,1-.025.359.929.929,0,0,1-.239.336l.46.265a.17.17,0,0,1,.088.1.072.072,0,0,1-.043.086l-.409.237a.27.27,0,0,1-.149.024.421.421,0,0,1-.169-.051Z",
    transform: "translate(54.928 196.4)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_741",
    "data-name": "Caminho 741",
    d: "M104.917,369.042a2.725,2.725,0,0,1-.63.14,3.416,3.416,0,0,1-.614.009,3.066,3.066,0,0,1-.548-.094,2.211,2.211,0,0,1-.423-.158c-.057-.028-.088-.06-.094-.1a.082.082,0,0,1,.049-.086l.354-.2a.332.332,0,0,1,.174-.049.953.953,0,0,1,.2.023,1.944,1.944,0,0,0,.525.037,1.354,1.354,0,0,0,.583-.192.941.941,0,0,0,.214-.168.394.394,0,0,0,.1-.182.251.251,0,0,0-.032-.18.47.47,0,0,0-.18-.162.907.907,0,0,0-.308-.114,1.171,1.171,0,0,0-.349.006,3.545,3.545,0,0,0-.449.109c-.171.051-.377.115-.616.191a5.3,5.3,0,0,1-.72.178,2.929,2.929,0,0,1-.628.035,2.249,2.249,0,0,1-.576-.111,2.9,2.9,0,0,1-.549-.251,1.628,1.628,0,0,1-.417-.328.8.8,0,0,1-.192-.365.6.6,0,0,1,.049-.379,1.049,1.049,0,0,1,.3-.369l-.459-.266a.162.162,0,0,1-.089-.1.075.075,0,0,1,.043-.086l.409-.237a.255.255,0,0,1,.151-.025.39.39,0,0,1,.169.051l.459.265a3.038,3.038,0,0,1,.586-.155,3.409,3.409,0,0,1,.623-.043,3.086,3.086,0,0,1,.616.077,2.334,2.334,0,0,1,.571.212c.057.029.088.062.092.1a.081.081,0,0,1-.048.086l-.354.2a.376.376,0,0,1-.172.052.683.683,0,0,1-.2-.026c-.082-.02-.169-.037-.263-.052a1.392,1.392,0,0,0-.291-.011,1.579,1.579,0,0,0-.693.22,1.628,1.628,0,0,0-.263.188.483.483,0,0,0-.146.2.269.269,0,0,0,0,.2.416.416,0,0,0,.192.188.748.748,0,0,0,.316.1,1.33,1.33,0,0,0,.377-.029c.142-.031.3-.074.485-.132s.4-.123.648-.194a4.36,4.36,0,0,1,.634-.145,2.533,2.533,0,0,1,.588-.023,2.4,2.4,0,0,1,.566.112,3.225,3.225,0,0,1,.585.266,1.562,1.562,0,0,1,.409.326.862.862,0,0,1,.192.353.58.58,0,0,1-.025.357.953.953,0,0,1-.239.337l.46.265a.172.172,0,0,1,.088.1.073.073,0,0,1-.043.088l-.409.235a.264.264,0,0,1-.151.026.426.426,0,0,1-.169-.051Z",
    transform: "translate(53.695 197.111)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_742",
    "data-name": "Caminho 742",
    d: "M153.907,343.4a1.8,1.8,0,0,1,.63,0c.3.058.406.186.232.288l-17.776,10.262a1.477,1.477,0,0,1-.862.077c-.3-.059-.4-.186-.231-.288l17.775-10.262a.744.744,0,0,1,.232-.077",
    transform: "translate(73.231 185.141)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_743",
    "data-name": "Caminho 743",
    d: "M151.982,342.286a1.778,1.778,0,0,1,.631,0c.3.059.406.186.231.288l-17.773,10.262a1.484,1.484,0,0,1-.863.077c-.3-.059-.4-.186-.231-.288l17.775-10.262a.765.765,0,0,1,.231-.077",
    transform: "translate(72.193 184.542)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_744",
    "data-name": "Caminho 744",
    d: "M150.057,341.175a1.809,1.809,0,0,1,.631,0c.3.058.406.186.231.288l-17.775,10.262a1.478,1.478,0,0,1-.862.077c-.3-.058-.4-.186-.231-.288l17.775-10.262a.8.8,0,0,1,.231-.077",
    transform: "translate(71.155 183.943)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    "data-name": "Caminho 745",
    d: "M225.233,358.949a1.914,1.914,0,0,1,1.125,1.561c0,.571.025,5.352.014,5.927a1.923,1.923,0,0,1-1.125,1.547l-41.3,23.847a6.01,6.01,0,0,1-5.436,0L104.8,349.275a1.912,1.912,0,0,1-1.127-1.57c0-.568,0-5.313-.012-5.874a1.894,1.894,0,0,1,1.125-1.592l41.3-23.847a6.01,6.01,0,0,1,5.436,0Z",
    transform: "translate(55.891 170.246)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_746",
    "data-name": "Caminho 746",
    d: "M104.783,343.379l73.709,42.556a6.009,6.009,0,0,0,5.436,0l41.3-23.847c1.5-.867,1.5-2.272,0-3.138l-73.709-42.556a6,6,0,0,0-5.436,0l-41.3,23.847c-1.5.867-1.5,2.272,0,3.138",
    transform: "translate(55.891 170.245)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_747",
    "data-name": "Caminho 747",
    d: "M121.405,334.524a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.853,1.853,0,0,1,1.6.2l5.146,2.971c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(58.167 177.469)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    "data-name": "Caminho 748",
    d: "M107.884,331.662l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.328,2.328,0,0,0,.916.292v-1.471a2.328,2.328,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(58.167 178.829)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_749",
    "data-name": "Caminho 749",
    d: "M119.1,331.691a.33.33,0,0,1-.186.272l-6.071,3.5a1.143,1.143,0,0,1-.685.1l0,1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(60.474 178.844)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_750",
    "data-name": "Caminho 750",
    d: "M114.138,329.248l-6.069,3.5c-.348.2-.2.613.339.922l5.146,2.972a1.862,1.862,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.924l-5.144-2.971a1.861,1.861,0,0,0-1.6-.2",
    transform: "translate(58.169 177.469)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_751",
    "data-name": "Caminho 751",
    d: "M128.445,330.46a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.145-2.972c-.34-.2-.525-.434-.526-.633,0-.116,0-1.273,0-1.471a.332.332,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.109,0,1.265,0,1.465",
    transform: "translate(61.963 175.278)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_752",
    "data-name": "Caminho 752",
    d: "M114.924,327.6l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.329,2.329,0,0,0,.916.292v-1.471a2.33,2.33,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(61.963 176.637)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_753",
    "data-name": "Caminho 753",
    d: "M126.141,327.627a.33.33,0,0,1-.186.272l-6.071,3.5a1.149,1.149,0,0,1-.686.1v1.47a1.174,1.174,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(64.27 176.653)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_754",
    "data-name": "Caminho 754",
    d: "M121.177,325.184l-6.069,3.5c-.348.2-.2.614.339.923l5.146,2.971a1.858,1.858,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.923l-5.144-2.971a1.862,1.862,0,0,0-1.6-.2",
    transform: "translate(61.964 175.278)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    "data-name": "Caminho 755",
    d: "M135.485,326.395a.333.333,0,0,1-.186.286l-6.071,3.5a1.847,1.847,0,0,1-1.6-.2l-5.146-2.972c-.34-.194-.525-.432-.526-.631,0-.117,0-1.273,0-1.473a.333.333,0,0,1,.186-.289l6.071-3.5a1.862,1.862,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.112,0,1.267,0,1.465",
    transform: "translate(65.759 173.086)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_756",
    "data-name": "Caminho 756",
    d: "M133.18,323.562a.332.332,0,0,1-.186.272l-6.069,3.5a1.16,1.16,0,0,1-.686.1l0,1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.336.336,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(68.066 174.461)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224",
    transform: "translate(187.717 497.979)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_757",
    "data-name": "Caminho 757",
    d: "M121.964,323.533l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.328,2.328,0,0,0,.916.293v-1.471a2.328,2.328,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-121.957 -323.533)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_758",
    "data-name": "Caminho 758",
    d: "M135.493,334.529a.331.331,0,0,1-.186.285l-6.071,3.5a1.851,1.851,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.114,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.853,1.853,0,0,1,1.6.2l5.145,2.971c.345.2.531.442.526.644,0,.111,0,1.265,0,1.465",
    transform: "translate(65.763 177.472)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_759",
    "data-name": "Caminho 759",
    d: "M133.189,331.7a.33.33,0,0,1-.186.272l-6.071,3.5a1.144,1.144,0,0,1-.685.1l0,1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(68.071 178.847)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_227",
    "data-name": "Grupo 227",
    transform: "translate(187.73 510.497)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_225",
    "data-name": "Grupo 225",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_760",
    "data-name": "Caminho 760",
    d: "M121.972,331.666l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.329,2.329,0,0,0,.916.292v-1.471a2.329,2.329,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-121.967 -331.666)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_761",
    "data-name": "Caminho 761",
    d: "M149.572,326.4a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.329.329,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.109,0,1.265,0,1.465",
    transform: "translate(73.355 173.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_762",
    "data-name": "Caminho 762",
    d: "M147.268,323.567a.33.33,0,0,1-.186.272l-6.071,3.5a1.154,1.154,0,0,1-.685.1l0,1.47a1.189,1.189,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(75.662 174.464)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_230",
    "data-name": "Grupo 230",
    transform: "translate(209.401 497.985)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_229",
    "data-name": "Grupo 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_228",
    "data-name": "Grupo 228",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_763",
    "data-name": "Caminho 763",
    d: "M136.051,323.537a.033.033,0,0,0,0,.017c0,.2,0,1.358,0,1.473,0,.2.186.439.525.634l5.146,2.972a2.35,2.35,0,0,0,.916.291v-1.471a2.305,2.305,0,0,1-.914-.293l-5.141-2.972c-.351-.2-.536-.445-.526-.651",
    transform: "translate(-136.046 -323.537)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_764",
    "data-name": "Caminho 764",
    d: "M142.533,330.465a.331.331,0,0,1-.186.285l-6.071,3.5a1.856,1.856,0,0,1-1.6-.2l-5.144-2.972c-.34-.2-.525-.434-.526-.633,0-.116,0-1.271,0-1.471a.332.332,0,0,1,.186-.289l6.071-3.5a1.862,1.862,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(69.559 175.281)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_765",
    "data-name": "Caminho 765",
    d: "M140.228,327.631a.33.33,0,0,1-.186.272l-6.071,3.5a1.144,1.144,0,0,1-.685.1l0,1.47a1.176,1.176,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(71.866 176.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_233",
    "data-name": "Grupo 233",
    transform: "translate(198.565 504.242)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_231",
    "data-name": "Grupo 231",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_766",
    "data-name": "Caminho 766",
    d: "M129.012,327.6l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.328,2.328,0,0,0,.916.292v-1.471a2.329,2.329,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-129.005 -327.602)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_767",
    "data-name": "Caminho 767",
    d: "M142.538,338.6a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.145-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(69.562 179.665)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_768",
    "data-name": "Caminho 768",
    d: "M140.234,335.763a.328.328,0,0,1-.186.272l-6.071,3.5a1.144,1.144,0,0,1-.685.1l0,1.468a1.176,1.176,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.282c0-.2,0-1.318,0-1.461",
    transform: "translate(71.869 181.04)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(198.574 516.758)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_235",
    "data-name": "Grupo 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_234",
    "data-name": "Grupo 234",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_769",
    "data-name": "Caminho 769",
    d: "M129.017,335.734l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.331,2.331,0,0,0,.916.292V339.65a2.332,2.332,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-129.012 -335.734)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_770",
    "data-name": "Caminho 770",
    d: "M156.618,330.468a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.273,0-1.471a.329.329,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.145,2.972c.345.2.531.442.525.643,0,.109,0,1.265,0,1.465",
    transform: "translate(77.154 175.282)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_771",
    "data-name": "Caminho 771",
    d: "M154.315,327.635a.335.335,0,0,1-.188.272l-6.069,3.5a1.15,1.15,0,0,1-.686.1l0,1.47a1.177,1.177,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(79.46 176.658)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239",
    transform: "translate(220.244 504.246)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_772",
    "data-name": "Caminho 772",
    d: "M143.1,327.605l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.332,2.332,0,0,0,.916.292v-1.471a2.331,2.331,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-143.09 -327.605)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_773",
    "data-name": "Caminho 773",
    d: "M149.578,334.532a.331.331,0,0,1-.186.285l-6.071,3.5a1.855,1.855,0,0,1-1.6-.2l-5.144-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.273,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(73.358 177.473)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_774",
    "data-name": "Caminho 774",
    d: "M147.274,331.7a.33.33,0,0,1-.186.272l-6.069,3.5a1.15,1.15,0,0,1-.686.1l0,1.47a1.177,1.177,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(75.665 178.849)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    transform: "translate(209.41 510.503)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_241",
    "data-name": "Grupo 241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_775",
    "data-name": "Caminho 775",
    d: "M136.057,331.67l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.332,2.332,0,0,0,.914.292l0-1.472a2.33,2.33,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-136.052 -331.67)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_776",
    "data-name": "Caminho 776",
    d: "M149.585,342.665a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.114,0-1.271,0-1.471a.332.332,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(73.362 181.859)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_777",
    "data-name": "Caminho 777",
    d: "M147.281,339.832a.33.33,0,0,1-.186.272l-6.069,3.5a1.148,1.148,0,0,1-.686.1l0,1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(75.669 183.234)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245",
    transform: "translate(209.421 523.02)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    "data-name": "Grupo 243",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_778",
    "data-name": "Caminho 778",
    d: "M136.064,339.8l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.331,2.331,0,0,0,.914.292l0-1.471a2.332,2.332,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-136.059 -339.802)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_779",
    "data-name": "Caminho 779",
    d: "M163.664,334.536a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.145-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.145,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(80.953 177.475)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_780",
    "data-name": "Caminho 780",
    d: "M161.36,331.7a.332.332,0,0,1-.186.272l-6.071,3.5a1.16,1.16,0,0,1-.686.1v1.47a1.176,1.176,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(83.26 178.851)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248",
    transform: "translate(231.091 510.509)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    "data-name": "Grupo 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_781",
    "data-name": "Caminho 781",
    d: "M150.143,331.674l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.33,2.33,0,0,0,.916.292V335.59a2.331,2.331,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-150.138 -331.674)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    "data-name": "Caminho 782",
    d: "M156.625,338.6a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.273,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.145,2.972c.345.2.531.442.525.643,0,.109,0,1.265,0,1.465",
    transform: "translate(77.158 179.667)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    "data-name": "Caminho 783",
    d: "M154.321,335.768a.336.336,0,0,1-.186.272l-6.071,3.5a1.149,1.149,0,0,1-.686.1v1.47a1.18,1.18,0,0,0,.683-.1l6.067-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(79.465 181.043)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_251",
    "data-name": "Grupo 251",
    transform: "translate(220.257 516.765)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_250",
    "data-name": "Grupo 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    "data-name": "Grupo 249",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_784",
    "data-name": "Caminho 784",
    d: "M143.1,335.738l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.33,2.33,0,0,0,.916.292v-1.471a2.33,2.33,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(-143.099 -335.738)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_785",
    "data-name": "Caminho 785",
    d: "M142.524,322.331a.331.331,0,0,1-.186.285l-6.071,3.5a1.851,1.851,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2L142,320.223c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(69.554 170.895)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_786",
    "data-name": "Caminho 786",
    d: "M129,319.468l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.329,2.329,0,0,0,.916.292v-1.471a2.329,2.329,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(69.554 172.254)",
    fill: "#658d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    "data-name": "Caminho 787",
    d: "M140.22,319.5a.332.332,0,0,1-.186.272l-6.069,3.5a1.16,1.16,0,0,1-.686.1l0,1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(71.862 172.27)",
    fill: "#93cd96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    "data-name": "Caminho 788",
    d: "M135.257,317.055l-6.069,3.5c-.348.2-.2.614.339.923l5.146,2.971a1.858,1.858,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.923l-5.144-2.971a1.862,1.862,0,0,0-1.6-.2",
    transform: "translate(69.556 170.895)",
    fill: "#7daf80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_789",
    "data-name": "Caminho 789",
    d: "M128.453,338.593a.333.333,0,0,1-.186.286l-6.071,3.5a1.846,1.846,0,0,1-1.6-.2l-5.145-2.972c-.34-.2-.525-.434-.526-.631,0-.117,0-1.273,0-1.473a.333.333,0,0,1,.186-.289l6.071-3.5a1.854,1.854,0,0,1,1.6.2l5.146,2.969c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(61.967 179.663)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    "data-name": "Caminho 790",
    d: "M114.932,335.731l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.437.525.634l5.146,2.97a2.329,2.329,0,0,0,.914.293l0-1.472a2.327,2.327,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(61.967 181.023)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    "data-name": "Caminho 791",
    d: "M126.149,335.76a.33.33,0,0,1-.186.272l-6.069,3.5a1.153,1.153,0,0,1-.686.1l0,1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(64.275 181.039)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    "data-name": "Caminho 792",
    d: "M121.186,333.317l-6.071,3.5c-.346.2-.2.613.34.922l5.144,2.972a1.866,1.866,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.924l-5.144-2.971a1.861,1.861,0,0,0-1.6-.2",
    transform: "translate(61.969 179.663)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    "data-name": "Caminho 793",
    d: "M135.5,342.663a.331.331,0,0,1-.186.285l-6.071,3.5a1.851,1.851,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.858,1.858,0,0,1,1.6.2l5.145,2.971c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(65.768 181.858)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    "data-name": "Caminho 794",
    d: "M121.98,339.8l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.328,2.328,0,0,0,.916.292v-1.472a2.329,2.329,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(65.768 183.217)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_795",
    "data-name": "Caminho 795",
    d: "M133.2,339.829a.33.33,0,0,1-.186.274l-6.071,3.5a1.143,1.143,0,0,1-.685.1l0,1.468a1.164,1.164,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.461",
    transform: "translate(68.075 183.232)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_796",
    "data-name": "Caminho 796",
    d: "M128.234,337.387l-6.071,3.5c-.346.2-.2.614.34.923l5.144,2.971a1.861,1.861,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.613-.34-.922l-5.144-2.971a1.862,1.862,0,0,0-1.6-.2",
    transform: "translate(65.769 181.858)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_797",
    "data-name": "Caminho 797",
    d: "M142.549,346.732a.331.331,0,0,1-.186.285l-6.071,3.5a1.851,1.851,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.862,1.862,0,0,1,1.6.2l5.145,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(69.568 184.052)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_798",
    "data-name": "Caminho 798",
    d: "M129.028,343.869l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.33,2.33,0,0,0,.914.292l0-1.471a2.33,2.33,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(69.568 185.411)",
    fill: "#a03232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_799",
    "data-name": "Caminho 799",
    d: "M140.245,343.9a.33.33,0,0,1-.186.272l-6.071,3.5a1.161,1.161,0,0,1-.686.1v1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(71.875 185.427)",
    fill: "#d85b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    "data-name": "Caminho 800",
    d: "M135.282,341.456l-6.069,3.5c-.348.2-.2.614.339.924l5.146,2.971a1.858,1.858,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.923l-5.144-2.972a1.865,1.865,0,0,0-1.6-.2",
    transform: "translate(69.569 184.052)",
    fill: "#cc4040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    "data-name": "Caminho 801",
    d: "M170.716,338.608a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.114,0-1.271,0-1.472a.331.331,0,0,1,.186-.289l6.071-3.5a1.853,1.853,0,0,1,1.6.2l5.145,2.971c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(84.755 179.671)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    "data-name": "Caminho 802",
    d: "M157.195,335.745l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.437.525.634l5.145,2.971a2.327,2.327,0,0,0,.916.292v-1.471a2.332,2.332,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(84.755 181.03)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    "data-name": "Caminho 803",
    d: "M168.412,335.775a.33.33,0,0,1-.186.272l-6.071,3.5a1.143,1.143,0,0,1-.685.1l0,1.47a1.177,1.177,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(87.062 181.046)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_804",
    "data-name": "Caminho 804",
    d: "M163.449,333.332l-6.069,3.5c-.348.2-.2.614.339.924l5.146,2.971a1.858,1.858,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.924l-5.144-2.971a1.862,1.862,0,0,0-1.6-.2",
    transform: "translate(84.757 179.671)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_805",
    "data-name": "Caminho 805",
    d: "M163.677,342.672a.331.331,0,0,1-.186.285l-6.071,3.5a1.851,1.851,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.273,0-1.471a.332.332,0,0,1,.186-.289l6.071-3.5a1.857,1.857,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(80.96 181.862)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_806",
    "data-name": "Caminho 806",
    d: "M150.156,339.809l0,.017c0,.2,0,1.357,0,1.473,0,.2.186.439.525.634l5.146,2.972a2.35,2.35,0,0,0,.916.291v-1.47a2.309,2.309,0,0,1-.914-.294l-5.141-2.972c-.351-.2-.536-.445-.526-.651",
    transform: "translate(80.96 183.222)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_807",
    "data-name": "Caminho 807",
    d: "M161.372,339.839a.332.332,0,0,1-.186.272l-6.071,3.5a1.146,1.146,0,0,1-.685.1v1.47a1.175,1.175,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(83.267 183.238)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_808",
    "data-name": "Caminho 808",
    d: "M156.409,337.4l-6.071,3.5c-.346.2-.2.614.34.924l5.144,2.971a1.861,1.861,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.923l-5.144-2.971a1.862,1.862,0,0,0-1.6-.2",
    transform: "translate(80.961 181.863)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_809",
    "data-name": "Caminho 809",
    d: "M156.637,346.737a.331.331,0,0,1-.186.285l-6.071,3.5a1.851,1.851,0,0,1-1.6-.2l-5.146-2.972c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.328.328,0,0,1,.186-.289l6.071-3.5a1.858,1.858,0,0,1,1.6.2l5.145,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(77.164 184.054)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_810",
    "data-name": "Caminho 810",
    d: "M143.116,343.874l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.33,2.33,0,0,0,.914.292l0-1.471a2.33,2.33,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(77.164 185.413)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_811",
    "data-name": "Caminho 811",
    d: "M154.333,343.9a.328.328,0,0,1-.186.272l-6.069,3.5a1.16,1.16,0,0,1-.686.1l0,1.47a1.188,1.188,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(79.471 185.429)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_812",
    "data-name": "Caminho 812",
    d: "M149.37,341.461l-6.071,3.5c-.348.2-.2.614.339.924l5.144,2.971a1.862,1.862,0,0,0,1.6.2l6.071-3.5c.348-.2.2-.614-.339-.923l-5.146-2.971a1.859,1.859,0,0,0-1.6-.2",
    transform: "translate(77.165 184.054)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_813",
    "data-name": "Caminho 813",
    d: "M149.6,350.8a.331.331,0,0,1-.186.285l-6.071,3.5a1.852,1.852,0,0,1-1.6-.2L136.6,351.42c-.34-.2-.525-.434-.526-.633,0-.115,0-1.271,0-1.471a.331.331,0,0,1,.186-.289l6.071-3.5a1.863,1.863,0,0,1,1.6.2l5.146,2.972c.345.2.531.442.525.643,0,.111,0,1.265,0,1.465",
    transform: "translate(73.368 186.245)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    "data-name": "Caminho 814",
    d: "M136.076,347.938l0,.017c0,.2,0,1.358,0,1.473,0,.2.186.437.525.634l5.146,2.971a2.33,2.33,0,0,0,.914.292l0-1.471a2.331,2.331,0,0,1-.914-.292l-5.141-2.972c-.351-.2-.536-.446-.526-.651",
    transform: "translate(73.368 187.605)",
    fill: "#0076a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    "data-name": "Caminho 815",
    d: "M147.293,347.968a.332.332,0,0,1-.186.272l-6.069,3.5a1.16,1.16,0,0,1-.687.1l0,1.47a1.176,1.176,0,0,0,.683-.1l6.069-3.5a.334.334,0,0,0,.189-.283c0-.2,0-1.316,0-1.459",
    transform: "translate(75.675 187.621)",
    fill: "#589cd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    "data-name": "Caminho 816",
    d: "M142.33,345.525l-6.069,3.5c-.348.2-.2.613.339.922l5.146,2.972a1.862,1.862,0,0,0,1.6.2l6.071-3.5c.346-.2.2-.614-.34-.923l-5.144-2.971a1.862,1.862,0,0,0-1.6-.2",
    transform: "translate(73.369 186.246)",
    fill: "#008abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    "data-name": "Caminho 817",
    d: "M154.236,331.22a.274.274,0,0,1,.046.039l1.61,1.81,1.053-.606a.167.167,0,0,1,.1-.017.266.266,0,0,1,.117.034l.5.289a.113.113,0,0,1,.06.068.051.051,0,0,1-.029.06l-1.689.974a.166.166,0,0,1-.1.017.266.266,0,0,1-.117-.035l-.437-.252a.793.793,0,0,1-.185-.171l-1.612-1.815a.223.223,0,0,1-.04-.068c-.008-.022,0-.042.029-.057l.5-.286a.166.166,0,0,1,.092-.015.238.238,0,0,1,.1.032",
    transform: "translate(82.772 178.572)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    "data-name": "Caminho 818",
    d: "M149.976,336.3a1.056,1.056,0,0,1,.342.288.535.535,0,0,1,.112.314.514.514,0,0,1-.1.3.93.93,0,0,1-.3.263,1.7,1.7,0,0,1-.457.177,2.3,2.3,0,0,1-.528.06,2.329,2.329,0,0,1-.543-.065,1.92,1.92,0,0,1-.5-.2,1.273,1.273,0,0,1-.3-.228.619.619,0,0,1-.143-.246,2.43,2.43,0,0,1-.482-.072,1.822,1.822,0,0,1-.449-.185,1.032,1.032,0,0,1-.34-.289.527.527,0,0,1-.1-.317.541.541,0,0,1,.12-.314,1.085,1.085,0,0,1,.334-.28,1.881,1.881,0,0,1,.485-.194,2.391,2.391,0,0,1,.545-.069,2.291,2.291,0,0,1,.549.062,1.856,1.856,0,0,1,.5.2,1.118,1.118,0,0,1,.32.259.566.566,0,0,1,.128.277,2.315,2.315,0,0,1,.422.085,1.78,1.78,0,0,1,.4.172m-1.927-.42a.613.613,0,0,0-.326-.075.787.787,0,0,0-.386.117c-.131.076-.2.149-.2.223a.211.211,0,0,0,.132.188.623.623,0,0,0,.325.075.8.8,0,0,0,.386-.117c.132-.077.2-.151.2-.223a.21.21,0,0,0-.131-.188m1.284.8a.645.645,0,0,0-.319-.08.663.663,0,0,0-.34.091c-.106.061-.159.126-.157.2a.225.225,0,0,0,.139.183.626.626,0,0,0,.317.08.654.654,0,0,0,.342-.091c.106-.06.159-.126.157-.2a.228.228,0,0,0-.139-.185",
    transform: "translate(78.817 180.766)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    "data-name": "Caminho 819",
    d: "M142.664,340.273a1.306,1.306,0,0,1,.4.334.6.6,0,0,1,.139.346.517.517,0,0,1-.1.325.922.922,0,0,1-.3.269,1.7,1.7,0,0,1-.465.175,2.374,2.374,0,0,1-.562.059,2.635,2.635,0,0,1-.6-.08,2.229,2.229,0,0,1-.579-.234,1.556,1.556,0,0,1-.229-.159,1.272,1.272,0,0,1-.157-.16,1.214,1.214,0,0,1-.109-.159c-.031-.054-.06-.1-.085-.155l-.568-1.1a.317.317,0,0,0-.02-.057c-.009-.022,0-.042.035-.06l.562-.325a.125.125,0,0,1,.082-.012.262.262,0,0,1,.092.031.168.168,0,0,1,.032.025.056.056,0,0,1,.011.021l.4.75a2.168,2.168,0,0,1,.456-.118,2.5,2.5,0,0,1,.517-.022,2.632,2.632,0,0,1,.537.091,2.1,2.1,0,0,1,.517.217m-1.416.817a.838.838,0,0,0,.2.082.973.973,0,0,0,.217.026.9.9,0,0,0,.206-.022.568.568,0,0,0,.174-.065.326.326,0,0,0,.112-.1.2.2,0,0,0,.037-.118.216.216,0,0,0-.046-.126.453.453,0,0,0-.14-.117.765.765,0,0,0-.2-.082.947.947,0,0,0-.215-.026.832.832,0,0,0-.208.022.558.558,0,0,0-.172.065.3.3,0,0,0-.112.1.209.209,0,0,0-.038.119.231.231,0,0,0,.048.126.458.458,0,0,0,.14.117",
    transform: "translate(75.176 182.935)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_820",
    "data-name": "Caminho 820",
    d: "M146.555,327.5a.165.165,0,0,1,.1-.017.267.267,0,0,1,.117.035l.48.277,1.113-.642a.168.168,0,0,1,.1-.017.268.268,0,0,1,.117.035l.5.288a.365.365,0,0,1,.155.143l.72,1.635a.108.108,0,0,1,.009.072.128.128,0,0,1-.057.052l-.533.306a.168.168,0,0,1-.1.017.26.26,0,0,1-.117-.034l-1.809-1.045-.3.176a.17.17,0,0,1-.1.017.273.273,0,0,1-.118-.035l-.5-.288a.116.116,0,0,1-.062-.068.051.051,0,0,1,.029-.06l.3-.175-.48-.277a.116.116,0,0,1-.062-.068.052.052,0,0,1,.029-.062Zm1.438.74.867.5-.351-.8Z",
    transform: "translate(78.755 176.389)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_821",
    "data-name": "Caminho 821",
    d: "M140.988,331.832c-.045-.008-.092-.014-.145-.02a1.335,1.335,0,0,0-.159-.009.958.958,0,0,0-.171.02.534.534,0,0,0-.169.066.365.365,0,0,0-.115.1.18.18,0,0,0,0,.235.482.482,0,0,0,.149.122.73.73,0,0,0,.354.1.677.677,0,0,0,.357-.089.23.23,0,0,0,.075-.066.482.482,0,0,0,.042-.069c.009-.023.02-.043.028-.063a.081.081,0,0,1,.035-.042l.549-.319a.2.2,0,0,1,.109-.018.269.269,0,0,1,.114.037l1.575,1.033a.12.12,0,0,1,.059.068.047.047,0,0,1-.026.06l-1.511.873a.181.181,0,0,1-.1.017.3.3,0,0,1-.118-.035l-.5-.288a.121.121,0,0,1-.062-.068.054.054,0,0,1,.029-.062l1.028-.593-.394-.255a.357.357,0,0,1-.069.129.521.521,0,0,1-.151.122,1.618,1.618,0,0,1-.456.175,2.067,2.067,0,0,1-.52.051,2.314,2.314,0,0,1-.549-.085,2.384,2.384,0,0,1-.548-.232,1.488,1.488,0,0,1-.419-.334.59.59,0,0,1-.146-.337.479.479,0,0,1,.1-.319,1.06,1.06,0,0,1,.326-.276,1.853,1.853,0,0,1,.511-.2,2.27,2.27,0,0,1,1.064.012,1.83,1.83,0,0,1,.448.172.106.106,0,0,1,.051.055.042.042,0,0,1-.025.049l-.449.259a.213.213,0,0,1-.114.034.475.475,0,0,1-.088,0",
    transform: "translate(75.034 178.577)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_822",
    "data-name": "Caminho 822",
    d: "M132.675,336.8a1.377,1.377,0,0,1-.412-.336.6.6,0,0,1-.139-.346.529.529,0,0,1,.1-.328.98.98,0,0,1,.32-.28,1.717,1.717,0,0,1,.486-.185,2.438,2.438,0,0,1,.568-.06,2.5,2.5,0,0,1,.6.08,2.327,2.327,0,0,1,.58.237,1.442,1.442,0,0,1,.239.169,1.32,1.32,0,0,1,.16.166,1.243,1.243,0,0,1,.106.16c.029.052.055.1.083.149l.54,1.091a.223.223,0,0,0,.02.056c.009.021,0,.043-.037.062l-.56.325a.133.133,0,0,1-.083.011.246.246,0,0,1-.092-.031.113.113,0,0,1-.031-.025l-.012-.02-.369-.743a2.109,2.109,0,0,1-.473.132,2.491,2.491,0,0,1-.528.028,2.522,2.522,0,0,1-.545-.091,2.32,2.32,0,0,1-.526-.222m1.456-.84a.841.841,0,0,0-.22-.086.941.941,0,0,0-.225-.023.854.854,0,0,0-.212.026.733.733,0,0,0-.175.068.382.382,0,0,0-.117.1.2.2,0,0,0-.046.122.218.218,0,0,0,.046.129.423.423,0,0,0,.146.126.777.777,0,0,0,.219.085.968.968,0,0,0,.226.026.859.859,0,0,0,.209-.026.763.763,0,0,0,.176-.068.423.423,0,0,0,.117-.1.211.211,0,0,0,.046-.122.2.2,0,0,0-.043-.131.405.405,0,0,0-.146-.126",
    transform: "translate(71.24 180.774)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_823",
    "data-name": "Caminho 823",
    d: "M142.645,324.08a.238.238,0,0,1,.112.045.092.092,0,0,1,.045.071l.018.887c0,.022,0,.048,0,.078a.094.094,0,0,1-.055.075l-.431.249a.18.18,0,0,1-.1.015.283.283,0,0,1-.117-.034l-3.041-1.756a.116.116,0,0,1-.062-.068.052.052,0,0,1,.029-.062l.462-.266a.171.171,0,0,1,.1-.017.272.272,0,0,1,.119.035l2.058,1.187,0-.486a.061.061,0,0,1,.045-.055.225.225,0,0,1,.114-.009Z",
    transform: "translate(74.95 174.319)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_824",
    "data-name": "Caminho 824",
    d: "M133.994,329.341a2.02,2.02,0,0,1-.243-.165.927.927,0,0,1-.174-.185.744.744,0,0,1-.1-.214.787.787,0,0,1-.032-.254l-.006-.573-.885.511a.181.181,0,0,1-.1.017.273.273,0,0,1-.119-.035l-.5-.288a.121.121,0,0,1-.062-.068.05.05,0,0,1,.029-.06l1.866-1.077a.19.19,0,0,1,.1-.017.288.288,0,0,1,.117.035l.4.234a.567.567,0,0,1,.128.1.157.157,0,0,1,.048.12l-.048,1.191a.31.31,0,0,0,.068.219.685.685,0,0,0,.163.131.839.839,0,0,0,.1.048.681.681,0,0,0,.157.045.723.723,0,0,0,.192.006.474.474,0,0,0,.2-.066c.066-.039.106-.077.117-.119a.168.168,0,0,0-.006-.114.3.3,0,0,0-.066-.094c-.029-.029-.049-.051-.065-.065-.031-.032-.042-.058-.032-.082a.145.145,0,0,1,.066-.062l.434-.251a.145.145,0,0,1,.086-.014.245.245,0,0,1,.1.028,1.5,1.5,0,0,1,.329.265.715.715,0,0,1,.174.309.465.465,0,0,1-.045.325.8.8,0,0,1-.331.3,1.523,1.523,0,0,1-.5.185,2.073,2.073,0,0,1-.543.031,2.4,2.4,0,0,1-1.013-.3",
    transform: "translate(71.046 176.279)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_825",
    "data-name": "Caminho 825",
    d: "M128.037,333.868a.181.181,0,0,1-.1.017.274.274,0,0,1-.119-.035l-.5-.288a.166.166,0,0,1-.069-.069.329.329,0,0,1-.025-.066l-.148-.579a2.191,2.191,0,0,1-.765.075,1.779,1.779,0,0,1-.765-.242q-.531-.307-.525-.62t.5-.6a1.967,1.967,0,0,1,.531-.212,2.29,2.29,0,0,1,.542-.069,2.237,2.237,0,0,1,.5.054,1.576,1.576,0,0,1,.417.152.1.1,0,0,1,.051.055.042.042,0,0,1-.025.049l-.445.257a.286.286,0,0,1-.159.04c-.055,0-.115,0-.182-.006a1.255,1.255,0,0,0-.22.015.763.763,0,0,0-.262.1.422.422,0,0,0-.206.2q-.037.109.129.2a.572.572,0,0,0,.351.075.912.912,0,0,0,.356-.12l.294-.169a.192.192,0,0,1,.1-.017.291.291,0,0,1,.117.035l.4.234a.15.15,0,0,1,.069.069.317.317,0,0,1,.026.072l.129.506.922-.533a.194.194,0,0,1,.1-.017.3.3,0,0,1,.119.035l.5.288a.124.124,0,0,1,.062.069.052.052,0,0,1-.031.06Z",
    transform: "translate(67.409 178.568)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_826",
    "data-name": "Caminho 826",
    d: "M128.859,325.256a1.61,1.61,0,0,1-.559.2,2.246,2.246,0,0,1-.593.023,2.628,2.628,0,0,1-.6-.128,3.871,3.871,0,0,1-.559-.239c-.14-.075-.283-.155-.431-.242s-.283-.166-.408-.243a2.359,2.359,0,0,1-.414-.323.8.8,0,0,1-.22-.343.452.452,0,0,1,.038-.342.843.843,0,0,1,.351-.323,1.7,1.7,0,0,1,.559-.2,2.2,2.2,0,0,1,.594-.022,2.584,2.584,0,0,1,.594.126,3.716,3.716,0,0,1,.56.24c.134.071.274.149.422.236s.286.168.416.248a2.313,2.313,0,0,1,.416.323.805.805,0,0,1,.22.343.457.457,0,0,1-.038.343.868.868,0,0,1-.352.322m-2.467-.988c.257.16.52.311.791.457.083.042.165.078.243.109a1.021,1.021,0,0,0,.234.063.756.756,0,0,0,.228,0,.62.62,0,0,0,.219-.077.305.305,0,0,0,.134-.126.159.159,0,0,0,0-.132.419.419,0,0,0-.109-.135,1.4,1.4,0,0,0-.191-.14q-.374-.236-.791-.456a2.1,2.1,0,0,0-.24-.112,1.112,1.112,0,0,0-.235-.063.818.818,0,0,0-.229,0,.609.609,0,0,0-.219.077.313.313,0,0,0-.135.128.159.159,0,0,0,0,.132.379.379,0,0,0,.108.135,1.4,1.4,0,0,0,.194.139",
    transform: "translate(67.433 174.193)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_827",
    "data-name": "Caminho 827",
    d: "M162.873,335.56a.876.876,0,0,1,.125.017l1.11.257-1.559-.9a.115.115,0,0,1-.06-.069.051.051,0,0,1,.029-.06l.462-.266a.171.171,0,0,1,.1-.017.294.294,0,0,1,.119.034l3.041,1.756a.118.118,0,0,1,.06.068.051.051,0,0,1-.029.062l-.409.235a.247.247,0,0,1-.157.032c-.059-.006-.1-.012-.122-.017l-1.876-.423.733,1.084a.328.328,0,0,1,.029.069c.011.034-.008.065-.054.091l-.409.237a.182.182,0,0,1-.1.017.273.273,0,0,1-.118-.035l-3.041-1.756a.116.116,0,0,1-.062-.068.052.052,0,0,1,.031-.06l.462-.268a.2.2,0,0,1,.1-.017.3.3,0,0,1,.118.035l1.558.9-.445-.64a.277.277,0,0,1-.031-.072c-.006-.026.008-.051.043-.071l.226-.131a.2.2,0,0,1,.123-.025",
    transform: "translate(86.638 180.37)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_828",
    "data-name": "Caminho 828",
    d: "M162.319,337l-.165-.1-.222-.129c-.077-.045-.152-.088-.228-.129l-.177-.1a2.489,2.489,0,0,0-.239-.1,1.109,1.109,0,0,0-.252-.055,1,1,0,0,0-.254.009.731.731,0,0,0-.246.089.447.447,0,0,0-.16.137.217.217,0,0,0-.035.126.22.22,0,0,0,.045.112,1.009,1.009,0,0,0,.082.1.228.228,0,0,1,.068.083c.006.02-.011.04-.051.063l-.463.268a.153.153,0,0,1-.085.014.217.217,0,0,1-.1-.029,1.2,1.2,0,0,1-.365-.311.619.619,0,0,1-.134-.346.586.586,0,0,1,.1-.345.945.945,0,0,1,.34-.3,1.675,1.675,0,0,1,.554-.2,2.424,2.424,0,0,1,.617-.038,2.721,2.721,0,0,1,.623.111,2.919,2.919,0,0,1,.579.234c.134.069.274.149.422.234s.286.168.417.249a1.633,1.633,0,0,1,.406.332.771.771,0,0,1,.191.36.5.5,0,0,1-.066.355.926.926,0,0,1-.354.322,1.751,1.751,0,0,1-.525.2,2.625,2.625,0,0,1-.594.059,2.732,2.732,0,0,1-.6-.077,2.251,2.251,0,0,1-.54-.211.091.091,0,0,1-.049-.057.041.041,0,0,1,.023-.049l.463-.265a.191.191,0,0,1,.111-.031.606.606,0,0,1,.145.04c.048.015.1.032.163.046a1.119,1.119,0,0,0,.2.026,1.1,1.1,0,0,0,.219-.02.777.777,0,0,0,.236-.092.365.365,0,0,0,.155-.143.2.2,0,0,0,.015-.146.343.343,0,0,0-.1-.145,1.328,1.328,0,0,0-.175-.14",
    transform: "translate(85.915 181.063)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_829",
    "data-name": "Caminho 829",
    d: "M155.821,339.631a1.191,1.191,0,0,1,.123.017l1.11.257-1.559-.9a.118.118,0,0,1-.058-.069.049.049,0,0,1,.029-.06l.46-.266a.173.173,0,0,1,.1-.017.275.275,0,0,1,.119.035l3.041,1.755a.118.118,0,0,1,.06.068.051.051,0,0,1-.029.062l-.409.237a.254.254,0,0,1-.155.031c-.06-.006-.1-.012-.123-.017l-1.876-.423.733,1.084a.312.312,0,0,1,.029.069c.011.034-.006.065-.052.092l-.411.236a.181.181,0,0,1-.106.017.267.267,0,0,1-.117-.035l-3.041-1.756a.1.1,0,0,1-.06-.068.052.052,0,0,1,.028-.06l.463-.266a.17.17,0,0,1,.106-.017.265.265,0,0,1,.117.034l1.558.9-.443-.64a.257.257,0,0,1-.031-.072c-.006-.026.008-.051.043-.071l.226-.131a.2.2,0,0,1,.123-.025",
    transform: "translate(82.835 182.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_830",
    "data-name": "Caminho 830",
    d: "M156.219,342.173a2.022,2.022,0,0,1-.483.2,1.83,1.83,0,0,1-.509.066,1.949,1.949,0,0,1-.536-.08,2.462,2.462,0,0,1-.546-.236,1.346,1.346,0,0,1-.477-.4.4.4,0,0,1-.045-.385l-1.558-.394a.274.274,0,0,1-.062-.023.1.1,0,0,1-.051-.055.042.042,0,0,1,.025-.049l.48-.279a.229.229,0,0,1,.143-.032,1.051,1.051,0,0,1,.132.02l1.4.356.325-.186-1.008-.582a.118.118,0,0,1-.06-.068.05.05,0,0,1,.029-.061l.462-.266a.17.17,0,0,1,.1-.017.274.274,0,0,1,.119.035l3.041,1.755a.118.118,0,0,1,.06.068.052.052,0,0,1-.029.061Zm-1.028-1.054-.4.231a.315.315,0,0,0-.171.185c-.014.066.045.137.177.214a.654.654,0,0,0,.369.1.761.761,0,0,0,.322-.1l.4-.231Z",
    transform: "translate(81.931 183.163)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_831",
    "data-name": "Caminho 831",
    d: "M148.512,343.851a.9.9,0,0,1,.125.017l1.11.257-1.559-.9a.116.116,0,0,1-.06-.069.049.049,0,0,1,.029-.06l.462-.266a.17.17,0,0,1,.1-.017.3.3,0,0,1,.118.034l3.041,1.756a.117.117,0,0,1,.06.068.051.051,0,0,1-.029.062l-.409.235a.25.25,0,0,1-.157.032c-.059-.006-.1-.012-.122-.017l-1.876-.423.733,1.084a.328.328,0,0,1,.029.069c.011.034-.008.065-.054.091l-.409.237a.184.184,0,0,1-.106.017.267.267,0,0,1-.117-.035l-3.041-1.756a.117.117,0,0,1-.062-.068.053.053,0,0,1,.029-.06l.463-.268a.2.2,0,0,1,.1-.017.3.3,0,0,1,.118.035l1.558.9-.445-.64a.277.277,0,0,1-.031-.072c-.006-.026.008-.051.043-.071l.226-.131a.205.205,0,0,1,.123-.025",
    transform: "translate(78.894 184.841)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_832",
    "data-name": "Caminho 832",
    d: "M147.013,344.311a.177.177,0,0,1,.1-.017.28.28,0,0,1,.119.035l.474.274a.115.115,0,0,1,.062.068.052.052,0,0,1-.029.062l-1.113.642a.177.177,0,0,1-.1.017.267.267,0,0,1-.117-.035l-.476-.274a.113.113,0,0,1-.062-.069.053.053,0,0,1,.029-.06Z",
    transform: "translate(78.651 185.64)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_833",
    "data-name": "Caminho 833",
    d: "M141.649,347.813a1.2,1.2,0,0,1,.125.017l1.11.257-1.559-.9a.111.111,0,0,1-.06-.069.049.049,0,0,1,.029-.06l.462-.266a.169.169,0,0,1,.1-.017.3.3,0,0,1,.119.034l3.041,1.756a.115.115,0,0,1,.06.069.049.049,0,0,1-.029.06l-.409.237a.259.259,0,0,1-.157.031c-.058-.006-.1-.012-.122-.017l-1.876-.423.733,1.084a.364.364,0,0,1,.029.069c.011.034-.008.065-.054.091l-.409.237a.173.173,0,0,1-.106.017.267.267,0,0,1-.117-.035l-3.041-1.756a.117.117,0,0,1-.062-.068.051.051,0,0,1,.029-.06l.463-.266a.178.178,0,0,1,.1-.018.291.291,0,0,1,.117.035l1.559.9-.445-.64a.257.257,0,0,1-.031-.072c-.006-.026.008-.051.043-.071l.226-.131a.2.2,0,0,1,.123-.025",
    transform: "translate(75.194 186.977)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_834",
    "data-name": "Caminho 834",
    d: "M139.321,348.982l-.777-.448a.124.124,0,0,1-.062-.069.052.052,0,0,1,.031-.06l.445-.257a.189.189,0,0,1,.1-.017.292.292,0,0,1,.117.035l.777.449.546-.317a.2.2,0,0,1,.106-.017.3.3,0,0,1,.117.035l.476.276a.112.112,0,0,1,.062.068.053.053,0,0,1-.029.06l-.548.316.777.449a.113.113,0,0,1,.06.068.051.051,0,0,1-.029.06l-.445.257a.179.179,0,0,1-.1.017.267.267,0,0,1-.117-.035l-.777-.448-.543.314a.2.2,0,0,1-.1.017.3.3,0,0,1-.118-.035l-.476-.275a.113.113,0,0,1-.06-.068.049.049,0,0,1,.029-.06Z",
    transform: "translate(74.668 187.708)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_835",
    "data-name": "Caminho 835",
    d: "M134.7,343.675a.179.179,0,0,1,.1-.017.268.268,0,0,1,.117.035l.476.274a.116.116,0,0,1,.062.068.052.052,0,0,1-.029.061l-2.1,1.213a.193.193,0,0,1-.1.017.283.283,0,0,1-.117-.035l-.476-.274a.114.114,0,0,1-.062-.069.051.051,0,0,1,.029-.06Z",
    transform: "translate(71.482 185.297)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_836",
    "data-name": "Caminho 836",
    d: "M134.219,345.011c-.257-.148-.309-.359-.117-.471a.927.927,0,0,1,.816.068c.257.148.309.359.117.471a.928.928,0,0,1-.816-.068",
    transform: "translate(72.244 185.737)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    "data-name": "Caminho 837",
    d: "M132.478,344.005a.924.924,0,0,0,.814.068c.194-.112.142-.323-.115-.471a.928.928,0,0,0-.816-.068c-.192.113-.14.323.117.471",
    transform: "translate(71.305 185.194)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    "data-name": "Caminho 838",
    d: "M127.52,340.224l1.067.091a.275.275,0,0,1,.119.035.117.117,0,0,1,.062.068l.1.423a.053.053,0,0,1-.029.06.184.184,0,0,1-.106.017l-1.067-.089.152.613a.051.051,0,0,1-.029.06.173.173,0,0,1-.106.017l-.733-.06a.266.266,0,0,1-.117-.035.112.112,0,0,1-.062-.068l-.152-.613-1.057-.086a.275.275,0,0,1-.118-.035.122.122,0,0,1-.062-.068l-.1-.423a.052.052,0,0,1,.031-.06.168.168,0,0,1,.1-.017l1.057.085-.152-.614a.052.052,0,0,1,.031-.06.176.176,0,0,1,.1-.017l.733.06a.292.292,0,0,1,.117.035.116.116,0,0,1,.062.068Z",
    transform: "translate(67.549 183.026)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    "data-name": "Caminho 839",
    d: "M120.59,335.526a.178.178,0,0,1,.1-.017.273.273,0,0,1,.118.035l.474.274a.116.116,0,0,1,.062.068.052.052,0,0,1-.029.062l-2.1,1.213a.192.192,0,0,1-.1.017.282.282,0,0,1-.117-.035l-.476-.276a.112.112,0,0,1-.062-.068.051.051,0,0,1,.029-.06Z",
    transform: "translate(63.871 180.903)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    "data-name": "Caminho 840",
    d: "M136.58,321.036a.257.257,0,0,1-.16.032.778.778,0,0,1-.154-.029l-3.736-1.268a.725.725,0,0,1-.085-.032.1.1,0,0,1-.051-.055.041.041,0,0,1,.025-.049l.445-.257a.227.227,0,0,1,.14-.035.374.374,0,0,1,.115.023l.49.169.939-.543-.291-.282a.131.131,0,0,1-.042-.066c-.006-.028.014-.054.062-.082l.443-.257a.148.148,0,0,1,.086-.014.217.217,0,0,1,.1.029.246.246,0,0,1,.057.049l2.2,2.156a.2.2,0,0,1,.052.089q.014.051-.055.092Zm-1.485-1.518-.573.329,1.416.488Z",
    transform: "translate(71.386 171.618)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_841",
    "data-name": "Caminho 841",
    d: "M134.214,320.675c-.039-.025-.094-.059-.165-.1s-.145-.086-.222-.131-.152-.088-.228-.129-.134-.074-.177-.1a1.884,1.884,0,0,0-.239-.1,1.111,1.111,0,0,0-.252-.057.938.938,0,0,0-.254.009.733.733,0,0,0-.246.089.448.448,0,0,0-.16.137.217.217,0,0,0-.035.126.214.214,0,0,0,.045.112.849.849,0,0,0,.082.1.24.24,0,0,1,.068.083q.009.03-.051.065l-.463.266a.141.141,0,0,1-.085.014.232.232,0,0,1-.1-.029,1.209,1.209,0,0,1-.363-.311.624.624,0,0,1-.134-.346.6.6,0,0,1,.1-.345.98.98,0,0,1,.342-.3,1.711,1.711,0,0,1,.554-.2,2.488,2.488,0,0,1,.616-.038,2.809,2.809,0,0,1,.625.109,3.013,3.013,0,0,1,.579.235c.134.071.274.149.422.234s.286.168.417.249a1.666,1.666,0,0,1,.406.332.778.778,0,0,1,.191.36.5.5,0,0,1-.066.356.914.914,0,0,1-.354.322,1.758,1.758,0,0,1-.523.2,2.66,2.66,0,0,1-.6.059,2.731,2.731,0,0,1-.6-.077,2.209,2.209,0,0,1-.54-.211.089.089,0,0,1-.049-.055.04.04,0,0,1,.023-.049l.463-.266a.177.177,0,0,1,.111-.029.586.586,0,0,1,.145.039c.048.015.1.032.163.046a.893.893,0,0,0,.2.026,1,1,0,0,0,.219-.02.779.779,0,0,0,.235-.092.365.365,0,0,0,.155-.143.2.2,0,0,0,.015-.146.352.352,0,0,0-.1-.145,1.194,1.194,0,0,0-.175-.139",
    transform: "translate(70.762 172.26)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_842",
    "data-name": "Caminho 842",
    d: "M121.3,327.863a.165.165,0,0,1,.1-.017.265.265,0,0,1,.117.034l.476.276a.117.117,0,0,1,.062.068.052.052,0,0,1-.029.06l-2.007,1.159a.192.192,0,0,1-.1.017.288.288,0,0,1-.117-.035l-.476-.276a.108.108,0,0,1-.062-.068.051.051,0,0,1,.029-.06Zm-1.159-.67a.182.182,0,0,1,.1-.017.274.274,0,0,1,.119.035l.476.274a.118.118,0,0,1,.06.068.052.052,0,0,1-.029.062l-2.006,1.158a.17.17,0,0,1-.1.017.275.275,0,0,1-.119-.035l-.476-.274a.117.117,0,0,1-.06-.068.05.05,0,0,1,.029-.06Z",
    transform: "translate(63.68 176.41)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_843",
    "data-name": "Caminho 843",
    d: "M112.2,332.262l-.777-.446a.122.122,0,0,1-.062-.071c-.006-.023,0-.043.031-.06l.445-.255a.187.187,0,0,1,.1-.018.315.315,0,0,1,.117.035l.777.451.548-.317a.19.19,0,0,1,.1-.017.269.269,0,0,1,.117.035l.476.276a.114.114,0,0,1,.062.066.052.052,0,0,1-.029.06l-.548.316.777.451a.12.12,0,0,1,.062.066.05.05,0,0,1-.031.06l-.445.259a.192.192,0,0,1-.1.017.269.269,0,0,1-.117-.037l-.777-.448-.543.316a.2.2,0,0,1-.1.017.3.3,0,0,1-.119-.037l-.476-.275a.112.112,0,0,1-.06-.066.05.05,0,0,1,.029-.06Z",
    transform: "translate(60.044 178.693)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_844",
    "data-name": "Caminho 844",
    d: "M181.229,377.439a5.553,5.553,0,0,1-2.738-.65l-73.706-42.557a1.949,1.949,0,0,1-1.128-1.525c.011.653.014,5.292.012,5.854a1.923,1.923,0,0,0,1.128,1.568L178.5,382.683a5.549,5.549,0,0,0,2.723.653Z",
    transform: "translate(55.891 179.392)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_845",
    "data-name": "Caminho 845",
    d: "M199.185,344.841l0-.034a1.884,1.884,0,0,1-1.127,1.612l-41.3,23.847a5.514,5.514,0,0,1-2.7.65l0,5.9a5.563,5.563,0,0,0,2.714-.651l41.3-23.848a1.923,1.923,0,0,0,1.127-1.545c.009-.574-.009-5.355-.014-5.926",
    transform: "translate(83.064 185.917)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_846",
    "data-name": "Caminho 846",
    d: "M182.19,338.744h0a1.4,1.4,0,0,0-.679.166l-37.733,21.781a.415.415,0,0,0,0,.785l15.29,8.829a1.515,1.515,0,0,0,1.359,0l21.744-12.561Z",
    transform: "translate(77.37 182.646)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_847",
    "data-name": "Caminho 847",
    d: "M184.608,347.732l-15.287-8.826a1.375,1.375,0,0,0-.679-.163l-.023,19,15.395-8.883.594-.342a.415.415,0,0,0,0-.787",
    transform: "translate(90.918 182.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_848",
    "data-name": "Caminho 848",
    d: "M197.254,348.346l-14.695-8.484a1.5,1.5,0,0,0-1.361,0L144.064,361.3l14.693,8.482a1.5,1.5,0,0,0,1.358,0Z",
    transform: "translate(77.678 183.162)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_849",
    "data-name": "Caminho 849",
    d: "M197.254,348.346l-14.695-8.484a1.5,1.5,0,0,0-1.361,0L144.064,361.3l14.693,8.482a1.5,1.5,0,0,0,1.358,0Z",
    transform: "translate(77.678 183.162)",
    fill: "#213952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_850",
    "data-name": "Caminho 850",
    d: "M166.923,343.969l1.324-.765a2.474,2.474,0,0,1,1.454-.242,3.858,3.858,0,0,1,1.636.5.394.394,0,0,1,.212.236.18.18,0,0,1-.1.211.6.6,0,0,1-.365.059.958.958,0,0,1-.406-.123,1.933,1.933,0,0,0-.817-.249,1.244,1.244,0,0,0-.727.122l-1.325.765a.36.36,0,0,0-.211.42.8.8,0,0,0,.426.474l1.125.65a.808.808,0,0,1,.426-.525l1.324-.765a2.485,2.485,0,0,1,1.455-.242,3.876,3.876,0,0,1,1.636.5l.882.509a1.642,1.642,0,0,1,.862.945.715.715,0,0,1-.42.839l-1.324.765a2.482,2.482,0,0,1-1.459.245,3.85,3.85,0,0,1-1.636-.5l-3.532-2.038a1.633,1.633,0,0,1-.86-.945.719.719,0,0,1,.425-.842m4.63,3.443a1.932,1.932,0,0,0,.817.248,1.234,1.234,0,0,0,.733-.123l1.325-.765a.359.359,0,0,0,.209-.42.816.816,0,0,0-.431-.471l-.884-.511a1.931,1.931,0,0,0-.817-.248,1.233,1.233,0,0,0-.727.122l-1.325.763a.363.363,0,0,0-.212.422.809.809,0,0,0,.428.474Z",
    transform: "translate(89.761 184.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_851",
    "data-name": "Caminho 851",
    d: "M170.1,347.486a.475.475,0,0,0-.2-.062.307.307,0,0,0-.182.029l-1.821,1.051a2.473,2.473,0,0,1-1.455.242,3.852,3.852,0,0,1-1.636-.5l-.884-.509a1.638,1.638,0,0,1-.86-.945.718.718,0,0,1,.42-.84l1.324-.763a2.472,2.472,0,0,1,1.454-.243,3.877,3.877,0,0,1,1.636.5.407.407,0,0,1,.215.239.183.183,0,0,1-.108.209.618.618,0,0,1-.36.06.986.986,0,0,1-.411-.125,1.91,1.91,0,0,0-.817-.249,1.231,1.231,0,0,0-.727.122l-1.325.763a.358.358,0,0,0-.209.42.814.814,0,0,0,.431.473l.882.509a1.926,1.926,0,0,0,.819.249,1.235,1.235,0,0,0,.727-.122L169,346.848a1.234,1.234,0,0,1,.727-.122,1.947,1.947,0,0,1,.819.249l2.207,1.274a.411.411,0,0,1,.217.236.181.181,0,0,1-.108.211l-3.311,1.91a.621.621,0,0,1-.36.062.95.95,0,0,1-.408-.123.391.391,0,0,1-.212-.236.181.181,0,0,1,.1-.208l2.815-1.625a.089.089,0,0,0,.051-.1.217.217,0,0,0-.114-.122Z",
    transform: "translate(87.907 185.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_852",
    "data-name": "Caminho 852",
    d: "M160.037,347.943l1.325-.765a2.468,2.468,0,0,1,1.453-.242,3.876,3.876,0,0,1,1.638.5l3.531,2.039a1.633,1.633,0,0,1,.86.945.714.714,0,0,1-.419.839l-1.324.765a2.475,2.475,0,0,1-1.455.242,3.868,3.868,0,0,1-1.636-.5l-3.532-2.039a1.638,1.638,0,0,1-.86-.945.716.716,0,0,1,.419-.839m2.209-.255-1.325.765a.42.42,0,0,0-.2.246l6.531,1.111-3.455-1.995a1.946,1.946,0,0,0-.819-.249,1.234,1.234,0,0,0-.727.122m3.973,3.823,1.324-.765a.4.4,0,0,0,.206-.246l-6.531-1.111,3.455,1.995a1.939,1.939,0,0,0,.819.248,1.223,1.223,0,0,0,.726-.12",
    transform: "translate(86.051 187.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_853",
    "data-name": "Caminho 853",
    d: "M156.7,349.87l1.987-1.147a.62.62,0,0,1,.36-.062.958.958,0,0,1,.408.123.408.408,0,0,1,.216.239.175.175,0,0,1-.1.209l-.662.383,4.414,2.547a1.9,1.9,0,0,0,.813.249,1.278,1.278,0,0,0,.722-.115l.011-.006a.615.615,0,0,1,.363-.062.979.979,0,0,1,.406.123.419.419,0,0,1,.217.237.176.176,0,0,1-.1.211l-.008,0,.008,0a2.473,2.473,0,0,1-1.455.243,3.87,3.87,0,0,1-1.636-.5L158.241,350l-.66.382a.619.619,0,0,1-.368.06.981.981,0,0,1-.409-.125.39.39,0,0,1-.211-.237.181.181,0,0,1,.1-.208",
    transform: "translate(84.43 187.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_854",
    "data-name": "Caminho 854",
    d: "M154.016,351.421l1.324-.765a2.466,2.466,0,0,1,1.453-.242,3.849,3.849,0,0,1,1.636.5l3.532,2.038a1.634,1.634,0,0,1,.86.945.715.715,0,0,1-.419.839l-1.324.765a2.474,2.474,0,0,1-1.455.242,3.868,3.868,0,0,1-1.636-.5l-3.532-2.04a1.633,1.633,0,0,1-.86-.945.715.715,0,0,1,.42-.839m2.206-.255-1.324.765a.414.414,0,0,0-.2.246l6.531,1.111-3.457-1.995a1.908,1.908,0,0,0-.817-.248,1.24,1.24,0,0,0-.728.12m3.974,3.823,1.324-.765a.4.4,0,0,0,.206-.246l-6.531-1.111,3.456,1.995a1.932,1.932,0,0,0,.819.249,1.233,1.233,0,0,0,.727-.122",
    transform: "translate(82.804 188.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_855",
    "data-name": "Caminho 855",
    d: "M149.708,353.656a.178.178,0,0,1,.1-.211.6.6,0,0,1,.36-.062.96.96,0,0,1,.409.126l2.449,1.413a.8.8,0,0,1,.42-.52l1.325-.765a2.466,2.466,0,0,1,1.453-.242,3.869,3.869,0,0,1,1.636.5l2.209,1.274a.419.419,0,0,1,.214.234.177.177,0,0,1-.1.211.633.633,0,0,1-.366.06.98.98,0,0,1-.409-.122l-2.207-1.274a1.932,1.932,0,0,0-.817-.249,1.24,1.24,0,0,0-.728.122l-1.324.765a.356.356,0,0,0-.209.419.811.811,0,0,0,.429.473l2.209,1.274a.419.419,0,0,1,.214.234.177.177,0,0,1-.1.211.631.631,0,0,1-.366.06.98.98,0,0,1-.409-.122l-6.18-3.569a.4.4,0,0,1-.212-.236",
    transform: "translate(80.718 190.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254",
    transform: "translate(345.365 601.304)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_253",
    "data-name": "Grupo 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    "data-name": "Grupo 252",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_856",
    "data-name": "Caminho 856",
    d: "M275.407,395.718c11.673,6.739,11.673,17.667,0,24.406s-30.6,6.739-42.271,0-11.673-17.667,0-24.406,30.6-6.74,42.272,0",
    transform: "translate(-224.382 -390.662)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_857",
    "data-name": "Caminho 857",
    d: "M235.68,418.442c-10.166-10.372-16.137-36.274-6.221-44.5H279.91c9.912,8.224,3.948,34.112-6.214,44.49-.086.1-.186.191-.279.286-.115.115-.231.231-.349.342-.286.279-.591.551-.919.817-.08.066-.162.126-.243.191-.249.2-.494.391-.767.58a14.42,14.42,0,0,1-1.314.84c-8.362,4.827-21.92,4.827-30.282,0h0a14.848,14.848,0,0,1-1.324-.847c-.252-.177-.48-.359-.713-.54-.1-.08-.2-.154-.3-.236-.317-.259-.611-.522-.887-.79-.137-.126-.269-.262-.4-.394-.075-.08-.162-.159-.234-.24",
    transform: "translate(120.984 201.625)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_858",
    "data-name": "Caminho 858",
    d: "M275.238,373.533c11.512,6.646,11.512,17.422,0,24.068s-30.174,6.646-41.686,0-11.512-17.422,0-24.067,30.174-6.648,41.686,0",
    transform: "translate(121.274 198.718)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_859",
    "data-name": "Caminho 859",
    d: "M263.033,375.911c7,4.043,7,10.6,0,14.642s-18.359,4.043-25.363,0-7-10.6,0-14.642,18.358-4.043,25.361,0",
    transform: "translate(125.317 201.052)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_860",
    "data-name": "Caminho 860",
    d: "M237.3,380.426c7-4.043,18.356-4.043,25.36,0a11.62,11.62,0,0,1,4.2,3.846,11.609,11.609,0,0,1-4.2,3.846c-7,4.044-18.358,4.044-25.36,0a11.628,11.628,0,0,1-4.2-3.846,11.639,11.639,0,0,1,4.2-3.846",
    transform: "translate(125.687 203.487)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_861",
    "data-name": "Caminho 861",
    d: "M265.133,399.047a57.51,57.51,0,0,0,9.174-12.2c4.236-7.49,7.856-17.011,5.667-18.25s-13.944,8.258-13.944,8.258a54.254,54.254,0,0,0,.939-12.786c-.376-6.672-2-12.734-3.911-13.959s-6.186,7.194-8.019,13.294-2.567,9.889-2.567,9.889-1.613-7.02-3.648-12.812c-2.223-6.332-4.241-7.764-5.8-7.139s-2.6,3.58-3.052,12.015a83.461,83.461,0,0,0,.376,12.07s-3.141-3.455-6.632-6.808c-3.831-3.68-6.539-3.676-7.634-2.974s-.329,5.915,5.6,16.651a59.939,59.939,0,0,0,11.2,14.746s8.215,5.3,22.251,0",
    transform: "translate(121.671 188.713)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_862",
    "data-name": "Caminho 862",
    d: "M265.133,399.047a57.51,57.51,0,0,0,9.174-12.2c4.236-7.49,7.856-17.011,5.667-18.25s-13.944,8.258-13.944,8.258a54.254,54.254,0,0,0,.939-12.786c-.376-6.672-2-12.734-3.911-13.959s-6.186,7.194-8.019,13.294-2.567,9.889-2.567,9.889-1.613-7.02-3.648-12.812c-2.223-6.332-4.241-7.764-5.8-7.139s-2.6,3.58-3.052,12.015a83.461,83.461,0,0,0,.376,12.07s-3.141-3.455-6.632-6.808c-3.831-3.68-6.539-3.676-7.634-2.974s-.329,5.915,5.6,16.651a59.939,59.939,0,0,0,11.2,14.746s8.215,5.3,22.251,0",
    transform: "translate(121.671 188.713)",
    fill: "#7daf80"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_257",
    "data-name": "Grupo 257",
    transform: "translate(374.142 548.383)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_256",
    "data-name": "Grupo 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_255",
    "data-name": "Grupo 255",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_863",
    "data-name": "Caminho 863",
    d: "M245.646,360.019c-1.833,6.1-2.569,9.889-2.569,9.889l1.113,5.256s1.153-11.487,2.771-18.886c-.506,1.276-.957,2.552-1.314,3.74",
    transform: "translate(-243.077 -356.281)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260",
    transform: "translate(361.554 546.697)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_864",
    "data-name": "Caminho 864",
    d: "M237.366,369.81c-1.47-5.387-1.619-14.565-1.621-14.625a59.206,59.206,0,0,0-.762,7.377,83.461,83.461,0,0,0,.376,12.07l8.1,8.492s-4.619-7.91-6.092-13.314",
    transform: "translate(-234.899 -355.185)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263",
    transform: "translate(382.593 545.226)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_262",
    "data-name": "Grupo 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_865",
    "data-name": "Caminho 865",
    d: "M248.568,379.563l5.109-4.987a54.235,54.235,0,0,0,.939-12.788,46.69,46.69,0,0,0-1.027-7.559,35.734,35.734,0,0,1-.6,12.264,114.775,114.775,0,0,1-4.422,13.069",
    transform: "translate(-248.568 -354.229)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_866",
    "data-name": "Caminho 866",
    d: "M238.18,8.546c-8.378-4.758-19.9-4.03-32.637,3.322-25.612,14.787-46.374,50.749-46.374,80.321,0,14.775,5.184,25.152,13.566,30,3.489,2.018,7.83,4.5,11.324,6.514,8.387,4.83,19.963,4.13,32.754-3.255,25.611-14.787,46.374-50.749,46.374-80.323,0-14.744-5.164-25.109-13.516-29.966-3.5-2.036-7.945-4.594-11.492-6.609",
    transform: "translate(85.822 2.986)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_867",
    "data-name": "Caminho 867",
    d: "M238.18,8.546c-8.378-4.758-19.9-4.03-32.637,3.322-25.612,14.787-46.374,50.749-46.374,80.321,0,14.775,5.184,25.152,13.566,30,3.489,2.018,7.83,4.5,11.324,6.514,8.387,4.83,19.963,4.13,32.754-3.255,25.611-14.787,46.374-50.749,46.374-80.323,0-14.744-5.164-25.109-13.516-29.966-3.5-2.036-7.945-4.594-11.492-6.609",
    transform: "translate(85.822 2.986)",
    fill: "#93cd96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_868",
    "data-name": "Caminho 868",
    d: "M192.93,93.458a25.352,25.352,0,0,1-8.478,8.4c-4.248,2.709-9.275,3.246-12.724,3.209a1.231,1.231,0,0,1-.594-.148c-.686-.408-8.064-4.645-8.232-4.738a1.158,1.158,0,0,1,.018-2c7.939-4.675,10.109-11.37,10.593-15.935l8.216,4.736Z",
    transform: "translate(87.529 44.347)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_869",
    "data-name": "Caminho 869",
    d: "M192.93,93.458a25.352,25.352,0,0,1-8.478,8.4c-4.248,2.709-9.275,3.246-12.724,3.209a1.231,1.231,0,0,1-.594-.148c-.686-.408-8.064-4.645-8.232-4.738a1.158,1.158,0,0,1,.018-2c7.939-4.675,10.109-11.37,10.593-15.935l8.216,4.736Z",
    transform: "translate(87.529 44.347)",
    fill: "#658d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_870",
    "data-name": "Caminho 870",
    d: "M166.49,96.4c0,29.574,20.762,41.561,46.374,26.774s46.374-50.749,46.374-80.323S238.476,1.292,212.864,16.079,166.49,66.827,166.49,96.4",
    transform: "translate(89.77 5.254)",
    fill: "#7daf80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_871",
    "data-name": "Caminho 871",
    d: "M178.745,82.028s2.683,13.266-10.474,21.008a1.154,1.154,0,0,0,.56,2.156c3.465.028,8.479-.506,12.741-3.209,9.014-5.715,10.136-12.472,10.136-12.472Z",
    transform: "translate(90.417 44.229)",
    fill: "#7daf80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_872",
    "data-name": "Caminho 872",
    d: "M198.343,47.234q.1,2.117.1,3.786t-.1,3.746A20.461,20.461,0,0,1,195.9,63.6a15.179,15.179,0,0,1-5.726,6.063q-3.532,2.039-5.726.55T182,64.2q-.1-1.96-.1-3.631t.1-3.9a20.335,20.335,0,0,1,2.32-8.833,15.113,15.113,0,0,1,5.852-6.135q3.731-2.154,5.85-.622t2.321,6.155M212.677,30.8a9.12,9.12,0,0,1,.731-1.51,3.054,3.054,0,0,1,1.084-1.014l5.247-3.028q.554-.321.882-.085a1.1,1.1,0,0,1,.328.937,2.417,2.417,0,0,1-.049.417,4.189,4.189,0,0,1-.152.554L195.829,91.938a9.227,9.227,0,0,1-.731,1.508,3.031,3.031,0,0,1-1.084,1.016l-5.247,3.028q-.556.323-.884.083a1.1,1.1,0,0,1-.326-.937,2.272,2.272,0,0,1,.049-.416,3.765,3.765,0,0,1,.152-.554ZM188.532,60.856a4.5,4.5,0,0,0,.426,1.924q.358.651,1.213.157a2.73,2.73,0,0,0,1.213-1.558,8.978,8.978,0,0,0,.426-2.417q.2-4.454,0-8.381a4.622,4.622,0,0,0-.426-1.926c-.242-.431-.646-.485-1.213-.155a2.711,2.711,0,0,0-1.213,1.558,8.753,8.753,0,0,0-.426,2.417q-.2,4.154,0,8.381m38.583-2.715q.1,2.117.1,3.785t-.1,3.748a20.459,20.459,0,0,1-2.446,8.829,15.168,15.168,0,0,1-5.726,6.063q-3.532,2.039-5.724.549t-2.447-6q-.1-1.962-.1-3.631t.1-3.9a20.35,20.35,0,0,1,2.32-8.833,15.123,15.123,0,0,1,5.852-6.135q3.731-2.154,5.852-.622t2.32,6.155M217.3,71.761a4.532,4.532,0,0,0,.426,1.926c.24.434.645.485,1.213.157a2.732,2.732,0,0,0,1.214-1.558,8.932,8.932,0,0,0,.425-2.418q.2-4.454,0-8.379a4.589,4.589,0,0,0-.425-1.926c-.242-.431-.646-.485-1.214-.157a2.723,2.723,0,0,0-1.213,1.558,8.841,8.841,0,0,0-.426,2.417q-.2,4.156,0,8.381",
    transform: "translate(98.078 13.513)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo267);
export default __webpack_public_path__ + "static/media/Grupo 267.054bc3064c123c34cd441495d6b1a029.svg";
export { ForwardRef as ReactComponent };